import type { NamespaceCatalog } from '@/i18n/ns';

const en = {
  projects: 'Projects',
  newProject: 'New project',
  searchProjects: 'Search projects',
  finished: 'Finished',
  people: 'People',
  skill: 'Skill',
  noBrief: 'No brief yet.',
  createProject: 'Create project',
  knowledgePages: 'Knowledge pages',
  searchPages: 'Search pages',
  formatting: 'Formatting',
  pageTitle: 'Page title',
  suggestions: 'Suggestions',
  current: 'Current',
  agent: 'Agent',
  runs: 'Runs',
  goal: 'Goal',
  instructions: 'Instructions',
  noRuns: 'No runs yet.',
  runNow: 'Run now',
  schedule: 'Schedule',
  editors: 'Editors',
  now: 'Now',
  moreFor: 'More for {name}',
  brief: 'Brief',
  version: 'Version {count}',
  noBriefLong: 'No brief yet. Say in a chat what this work is and the rules for it.',
  changeInChat: 'Change in chat',
  everyChatFollows: 'Every chat here follows',
  andReadsFirst: 'And reads first',
  file: 'File',
  knowledge: 'Knowledge',
  youLeadIt: 'You lead it.',
  personLeadsIt: '{name} leads it.',
  everyoneAtCanFind: 'Everyone at {company} can find it.',
  shareWhenOthers: 'Share it when others should work here.',
  projectAccessNote:
    'Being in the project opens nothing. Each item keeps its own access, and chats here run as the person who starts them.',
  project: 'Project',
  needsYou: 'Needs you',
  review: 'Review',
  inThisProject: 'In this project',
  deleteQuestion: 'Delete {name}?',
  deleteDescription:
    'Only the project goes away. Its chats, files and results stay with the people who own them, where they were before.',
  deleteConfirm: 'Delete {name}',
  projectDeleted: '{name} is deleted. Its chats and work stay where they were.',
  couldntDelete: "Couldn't delete {name}.",
  itemOutSuccess: '{item} is out of {project}. Nothing else changed.',
  itemOutError: "Couldn't take {item} out of {project}.",
  moveOutProject: 'Move out of the project',
  takeOutProject: 'Take out of the project',
  unavailableTitle: "This project isn't available",
  unavailableDescription:
    "It may have been deleted, or it isn't shared with you. Nothing in it changed for you.",
  allProjects: 'All projects',
  openingProject: 'Opening the project…',
  ended: 'Ended',
  ends: 'Ends',
  yesterday: 'Yesterday',
  roleLead: 'Lead',
  roleCanEdit: 'Can edit',
  roleCanUse: 'Can use',
  visibilityCompany: 'Everyone at {company}',
  visibilityMembers: 'Selected colleagues',
  visibilityPrivate: 'Only you',
  kindApp: 'App',
  kindDeck: 'Deck',
  kindSheet: 'Sheet',
  kindChart: 'Chart',
  kindDashboard: 'Dashboard',
  kindReport: 'Report',
  kindChat: 'Chat',
  kindFile: 'File',
  kindMeeting: 'Meeting',
  kindAgent: 'Agent',
  kindDocument: 'Document',
  you: 'You',
  gettingAnswer: 'Getting an answer',
  gettingAnswerOther: '{name} is getting an answer',
  addedByYou: 'added by you',
  addedByOther: 'added by {name}',
  renameProjectDescription: 'Rename it, change the brief or its end date',
  deleteProject: 'Delete project',
  add: 'Add',
  addTo: 'Add to {name}',
  addAnything:
    'Anything you can open. It keeps its own access: adding it here shares it with no one.',
  couldntAdd: "Couldn't add {name}.",
  projectReadyChat:
    "{name} is ready, and this chat is in it. Who can open the chat hasn't changed.",
  projectReadyPrivate: '{name} is ready. Only you can open it.',
  projectCreatedNotice: '{name} is created. Everything in it keeps its own access.',
  latestAnswerYou: 'You are getting an answer',
  latestAnswerOther: '{name} is getting an answer',
  inProjectMove: 'In {name}. Move this chat',
  notInProjectMove: 'Not in a project. Move this chat',
  movedTo: 'Moved to',
  accessUnchanged: "Who can open this chat hasn't changed.",
  theProject: 'the project',
  in: 'In',
  stopMakingProject: 'Stop making a new project in this chat',
  searchYourWork: 'Search your work',
  searchDocuments: 'Search documents, files and meetings…',
  yourWork: 'Your work',
  looking: 'Looking…',
  nothingMatchesChat:
    'Nothing matches. To bring in a chat, open it and use its place in the header.',
  typeToFind: 'Type to find work you can open.',
  newProjectDraft: 'New project · Draft {count} · Not created yet',
  projectCreatedOpen: 'Project created · Open it',
  aNewProject: 'A new project',
  draftIntro:
    'Say in the chat what the work is. Poneva drafts the project here, with what to bring in and who to share it with. Nothing is created until you say so.',
  draft: 'Draft',
  projectCreatedAccess: 'Created. Everything in it keeps its own access.',
  changeInChatDraft: 'Change anything by saying so in the chat.',
  chatOwnerCreate: 'Only the person who owns this chat can create it.',
  open: 'Open',
  creating: 'Creating…',
  cannotOpenDraft:
    "{people} can't open {title}, so their chats here would answer without it. Say in the chat whether to ask its owner to share it, or to leave it out.",
  bringsIn: 'Brings in {count}',
  thisChat: 'This chat',
  takenOutDraft: 'Taken out in draft {count}',
  nothingYet: 'Nothing yet. Name what belongs here in the chat.',
  leftOut: 'Left out: {items}.',
  whoCanUse: 'Who can use it',
  youLead: 'You, lead',
  beingInProject: 'Being in the project opens nothing. Each item keeps its own access.',
  onlyYouUntilShare: 'It stays Only you until you share it.',
  colour: 'Colour',
  sand: 'Sand',
  green: 'Green',
  blue: 'Blue',
  grey: 'Grey',
  firstProject: 'Start your first project',
  firstProjectDescription:
    'Name it, and every chat you start in it reads the same brief. Bring in work you already have, and share it when others should work there.',
  loadingProjects: 'Loading projects…',
  thisChatMoves: "This chat moves into the project. Who can open it doesn't change.",
  whatIsWork: 'What is the work?',
  optional: 'Optional',
  writeFromChat: 'Write it from this chat',
  briefPlaceholder: 'What it is for, the rules to follow, the dates that matter.',
  briefDraftHelp:
    'Every chat in the project reads this first. Write it from this chat asks Poneva to draft it beside the chat; you still choose Create.',
  briefLaterHelp:
    'Every chat in the project reads this first. Change it later by asking in any chat there.',
  sendClearFirst:
    'Send or clear your unsent message and attachments first to write the brief from this chat.',
  createProjectError: "Couldn't create the project. Try again.",
  onlyYouUntil: 'Only you, until you share it',
  whereChat: 'Where this chat lives',
  whereChatHelp: 'A chat lives in one project at a time. Moving it never changes who can open it.',
  searchCreateProject: 'Search or create a project',
  noProject: 'No project',
  inCompanyChats: 'In your chats at {company}',
  newProjectWithChat: 'New project with this chat',
  newProjectNamedWithChat: 'New project “{name}” with this chat',
  makingProject: 'Making a new project',
  moveToProject: 'Move this chat to {name}',
  chatInProject: 'This chat is in {name}.',
  looksLikeWork: 'This looks like {name} work. Move it there?',
  accessBriefNext:
    "Who can open it hasn't changed. It reads the project's brief from your next message.",
  moveFailed: "Couldn't move it. Try again, or use its place in the header.",
  accessBriefNextTypographic:
    'Who can open it doesn’t change. It reads the project’s brief from your next message.',
  openProject: 'Open project',
  move: 'Move',
  movedOut: "Moved out of its project. Who can open it hasn't changed.",
  chatLivesHere: "This chat lives here now. Who can open it hasn't changed.",
  addedTo: 'Added {item} to {project}',
  addedAccess: 'It keeps its own access. Adding it here shares it with no one.',
  removedOut:
    "{item} is out of {project}. It stays where it lives, and who can open it hasn't changed.",
  itIs: 'It is',
  couldntMoveChat: "Couldn't move this chat.",
  sharingCheckFailed:
    "Couldn't check who can open the reads-first items. Review their access before sharing this project.",
  cannotOpenShare: "{people} can't open {title}.",
  readsFirstShare:
    "Every chat in this project reads it first, so their chats here answer without it. Sharing the project doesn't change that.",
  openToShare: 'Open it to share',
  sharingSaved: 'Sharing saved. {name} is no longer shared with you.',
  onlyOwnerPrivate: 'Only {name} can make it private',
  sharingSavedUnread: "Sharing saved. {name} couldn't be read again just now.",
  formerColleague: 'A former colleague',
  madeInChatHere: 'made in a chat here',
  latestStarted: '{name} started {title}',
  latestStartedYou: 'You started {title}',
  latestContinued: '{name} continued {title}',
  latestContinuedYou: 'You continued {title}',
  latestMade: '{name} made {title}',
  latestMadeYou: 'You made {title}',
  latestAdded: '{name} added {title}',
  latestAddedYou: 'You added {title}',
  projectChipLives:
    'This chat lives in {name} and reads its brief. Move it from the first part of the header.',
  addExistingWork: 'Add work you already have',
  nameLabel: 'Name',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} item',
  itemsMany: '{count} items',
  itemsAllStillHere: '{items}, all still here',
  projectsOverviewDescription:
    'One place for each piece of work. Putting something in a project never changes who can open it.',
  noProjectMatchesHint: 'No project matches. Try a word from its name or brief.',
  aboutProject: 'About this project',
  aboutShort: 'About',
  workingIn: 'Working in {name}',
  noBriefHome:
    'No brief yet. Say in a chat here what the work is; every chat in the project reads it first.',
  tabAll: 'All',
  tabChats: 'Chats',
  tabResults: 'Results',
  tabFiles: 'Files',
  emptyChats: 'No chats here yet. Start one above.',
  emptyResults: 'Nothing made here yet. What you make in a chat here lands here.',
  emptyFiles: 'No files here yet. Files you add in a chat here land here.',
  showTabs: 'Show',
  newestShown: 'The newest {shown} of {count} are shown here.',
  nothingHereYet: 'Nothing here yet.',
  homeEmptyHelp:
    'Chats you start above land here, and so do the files you add and the results you make in them.',
  shareWithPeopleDoingIt: 'Share with the people doing it',
  briefWrittenBy: '{version} · written by {name}, {when}',
  briefChangedBy: '{version} · changed by {name}, {when}',
  personWorksInIt: '{people} works in it.',
  peopleWorkInIt: '{people} work in it.',
  aboutUnavailable:
    "This project isn't available. It may have been deleted, or it isn't shared with you.",
  landedIn: 'In {name} · {access}',
  landedOnlyYou: 'Only you can open it',
  youWorkInIt: 'You work in it.',
  youAndPeopleWorkInIt: 'You and {people} work in it.',
  landedCompanyCanOpen: 'Everyone at {company} can open it',
  landedMembersCanOpen: 'Selected colleagues can open it',
  briefWrittenByYou: '{version} · written by you, {when}',
  briefChangedByYou: '{version} · changed by you, {when}',
  briefWrittenByFormer: '{version} · written by a former colleague, {when}',
  briefChangedByFormer: '{version} · changed by a former colleague, {when}',
  addedByFormer: 'added by a former colleague',
  formerColleagueLeadsIt: 'A former colleague leads it.',
  projectLoadFailed: "This project couldn't be loaded.",
  personCannotOpenWithout: "{people} can't open this, so their chats here answer without it.",
  peopleCannotOpenWithout: "{people} can't open this, so their chats here answer without it.",
} as const;
type Copy = Record<keyof typeof en, string>;
const bg: Copy = {
  projects: 'Проекти',
  newProject: 'Нов проект',
  searchProjects: 'Търсене на проекти',
  finished: 'Завършени',
  people: 'Хора',
  skill: 'Умение',
  noBrief: 'Все още няма описание.',
  createProject: 'Създай проект',
  knowledgePages: 'Страници със знания',
  searchPages: 'Търсене на страници',
  formatting: 'Форматиране',
  pageTitle: 'Заглавие на страницата',
  suggestions: 'Предложения',
  current: 'Текущо',
  agent: 'Агент',
  runs: 'Изпълнения',
  goal: 'Цел',
  instructions: 'Инструкции',
  noRuns: 'Все още няма изпълнения.',
  runNow: 'Стартирай сега',
  schedule: 'График',
  editors: 'Редактори',
  now: 'Сега',
  moreFor: 'Още за {name}',
  brief: 'Кратко описание',
  version: 'Версия {count}',
  noBriefLong:
    'Все още няма кратко описание. Кажете в чат какво представлява тази работа и какви са правилата за нея.',
  changeInChat: 'Промяна в чата',
  everyChatFollows: 'Всеки чат тук следва',
  andReadsFirst: 'И първо прочита',
  file: 'Файл',
  knowledge: 'Знания',
  youLeadIt: 'Вие го ръководите.',
  personLeadsIt: '{name} го ръководи.',
  everyoneAtCanFind: 'Всеки в {company} може да го намери.',
  shareWhenOthers: 'Споделете го, когато други трябва да работят тук.',
  projectAccessNote:
    'Самото участие в проекта не дава достъп до нищо. Всеки елемент запазва собствения си достъп, а чатовете тук се изпълняват от името на човека, който ги започва.',
  project: 'Проект',
  needsYou: 'Изисква вашето внимание',
  review: 'Преглед',
  inThisProject: 'В този проект',
  deleteQuestion: 'Да се изтрие ли {name}?',
  deleteDescription:
    'Ще бъде премахнат само проектът. Чатовете, файловете и резултатите му ще останат при хората, които ги притежават, на предишните им места.',
  deleteConfirm: 'Изтриване на {name}',
  projectDeleted: '{name} е изтрит. Чатовете и работата му остават там, където са били.',
  couldntDelete: '{name} не можа да бъде изтрит.',
  itemOutSuccess: '{item} вече не е в {project}. Нищо друго не се промени.',
  itemOutError: '{item} не можа да бъде изваден от {project}.',
  moveOutProject: 'Преместване извън проекта',
  takeOutProject: 'Изваждане от проекта',
  unavailableTitle: 'Този проект не е наличен',
  unavailableDescription:
    'Възможно е да е изтрит или да не е споделен с вас. Нищо в него не се е променило за вас.',
  allProjects: 'Всички проекти',
  openingProject: 'Проектът се отваря…',
  ended: 'Приключил',
  ends: 'Приключва',
  yesterday: 'Вчера',
  roleLead: 'Ръководител',
  roleCanEdit: 'Може да редактира',
  roleCanUse: 'Може да използва',
  visibilityCompany: 'Всеки в {company}',
  visibilityMembers: 'Избрани колеги',
  visibilityPrivate: 'Само вие',
  kindApp: 'Приложение',
  kindDeck: 'Презентация',
  kindSheet: 'Таблица',
  kindChart: 'Диаграма',
  kindDashboard: 'Табло',
  kindReport: 'Отчет',
  kindChat: 'Чат',
  kindFile: 'Файл',
  kindMeeting: 'Среща',
  kindAgent: 'Агент',
  kindDocument: 'Документ',
  you: 'Вие',
  gettingAnswer: 'Получаване на отговор',
  gettingAnswerOther: '{name} получава отговор',
  addedByYou: 'добавено от вас',
  addedByOther: 'добавено от {name}',
  renameProjectDescription: 'Преименувайте го, променете краткото описание или крайната му дата',
  deleteProject: 'Изтриване на проекта',
  openToShare: 'Отворете го, за да го споделите',
  sharingSaved: 'Споделянето е запазено. {name} вече не се споделя с вас.',
  onlyOwnerPrivate: 'Само {name} може да го направи частно',
  add: 'Добавяне',
  addTo: 'Добавяне към {name}',
  addAnything:
    'Всичко, което можете да отворите. То запазва собствения си достъп: добавянето му тук не го споделя с никого.',
  couldntAdd: 'Неуспешно добавяне на {name}.',
  projectReadyChat:
    '{name} е готов и този чат е в него. Кой може да отваря чата не се е променило.',
  projectReadyPrivate: '{name} е готов. Само вие можете да го отваряте.',
  projectCreatedNotice: '{name} е създаден. Всичко в него запазва собствените си права за достъп.',
  latestAnswerYou: 'Получавате отговор',
  latestAnswerOther: '{name} получава отговор',
  inProjectMove: 'В {name}. Преместете този чат',
  notInProjectMove: 'Не е в проект. Преместете този чат',
  movedTo: 'Преместено в',
  accessUnchanged: 'Няма промяна в това кой може да отваря този чат.',
  theProject: 'проекта',
  in: 'В',
  stopMakingProject: 'Спрете създаването на нов проект в този чат',
  searchYourWork: 'Търсене в работата ви',
  searchDocuments: 'Търсене на документи, файлове и срещи…',
  yourWork: 'Вашата работа',
  looking: 'Търсене…',
  nothingMatchesChat:
    'Няма съвпадения. За да добавите чат, отворете го и използвайте бутона му в горната лента.',
  typeToFind: 'Въведете, за да намерите работа, която можете да отворите.',
  newProjectDraft: 'Нов проект · Чернова {count} · Все още не е създаден',
  projectCreatedOpen: 'Проектът е създаден · Отваряне',
  aNewProject: 'Нов проект',
  draftIntro:
    'Кажете в чата каква е работата. Poneva ще подготви проекта тук, заедно с това какво да добавите и с кого да го споделите. Нищо няма да бъде създадено, докато не го потвърдите.',
  draft: 'Чернова',
  projectCreatedAccess: 'Създадено. Всичко в него запазва собствения си достъп.',
  changeInChatDraft: 'Променете каквото искате, като го кажете в чата.',
  chatOwnerCreate: 'Само човекът, който притежава този чат, може да го създаде.',
  open: 'Отваряне',
  creating: 'Създаване…',
  cannotOpenDraft:
    '{people} не могат да отворят {title}, затова чатовете им тук ще отговарят без него. Кажете в чата дали да помолите собственика му да го сподели, или да го изключите.',
  bringsIn: 'Добавя {count}',
  thisChat: 'Този чат',
  takenOutDraft: 'Премахнато от чернова {count}',
  nothingYet: 'Все още няма нищо. Кажете в чата какво трябва да бъде тук.',
  leftOut: 'Изключено: {items}.',
  whoCanUse: 'Кой може да го използва',
  youLead: 'Вие, ръководител',
  beingInProject:
    'Присъствието в проекта не отваря нищо. Всеки елемент запазва собствения си достъп.',
  onlyYouUntilShare: 'Остава видимо само за вас, докато не го споделите.',
  colour: 'Цвят',
  sand: 'Пясъчен',
  green: 'Зелен',
  blue: 'Син',
  grey: 'Сив',
  firstProject: 'Започнете първия си проект',
  firstProjectDescription:
    'Дайте му име и всеки чат, който започнете в него, ще прочита същата кратка информация. Добавете вече налична работа и я споделете, когато други трябва да работят там.',
  loadingProjects: 'Зареждане на проекти…',
  thisChatMoves: 'Този чат ще бъде преместен в проекта. Кой може да го отвори няма да се промени.',
  whatIsWork: 'Каква е работата?',
  optional: 'Незадължително',
  writeFromChat: 'Напишете го от този чат',
  briefPlaceholder: 'За какво е, какви правила да следва и кои дати са важни.',
  briefDraftHelp:
    'Всеки чат в проекта първо прочита това. Опцията „Напишете го от този чат“ иска от Poneva да го подготви до чата; вие все пак избирате „Създаване“.',
  briefLaterHelp:
    'Всеки чат в проекта първо прочита това. По-късно го променете, като попитате в който и да е чат там.',
  sendClearFirst:
    'Първо изпратете или изчистете неизпратеното съобщение и прикачените файлове, за да напишете кратката информация от този чат.',
  createProjectError: 'Проектът не можа да бъде създаден. Опитайте отново.',
  onlyYouUntil: 'Само за вас, докато не го споделите',
  whereChat: 'Къде се намира този чат',
  whereChatHelp:
    'Чатът може да се намира само в един проект едновременно. Преместването му никога не променя кой може да го отвори.',
  searchCreateProject: 'Търсене или създаване на проект',
  noProject: 'Без проект',
  inCompanyChats: 'В чатовете ви в {company}',
  newProjectWithChat: 'Нов проект с този чат',
  newProjectNamedWithChat: 'Нов проект „{name}“ с този чат',
  makingProject: 'Създаване на нов проект',
  moveToProject: 'Преместване на този чат в {name}',
  chatInProject: 'Този чат е в {name}.',
  looksLikeWork: 'Това изглежда като работа за {name}. Да го преместим там?',
  accessBriefNext:
    'Кой може да го отвори не се е променил. Чатът ще прочете кратката информация на проекта от следващото ви съобщение.',
  moveFailed:
    'Не можа да бъде преместен. Опитайте отново или използвайте бутона му в горната лента.',
  accessBriefNextTypographic:
    'Кой може да го отвори не се променя. Чатът ще прочете кратката информация на проекта от следващото ви съобщение.',
  openProject: 'Отваряне на проекта',
  move: 'Преместване',
  movedOut: 'Преместен извън проекта си. Кой може да го отвори не се е променил.',
  chatLivesHere: 'Този чат вече е тук. Кой може да го отвори не се е променил.',
  addedTo: '{item} е добавен към {project}',
  addedAccess: 'Той запазва собствения си достъп. Добавянето му тук не го споделя с никого.',
  removedOut:
    '{item} е премахнат от {project}. Остава там, където се намира, и кой може да го отвори не се е променил.',
  itIs: 'Това е',
  couldntMoveChat: 'Този чат не можа да бъде преместен.',
  sharingCheckFailed:
    'Не може да се провери кой може да отвори елементите, които се прочитат първо. Прегледайте достъпа до тях, преди да споделите този проект.',
  cannotOpenShare: '{people} не могат да отворят {title}.',
  readsFirstShare:
    'Всеки чат в този проект първо го прочита, затова чатовете им тук ще отговарят без него. Споделянето на проекта не променя това.',
  sharingSavedUnread: 'Споделянето е запазено. {name} не можа да бъде прочетен отново в момента.',
  formerColleague: 'Бивш колега',
  madeInChatHere: 'създадено в чат тук',
  latestStarted: '{name} започна {title}',
  latestStartedYou: 'Започнахте {title}',
  latestContinued: '{name} продължи {title}',
  latestContinuedYou: 'Продължихте {title}',
  latestMade: '{name} създаде {title}',
  latestMadeYou: 'Създадохте {title}',
  latestAdded: '{name} добави {title}',
  latestAddedYou: 'Добавихте {title}',
  projectChipLives:
    'Този чат е в проекта {name} и чете неговото кратко описание. Преместете го от първата част на заглавната лента.',
  addExistingWork: 'Добавете работа, която вече имате',
  nameLabel: 'Име',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} елемент',
  itemsMany: 'Елементи: {count}',
  itemsAllStillHere: '{items}, всичко е все още тук',
  projectsOverviewDescription:
    'Едно място за всяка работа. Добавянето на нещо към проект никога не променя кой може да го отвори.',
  noProjectMatchesHint: 'Няма съвпадащ проект. Опитайте с дума от името или краткото описание.',
  aboutProject: 'За този проект',
  aboutShort: 'За проекта',
  workingIn: 'Работите в {name}',
  noBriefHome:
    'Още няма кратко описание. Кажете в чат тук каква е работата; всеки чат в проекта го чете първо.',
  tabAll: 'Всички',
  tabChats: 'Чатове',
  tabResults: 'Резултати',
  tabFiles: 'Файлове',
  emptyChats: 'Тук още няма чатове. Започнете един по-горе.',
  emptyResults: 'Тук още нищо не е създадено. Каквото създадете в чат тук, ще се появи тук.',
  emptyFiles: 'Тук още няма файлове. Файловете, добавени в чат тук, ще се появят тук.',
  showTabs: 'Покажи',
  newestShown: 'Тук са показани най-новите {shown} от {count}.',
  nothingHereYet: 'Тук още няма нищо.',
  homeEmptyHelp:
    'Чатовете, които започнете по-горе, се появяват тук, както и файловете, които добавяте, и резултатите, които създавате в тях.',
  shareWithPeopleDoingIt: 'Споделете с хората, които работят по това',
  briefWrittenBy: '{version} · написано от {name}, {when}',
  briefChangedBy: '{version} · променено от {name}, {when}',
  personWorksInIt: '{people} работи по него.',
  peopleWorkInIt: '{people} работят по него.',
  aboutUnavailable: 'Този проект не е наличен. Възможно е да е изтрит или да не е споделен с вас.',
  landedIn: 'В {name} · {access}',
  landedOnlyYou: 'Само вие можете да го отворите',
  youWorkInIt: 'Вие работите по него.',
  youAndPeopleWorkInIt: 'Вие и {people} работите по него.',
  landedCompanyCanOpen: 'Всеки в {company} може да го отвори',
  landedMembersCanOpen: 'Избрани колеги могат да го отворят',
  briefWrittenByYou: '{version} · написано от вас, {when}',
  briefChangedByYou: '{version} · променено от вас, {when}',
  briefWrittenByFormer: '{version} · написано от бивш колега, {when}',
  briefChangedByFormer: '{version} · променено от бивш колега, {when}',
  addedByFormer: 'добавено от бивш колега',
  formerColleagueLeadsIt: 'Бивш колега го ръководи.',
  projectLoadFailed: 'Този проект не можа да бъде зареден.',
  personCannotOpenWithout:
    '{people} не може да отвори това, затова чатовете на този човек тук отговарят без него.',
  peopleCannotOpenWithout:
    '{people} не могат да отворят това, затова чатовете им тук отговарят без него.',
};
const cs: Copy = {
  projects: 'Projekty',
  newProject: 'Nový projekt',
  searchProjects: 'Hledat projekty',
  finished: 'Dokončené',
  people: 'Lidé',
  skill: 'Dovednost',
  noBrief: 'Zatím žádné zadání.',
  createProject: 'Vytvořit projekt',
  knowledgePages: 'Stránky znalostí',
  searchPages: 'Hledat stránky',
  formatting: 'Formátování',
  pageTitle: 'Název stránky',
  suggestions: 'Návrhy',
  current: 'Aktuální',
  agent: 'Agent',
  runs: 'Spuštění',
  goal: 'Cíl',
  instructions: 'Pokyny',
  noRuns: 'Zatím žádná spuštění.',
  runNow: 'Spustit hned',
  schedule: 'Plán',
  editors: 'Editoři',
  now: 'Teď',
  moreFor: 'Více pro {name}',
  brief: 'Zadání',
  version: 'Verze {count}',
  noBriefLong:
    'Zatím žádné zadání. Řekněte v chatu, o čem tato práce je a jaká pro ni platí pravidla.',
  changeInChat: 'Změnit v chatu',
  everyChatFollows: 'Každý chat zde se řídí',
  andReadsFirst: 'A nejprve čte',
  file: 'Soubor',
  knowledge: 'Znalosti',
  youLeadIt: 'Vedete ho.',
  personLeadsIt: 'Vede ho {name}.',
  everyoneAtCanFind: 'Najdou ho všichni ve {company}.',
  shareWhenOthers: 'Sdílejte ho, pokud v něm mají pracovat i ostatní.',
  projectAccessNote:
    'Členství v projektu nic neotevírá. Každá položka má vlastní přístup a chaty zde fungují jako osoba, která je zahájí.',
  project: 'Projekt',
  needsYou: 'Vyžaduje vaši pozornost',
  review: 'Kontrola',
  inThisProject: 'V tomto projektu',
  deleteQuestion: 'Smazat {name}?',
  deleteDescription:
    'Zmizí pouze projekt. Jeho chaty, soubory a výsledky zůstanou lidem, kteří je vlastní, na původním místě.',
  deleteConfirm: 'Smazat {name}',
  projectDeleted: '{name} byl smazán. Jeho chaty a práce zůstávají na svém místě.',
  couldntDelete: '{name} se nepodařilo smazat.',
  itemOutSuccess: '{item} byl odebrán z projektu {project}. Nic dalšího se nezměnilo.',
  itemOutError: '{item} se nepodařilo odebrat z projektu {project}.',
  moveOutProject: 'Přesunout mimo projekt',
  takeOutProject: 'Odebrat z projektu',
  unavailableTitle: 'Tento projekt není dostupný',
  unavailableDescription:
    'Možná byl smazán nebo s vámi není sdílen. Nic v něm se pro vás nezměnilo.',
  allProjects: 'Všechny projekty',
  openingProject: 'Otevírání projektu…',
  ended: 'Skončil',
  ends: 'Končí',
  yesterday: 'Včera',
  roleLead: 'Vedoucí',
  roleCanEdit: 'Může upravovat',
  roleCanUse: 'Může používat',
  visibilityCompany: 'Všichni ve {company}',
  visibilityMembers: 'Vybraní kolegové',
  visibilityPrivate: 'Pouze vy',
  kindApp: 'Aplikace',
  kindDeck: 'Prezentace',
  kindSheet: 'Tabulka',
  kindChart: 'Graf',
  kindDashboard: 'Nástěnka',
  kindReport: 'Přehled',
  kindChat: 'Chat',
  kindFile: 'Soubor',
  kindMeeting: 'Schůzka',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Vy',
  gettingAnswer: 'Získávání odpovědi',
  gettingAnswerOther: '{name} získává odpověď',
  addedByYou: 'přidali jste',
  addedByOther: 'přidal(a) {name}',
  renameProjectDescription: 'Přejmenujte ho, změňte zadání nebo datum ukončení',
  deleteProject: 'Smazat projekt',
  openToShare: 'Otevřete ho a sdílejte ho',
  sharingSaved: 'Sdílení bylo uloženo. {name} s vámi už není sdíleno.',
  onlyOwnerPrivate: 'Nastavit ho jako soukromý může pouze {name}',
  add: 'Přidat',
  addTo: 'Přidat do {name}',
  addAnything:
    'Cokoli, co můžete otevřít. Zachovává si vlastní přístupová oprávnění: jeho přidáním sem ho s nikým nesdílíte.',
  couldntAdd: 'Nepodařilo se přidat {name}.',
  projectReadyChat:
    '{name} je připravený a tento chat je v něm. Kdo může chat otevřít, se nezměnil.',
  projectReadyPrivate: '{name} je připravený. Pouze vy ho můžete otevřít.',
  projectCreatedNotice: '{name} je vytvořený. Vše v něm si zachovává vlastní přístup.',
  latestAnswerYou: 'Získáváte odpověď',
  latestAnswerOther: '{name} získává odpověď',
  inProjectMove: 'V projektu {name}. Přesunout tento chat',
  notInProjectMove: 'Není v projektu. Přesunout tento chat',
  movedTo: 'Přesunuto do',
  accessUnchanged: 'Kdo může tento chat otevřít, se nezměnil.',
  theProject: 'projektu',
  in: 'V',
  stopMakingProject: 'Přestat v tomto chatu vytvářet nový projekt',
  searchYourWork: 'Hledat ve své práci',
  searchDocuments: 'Hledat v dokumentech, souborech a schůzkách…',
  yourWork: 'Vaše práce',
  looking: 'Hledání…',
  nothingMatchesChat:
    'Nic neodpovídá. Chat přidáte tak, že ho otevřete a použijete jeho umístění v záhlaví.',
  typeToFind: 'Začněte psát a najděte práci, kterou můžete otevřít.',
  newProjectDraft: 'Nový projekt · Koncept {count} · Zatím nevytvořen',
  projectCreatedOpen: 'Projekt vytvořen · Otevřít',
  aNewProject: 'Nový projekt',
  draftIntro:
    'Napište do chatu, čeho se práce týká. Poneva zde připraví projekt včetně toho, co do něj přidat a s kým ho sdílet. Nic se nevytvoří, dokud to nepotvrdíte.',
  draft: 'Koncept',
  projectCreatedAccess: 'Vytvořeno. Vše v projektu si zachovává vlastní přístupová oprávnění.',
  changeInChatDraft: 'Cokoli změňte tak, že to napíšete do chatu.',
  chatOwnerCreate: 'Projekt může vytvořit pouze vlastník tohoto chatu.',
  open: 'Otevřít',
  creating: 'Vytváření…',
  cannotOpenDraft:
    '{people} nemohou otevřít {title}, takže jejich chaty zde by odpovídaly bez něj. Napište do chatu, zda požádat jeho vlastníka o sdílení, nebo ho vynechat.',
  bringsIn: 'Přidává {count}',
  thisChat: 'Tento chat',
  takenOutDraft: 'Vyřazeno z konceptu {count}',
  nothingYet: 'Zatím nic. Napište do chatu, co sem patří.',
  leftOut: 'Vynecháno: {items}.',
  whoCanUse: 'Kdo to může používat',
  youLead: 'Vy, vedoucí',
  beingInProject:
    'Umístění v projektu samo o sobě nic neotevírá. Každá položka si zachovává vlastní přístupová oprávnění.',
  onlyYouUntilShare: 'Dokud ho nesdílíte, je dostupný jen vám.',
  colour: 'Barva',
  sand: 'Písková',
  green: 'Zelená',
  blue: 'Modrá',
  grey: 'Šedá',
  firstProject: 'Začněte svůj první projekt',
  firstProjectDescription:
    'Pojmenujte ho a každý chat, který v něm začnete, bude vycházet ze stejného zadání. Přidejte práci, kterou už máte, a sdílejte ji, až v ní budou pracovat další.',
  loadingProjects: 'Načítání projektů…',
  thisChatMoves: 'Tento chat se přesune do projektu. To, kdo ho může otevřít, se nezmění.',
  whatIsWork: 'Čeho se práce týká?',
  optional: 'Volitelné',
  writeFromChat: 'Napsat z tohoto chatu',
  briefPlaceholder: 'K čemu slouží, jaká pravidla dodržovat a na jakých datech záleží.',
  briefDraftHelp:
    'Každý chat v projektu toto přečte jako první. Volba Napsat z tohoto chatu požádá Ponevu, aby zadání připravila vedle chatu; vytvoření stále potvrdíte vy.',
  briefLaterHelp:
    'Každý chat v projektu toto přečte jako první. Později to změňte požadavkem v libovolném chatu projektu.',
  sendClearFirst:
    'Nejprve odešlete nebo vymažte neodeslanou zprávu a přílohy, abyste mohli zadání napsat z tohoto chatu.',
  createProjectError: 'Projekt se nepodařilo vytvořit. Zkuste to znovu.',
  onlyYouUntil: 'Jen vy, dokud ho nesdílíte',
  whereChat: 'Kde tento chat je',
  whereChatHelp:
    'Chat může být vždy jen v jednom projektu. Jeho přesun nikdy nemění, kdo ho může otevřít.',
  searchCreateProject: 'Hledat projekt nebo vytvořit nový',
  noProject: 'Žádný projekt',
  inCompanyChats: 'Ve vašich chatech v {company}',
  newProjectWithChat: 'Nový projekt s tímto chatem',
  newProjectNamedWithChat: 'Nový projekt „{name}“ s tímto chatem',
  makingProject: 'Vytváření nového projektu',
  moveToProject: 'Přesunout tento chat do projektu {name}',
  chatInProject: 'Tento chat je v projektu {name}.',
  looksLikeWork: 'Vypadá to jako práce pro {name}. Přesunout ho tam?',
  accessBriefNext:
    'To, kdo ho může otevřít, se nezměnilo. Od vaší další zprávy bude vycházet ze zadání projektu.',
  moveFailed: 'Přesun se nezdařil. Zkuste to znovu nebo použijte jeho umístění v záhlaví.',
  accessBriefNextTypographic:
    'To, kdo ho může otevřít, se nezmění. Od vaší další zprávy bude vycházet ze zadání projektu.',
  openProject: 'Otevřít projekt',
  move: 'Přesunout',
  movedOut: 'Přesunuto mimo projekt. To, kdo to může otevřít, se nezměnilo.',
  chatLivesHere: 'Tento chat je nyní zde. To, kdo ho může otevřít, se nezměnilo.',
  addedTo: 'Přidáno: {item} do {project}',
  addedAccess: 'Zachovává si vlastní přístupová oprávnění. Jeho přidáním sem ho s nikým nesdílíte.',
  removedOut:
    '{item} je mimo {project}. Zůstává tam, kde je, a to, kdo ho může otevřít, se nezměnilo.',
  itIs: 'Je to',
  couldntMoveChat: 'Tento chat se nepodařilo přesunout.',
  sharingCheckFailed:
    'Nepodařilo se ověřit, kdo může otevřít položky čtené jako první. Před sdílením tohoto projektu zkontrolujte jejich přístupová oprávnění.',
  cannotOpenShare: '{people} nemohou otevřít {title}.',
  readsFirstShare:
    'Každý chat v tomto projektu to přečte jako první, takže jeho chaty zde by odpovídaly bez něj. Sdílení projektu to nemění.',
  sharingSavedUnread: 'Sdílení bylo uloženo. {name} se právě nepodařilo znovu načíst.',
  formerColleague: 'Dřívější kolega',
  madeInChatHere: 'vytvořeno v chatu zde',
  latestStarted: '{name} zahájil(a) {title}',
  latestStartedYou: 'Zahájili jste {title}',
  latestContinued: '{name} pokračoval(a) v {title}',
  latestContinuedYou: 'Pokračovali jste v {title}',
  latestMade: '{name} vytvořil(a) {title}',
  latestMadeYou: 'Vytvořili jste {title}',
  latestAdded: '{name} přidal(a) {title}',
  latestAddedYou: 'Přidali jste {title}',
  projectChipLives:
    'Tento chat patří do projektu {name} a čte jeho zadání. Přesunete ho z první části záhlaví.',
  addExistingWork: 'Přidejte práci, kterou už máte',
  nameLabel: 'Název',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} položka',
  itemsMany: 'Položky: {count}',
  itemsAllStillHere: '{items}, vše je stále tady',
  projectsOverviewDescription:
    'Jedno místo pro každou práci. Přidáním něčeho do projektu se nikdy nezmění, kdo to může otevřít.',
  noProjectMatchesHint: 'Žádný projekt neodpovídá. Zkuste slovo z názvu nebo zadání.',
  aboutProject: 'O tomto projektu',
  aboutShort: 'O projektu',
  workingIn: 'Pracujete v projektu {name}',
  noBriefHome:
    'Zatím žádné zadání. Napište zde v chatu, o jakou práci jde; každý chat v projektu ho čte jako první.',
  tabAll: 'Vše',
  tabChats: 'Chaty',
  tabResults: 'Výsledky',
  tabFiles: 'Soubory',
  emptyChats: 'Zatím zde nejsou žádné chaty. Jeden zahajte výše.',
  emptyResults: 'Zatím zde nic nevzniklo. Co vytvoříte v chatu zde, objeví se tady.',
  emptyFiles: 'Zatím zde nejsou žádné soubory. Soubory přidané v chatu zde se objeví tady.',
  showTabs: 'Zobrazit',
  newestShown: 'Zobrazuje se {shown} nejnovějších z {count}.',
  nothingHereYet: 'Zatím zde nic není.',
  homeEmptyHelp:
    'Chaty, které zahájíte výše, se objeví zde, stejně jako soubory, které přidáte, a výsledky, které v nich vytvoříte.',
  shareWithPeopleDoingIt: 'Sdílet s lidmi, kteří na tom pracují',
  briefWrittenBy: '{version} · autor: {name}, {when}',
  briefChangedBy: '{version} · změna: {name}, {when}',
  personWorksInIt: '{people} v něm pracuje.',
  peopleWorkInIt: '{people} v něm pracují.',
  aboutUnavailable: 'Tento projekt není dostupný. Možná byl smazán nebo s vámi není sdílen.',
  landedIn: 'V projektu {name} · {access}',
  landedOnlyYou: 'Otevřít ho můžete jen vy',
  youWorkInIt: 'Pracujete v něm.',
  youAndPeopleWorkInIt: 'Vy a {people} v něm pracujete.',
  landedCompanyCanOpen: 'Všichni ve {company} to mohou otevřít',
  landedMembersCanOpen: 'Vybraní kolegové to mohou otevřít',
  briefWrittenByYou: '{version} · autor: vy, {when}',
  briefChangedByYou: '{version} · změna: vy, {when}',
  briefWrittenByFormer: '{version} · autor: dřívější kolega, {when}',
  briefChangedByFormer: '{version} · změna: dřívější kolega, {when}',
  addedByFormer: 'přidal dřívější kolega',
  formerColleagueLeadsIt: 'Vede ho dřívější kolega.',
  projectLoadFailed: 'Tento projekt se nepodařilo načíst.',
  personCannotOpenWithout:
    '{people} to nemůže otevřít, takže chaty této osoby zde fungují bez toho.',
  peopleCannotOpenWithout: '{people} to nemohou otevřít, takže jejich chaty zde fungují bez toho.',
};
const da: Copy = {
  projects: 'Projekter',
  newProject: 'Nyt projekt',
  searchProjects: 'Søg i projekter',
  finished: 'Afsluttede',
  people: 'Personer',
  skill: 'Færdighed',
  noBrief: 'Ingen brief endnu.',
  createProject: 'Opret projekt',
  knowledgePages: 'Videnssider',
  searchPages: 'Søg på sider',
  formatting: 'Formatering',
  pageTitle: 'Sidens titel',
  suggestions: 'Forslag',
  current: 'Aktuel',
  agent: 'Agent',
  runs: 'Kørsler',
  goal: 'Mål',
  instructions: 'Instruktioner',
  noRuns: 'Ingen kørsler endnu.',
  runNow: 'Kør nu',
  schedule: 'Plan',
  editors: 'Redaktører',
  now: 'Nu',
  moreFor: 'Mere for {name}',
  brief: 'Oplæg',
  version: 'Version {count}',
  noBriefLong:
    'Intet oplæg endnu. Skriv i en chat, hvad dette arbejde går ud på, og hvilke regler der gælder.',
  changeInChat: 'Skift i chatten',
  everyChatFollows: 'Alle chats her følger',
  andReadsFirst: 'Og læser først',
  file: 'Fil',
  knowledge: 'Viden',
  youLeadIt: 'Du er ansvarlig.',
  personLeadsIt: '{name} er ansvarlig.',
  everyoneAtCanFind: 'Alle i {company} kan finde det.',
  shareWhenOthers: 'Del det, når andre skal arbejde her.',
  projectAccessNote:
    'At være med i projektet giver ikke adgang til noget. Hvert element har sin egen adgang, og chats her kører som den person, der starter dem.',
  project: 'Projekt',
  needsYou: 'Kræver din opmærksomhed',
  review: 'Gennemgå',
  inThisProject: 'I dette projekt',
  deleteQuestion: 'Slet {name}?',
  deleteDescription:
    'Kun projektet forsvinder. Dets chats, filer og resultater bliver hos de personer, der ejer dem, på de steder, hvor de var før.',
  deleteConfirm: 'Slet {name}',
  projectDeleted: '{name} er slettet. Dets chats og arbejde bliver, hvor de var.',
  couldntDelete: 'Kunne ikke slette {name}.',
  itemOutSuccess: '{item} er fjernet fra {project}. Intet andet blev ændret.',
  itemOutError: 'Kunne ikke fjerne {item} fra {project}.',
  moveOutProject: 'Flyt ud af projektet',
  takeOutProject: 'Fjern fra projektet',
  unavailableTitle: 'Dette projekt er ikke tilgængeligt',
  unavailableDescription:
    'Det kan være blevet slettet, eller det er ikke delt med dig. Intet i det blev ændret for dig.',
  allProjects: 'Alle projekter',
  openingProject: 'Åbner projektet…',
  ended: 'Afsluttet',
  ends: 'Slutter',
  yesterday: 'I går',
  roleLead: 'Ansvarlig',
  roleCanEdit: 'Kan redigere',
  roleCanUse: 'Kan bruge',
  visibilityCompany: 'Alle i {company}',
  visibilityMembers: 'Udvalgte kolleger',
  visibilityPrivate: 'Kun dig',
  kindApp: 'App',
  kindDeck: 'Præsentation',
  kindSheet: 'Regneark',
  kindChart: 'Diagram',
  kindDashboard: 'Dashboard',
  kindReport: 'Rapport',
  kindChat: 'Chat',
  kindFile: 'Fil',
  kindMeeting: 'Møde',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Dig',
  gettingAnswer: 'Finder et svar',
  gettingAnswerOther: '{name} finder et svar',
  addedByYou: 'tilføjet af dig',
  addedByOther: 'tilføjet af {name}',
  renameProjectDescription: 'Omdøb det, rediger oplægget eller skift slutdatoen',
  deleteProject: 'Slet projekt',
  openToShare: 'Åbn den for at dele',
  sharingSaved: 'Deling gemt. {name} deles ikke længere med dig.',
  onlyOwnerPrivate: 'Kun {name} kan gøre den privat',
  add: 'Tilføj',
  addTo: 'Føj til {name}',
  addAnything:
    'Alt, du kan åbne. Det beholder sin egen adgang: Hvis du føjer det til her, deles det ikke med nogen.',
  couldntAdd: 'Kunne ikke tilføje {name}.',
  projectReadyChat:
    '{name} er klar, og denne chat er i det. Hvem der kan åbne chatten, er ikke ændret.',
  projectReadyPrivate: '{name} er klar. Det er kun dig, der kan åbne det.',
  projectCreatedNotice: '{name} er oprettet. Alt i det har fortsat sin egen adgang.',
  latestAnswerYou: 'Du er ved at få et svar',
  latestAnswerOther: '{name} er ved at få et svar',
  inProjectMove: 'I {name}. Flyt denne chat',
  notInProjectMove: 'Ikke i et projekt. Flyt denne chat',
  movedTo: 'Flyttet til',
  accessUnchanged: 'Hvem der kan åbne denne chat, er ikke ændret.',
  theProject: 'projektet',
  in: 'I',
  stopMakingProject: 'Stop med at oprette et nyt projekt i denne chat',
  searchYourWork: 'Søg i dit arbejde',
  searchDocuments: 'Søg i dokumenter, filer og møder…',
  yourWork: 'Dit arbejde',
  looking: 'Søger…',
  nothingMatchesChat:
    'Intet matcher. Hvis du vil hente en chat ind, skal du åbne den og bruge dens placering i sidehovedet.',
  typeToFind: 'Skriv for at finde arbejde, du kan åbne.',
  newProjectDraft: 'Nyt projekt · Udkast {count} · Endnu ikke oprettet',
  projectCreatedOpen: 'Projekt oprettet · Åbn det',
  aNewProject: 'Et nyt projekt',
  draftIntro:
    'Skriv i chatten, hvad arbejdet går ud på. Poneva laver et udkast til projektet her med det, der skal med, og hvem det skal deles med. Der bliver ikke oprettet noget, før du siger til.',
  draft: 'Udkast',
  projectCreatedAccess: 'Oprettet. Alt i det beholder sin egen adgang.',
  changeInChatDraft: 'Foretag ændringer ved at skrive det i chatten.',
  chatOwnerCreate: 'Kun den person, der ejer denne chat, kan oprette det.',
  open: 'Åbn',
  creating: 'Opretter…',
  cannotOpenDraft:
    '{people} kan ikke åbne {title}, så deres chats her vil svare uden det. Skriv i chatten, om ejeren skal bedes om at dele det, eller om det skal udelades.',
  bringsIn: 'Medtager {count}',
  thisChat: 'Denne chat',
  takenOutDraft: 'Fjernet i udkast {count}',
  nothingYet: 'Intet endnu. Skriv i chatten, hvad der hører til her.',
  leftOut: 'Udeladt: {items}.',
  whoCanUse: 'Hvem kan bruge det',
  youLead: 'Du, leder',
  beingInProject: 'At være i projektet åbner ikke noget. Hvert element beholder sin egen adgang.',
  onlyYouUntilShare: 'Det er kun synligt for dig, indtil du deler det.',
  colour: 'Farve',
  sand: 'Sand',
  green: 'Grøn',
  blue: 'Blå',
  grey: 'Grå',
  firstProject: 'Start dit første projekt',
  firstProjectDescription:
    'Giv det et navn, så tager alle chats, du starter i det, udgangspunkt i den samme brief. Medtag arbejde, du allerede har, og del det, når andre skal arbejde der.',
  loadingProjects: 'Indlæser projekter…',
  thisChatMoves: 'Denne chat flyttes ind i projektet. Det ændrer ikke, hvem der kan åbne den.',
  whatIsWork: 'Hvad handler arbejdet om?',
  optional: 'Valgfrit',
  writeFromChat: 'Skriv den ud fra denne chat',
  briefPlaceholder: 'Hvad den er til, reglerne der skal følges, og de vigtige datoer.',
  briefDraftHelp:
    'Alle chats i projektet læser dette først. »Skriv den ud fra denne chat« beder Poneva om at lave et udkast ved siden af chatten; du vælger stadig Opret.',
  briefLaterHelp:
    'Alle chats i projektet læser dette først. Du kan ændre det senere ved at spørge i en chat der.',
  sendClearFirst:
    'Send eller ryd din ikke-sendte besked og dine vedhæftede filer, før du skriver briefen ud fra denne chat.',
  createProjectError: 'Projektet kunne ikke oprettes. Prøv igen.',
  onlyYouUntil: 'Kun synligt for dig, indtil du deler det',
  whereChat: 'Hvor denne chat hører til',
  whereChatHelp:
    'En chat hører til i ét projekt ad gangen. Flytning ændrer aldrig, hvem der kan åbne den.',
  searchCreateProject: 'Søg efter eller opret et projekt',
  noProject: 'Intet projekt',
  inCompanyChats: 'I dine chats hos {company}',
  newProjectWithChat: 'Nyt projekt med denne chat',
  newProjectNamedWithChat: 'Nyt projekt “{name}” med denne chat',
  makingProject: 'Opretter et nyt projekt',
  moveToProject: 'Flyt denne chat til {name}',
  chatInProject: 'Denne chat er i {name}.',
  looksLikeWork: 'Det ligner {name}-arbejde. Vil du flytte den dertil?',
  accessBriefNext:
    'Det ændrer ikke, hvem der kan åbne den. Fra din næste besked tager den udgangspunkt i projektets brief.',
  moveFailed: 'Den kunne ikke flyttes. Prøv igen, eller brug dens placering i sidehovedet.',
  accessBriefNextTypographic:
    'Det ændrer ikke, hvem der kan åbne den. Fra din næste besked tager den udgangspunkt i projektets brief.',
  openProject: 'Åbn projekt',
  move: 'Flyt',
  movedOut: 'Flyttet ud af projektet. Det ændrer ikke, hvem der kan åbne den.',
  chatLivesHere: 'Denne chat hører til her nu. Det ændrer ikke, hvem der kan åbne den.',
  addedTo: 'Føjede {item} til {project}',
  addedAccess: 'Det beholder sin egen adgang. Hvis du føjer det til her, deles det ikke med nogen.',
  removedOut:
    '{item} er fjernet fra {project}. Det bliver, hvor det hører til, og det ændrer ikke, hvem der kan åbne det.',
  itIs: 'Det er',
  couldntMoveChat: 'Denne chat kunne ikke flyttes.',
  sharingCheckFailed:
    'Det var ikke muligt at kontrollere, hvem der kan åbne elementerne, der læses først. Gennemgå deres adgang, før du deler dette projekt.',
  cannotOpenShare: '{people} kan ikke åbne {title}.',
  readsFirstShare:
    'Alle chats i dette projekt læser det først, så deres chats her vil svare uden det. Deling af projektet ændrer ikke dette.',
  sharingSavedUnread: 'Deling gemt. {name} kunne ikke læses igen lige nu.',
  formerColleague: 'En tidligere kollega',
  madeInChatHere: 'lavet i en chat her',
  latestStarted: '{name} startede {title}',
  latestStartedYou: 'Du startede {title}',
  latestContinued: '{name} fortsatte {title}',
  latestContinuedYou: 'Du fortsatte {title}',
  latestMade: '{name} lavede {title}',
  latestMadeYou: 'Du lavede {title}',
  latestAdded: '{name} tilføjede {title}',
  latestAddedYou: 'Du tilføjede {title}',
  projectChipLives:
    'Denne chat hører til i {name} og læser dets oplæg. Flyt den fra den første del af overskriften.',
  addExistingWork: 'Tilføj arbejde, du allerede har',
  nameLabel: 'Navn',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} element',
  itemsMany: '{count} elementer',
  itemsAllStillHere: '{items}, alle stadig her',
  projectsOverviewDescription:
    'Ét sted til hver arbejdsopgave. At lægge noget i et projekt ændrer aldrig, hvem der kan åbne det.',
  noProjectMatchesHint: 'Intet projekt matcher. Prøv et ord fra navnet eller oplægget.',
  aboutProject: 'Om dette projekt',
  aboutShort: 'Om',
  workingIn: 'Arbejder i {name}',
  noBriefHome:
    'Intet oplæg endnu. Skriv i en chat her, hvad arbejdet handler om; alle chats i projektet læser det først.',
  tabAll: 'Alle',
  tabChats: 'Chats',
  tabResults: 'Resultater',
  tabFiles: 'Filer',
  emptyChats: 'Ingen chats her endnu. Start en ovenfor.',
  emptyResults: 'Intet lavet her endnu. Det, du laver i en chat her, havner her.',
  emptyFiles: 'Ingen filer her endnu. Filer, du tilføjer i en chat her, havner her.',
  showTabs: 'Vis',
  newestShown: 'De nyeste {shown} af {count} vises her.',
  nothingHereYet: 'Intet her endnu.',
  homeEmptyHelp:
    'Chats, du starter ovenfor, havner her, og det gør de filer, du tilføjer, og de resultater, du laver i dem.',
  shareWithPeopleDoingIt: 'Del med dem, der udfører arbejdet',
  briefWrittenBy: '{version} · skrevet af {name}, {when}',
  briefChangedBy: '{version} · ændret af {name}, {when}',
  personWorksInIt: '{people} arbejder i det.',
  peopleWorkInIt: '{people} arbejder i det.',
  aboutUnavailable:
    'Dette projekt er ikke tilgængeligt. Det kan være slettet, eller det er ikke delt med dig.',
  landedIn: 'I {name} · {access}',
  landedOnlyYou: 'Kun du kan åbne det',
  youWorkInIt: 'Du arbejder i det.',
  youAndPeopleWorkInIt: 'Du og {people} arbejder i det.',
  landedCompanyCanOpen: 'Alle i {company} kan åbne det',
  landedMembersCanOpen: 'Udvalgte kolleger kan åbne det',
  briefWrittenByYou: '{version} · skrevet af dig, {when}',
  briefChangedByYou: '{version} · ændret af dig, {when}',
  briefWrittenByFormer: '{version} · skrevet af en tidligere kollega, {when}',
  briefChangedByFormer: '{version} · ændret af en tidligere kollega, {when}',
  addedByFormer: 'tilføjet af en tidligere kollega',
  formerColleagueLeadsIt: 'En tidligere kollega er ansvarlig.',
  projectLoadFailed: 'Projektet kunne ikke indlæses.',
  personCannotOpenWithout:
    '{people} kan ikke åbne dette, så vedkommendes chats her svarer uden det.',
  peopleCannotOpenWithout: '{people} kan ikke åbne dette, så deres chats her svarer uden det.',
};
const de: Copy = {
  projects: 'Projekte',
  newProject: 'Neues Projekt',
  searchProjects: 'Projekte durchsuchen',
  finished: 'Abgeschlossen',
  people: 'Personen',
  skill: 'Fähigkeit',
  noBrief: 'Noch kein Briefing.',
  createProject: 'Projekt erstellen',
  knowledgePages: 'Wissensseiten',
  searchPages: 'Seiten durchsuchen',
  formatting: 'Formatierung',
  pageTitle: 'Seitentitel',
  suggestions: 'Vorschläge',
  current: 'Aktuell',
  agent: 'Agent',
  runs: 'Ausführungen',
  goal: 'Ziel',
  instructions: 'Anweisungen',
  noRuns: 'Noch keine Ausführungen.',
  runNow: 'Jetzt ausführen',
  schedule: 'Zeitplan',
  editors: 'Bearbeiter',
  now: 'Jetzt',
  moreFor: 'Mehr für {name}',
  brief: 'Briefing',
  version: 'Version {count}',
  noBriefLong:
    'Noch kein Briefing. Beschreiben Sie in einem Chat, worum es bei dieser Arbeit geht und welche Regeln dafür gelten.',
  changeInChat: 'Im Chat ändern',
  everyChatFollows: 'Jeder Chat hier folgt',
  andReadsFirst: 'Und liest zuerst',
  file: 'Datei',
  knowledge: 'Wissen',
  youLeadIt: 'Sie leiten es.',
  personLeadsIt: '{name} leitet es.',
  everyoneAtCanFind: 'Alle bei {company} können es finden.',
  shareWhenOthers: 'Teilen Sie es, wenn andere hier mitarbeiten sollen.',
  projectAccessNote:
    'Die Mitgliedschaft im Projekt öffnet nichts. Jedes Element hat weiterhin seinen eigenen Zugriff, und Chats hier laufen im Namen der Person, die sie startet.',
  project: 'Projekt',
  needsYou: 'Ihre Aufmerksamkeit erforderlich',
  review: 'Überprüfen',
  inThisProject: 'In diesem Projekt',
  deleteQuestion: '{name} löschen?',
  deleteDescription:
    'Nur das Projekt wird entfernt. Die zugehörigen Chats, Dateien und Ergebnisse bleiben bei den Personen, denen sie gehören, an ihrem bisherigen Ort.',
  deleteConfirm: '{name} löschen',
  projectDeleted:
    '{name} wurde gelöscht. Die zugehörigen Chats und Arbeiten bleiben an ihrem bisherigen Ort.',
  couldntDelete: '{name} konnte nicht gelöscht werden.',
  itemOutSuccess: '{item} wurde aus {project} entfernt. Sonst hat sich nichts geändert.',
  itemOutError: '{item} konnte nicht aus {project} entfernt werden.',
  moveOutProject: 'Aus dem Projekt verschieben',
  takeOutProject: 'Aus dem Projekt entfernen',
  unavailableTitle: 'Dieses Projekt ist nicht verfügbar',
  unavailableDescription:
    'Es wurde möglicherweise gelöscht oder nicht für Sie freigegeben. Für Sie hat sich darin nichts geändert.',
  allProjects: 'Alle Projekte',
  openingProject: 'Projekt wird geöffnet…',
  ended: 'Beendet',
  ends: 'Endet',
  yesterday: 'Gestern',
  roleLead: 'Leitung',
  roleCanEdit: 'Kann bearbeiten',
  roleCanUse: 'Kann verwenden',
  visibilityCompany: 'Alle bei {company}',
  visibilityMembers: 'Ausgewählte Kollegen',
  visibilityPrivate: 'Nur Sie',
  kindApp: 'App',
  kindDeck: 'Präsentation',
  kindSheet: 'Tabelle',
  kindChart: 'Diagramm',
  kindDashboard: 'Dashboard',
  kindReport: 'Bericht',
  kindChat: 'Chat',
  kindFile: 'Datei',
  kindMeeting: 'Meeting',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Sie',
  gettingAnswer: 'Antwort wird abgerufen',
  gettingAnswerOther: '{name} ruft eine Antwort ab',
  addedByYou: 'von Ihnen hinzugefügt',
  addedByOther: 'von {name} hinzugefügt',
  renameProjectDescription: 'Umbenennen, Briefing oder Enddatum ändern',
  deleteProject: 'Projekt löschen',
  openToShare: 'Öffnen, um es zu teilen',
  sharingSaved: 'Freigabe gespeichert. {name} wird nicht mehr mit Ihnen geteilt.',
  onlyOwnerPrivate: 'Nur {name} kann es privat machen',
  add: 'Hinzufügen',
  addTo: 'Zu {name} hinzufügen',
  addAnything:
    'Alles, was Sie öffnen können. Es behält seinen eigenen Zugriff: Wenn Sie es hier hinzufügen, teilen Sie es mit niemandem.',
  couldntAdd: '{name} konnte nicht hinzugefügt werden.',
  projectReadyChat:
    '{name} ist bereit, und dieser Chat befindet sich darin. Wer den Chat öffnen kann, hat sich nicht geändert.',
  projectReadyPrivate: '{name} ist bereit. Nur Sie können es öffnen.',
  projectCreatedNotice: '{name} wurde erstellt. Alles darin behält seine eigenen Zugriffsrechte.',
  latestAnswerYou: 'Sie erhalten eine Antwort',
  latestAnswerOther: '{name} erhält eine Antwort',
  inProjectMove: 'In {name}. Diesen Chat verschieben',
  notInProjectMove: 'In keinem Projekt. Diesen Chat verschieben',
  movedTo: 'Verschoben nach',
  accessUnchanged: 'Wer diesen Chat öffnen kann, hat sich nicht geändert.',
  theProject: 'das Projekt',
  in: 'In',
  stopMakingProject: 'Kein neues Projekt mehr in diesem Chat erstellen',
  searchYourWork: 'Ihre Arbeit durchsuchen',
  searchDocuments: 'Dokumente, Dateien und Meetings durchsuchen…',
  yourWork: 'Ihre Arbeit',
  looking: 'Suche…',
  nothingMatchesChat:
    'Keine Treffer. Um einen Chat hinzuzufügen, öffnen Sie ihn und verwenden Sie seinen Platz in der Kopfzeile.',
  typeToFind: 'Geben Sie etwas ein, um Arbeit zu finden, die Sie öffnen können.',
  newProjectDraft: 'Neues Projekt · Entwurf {count} · Noch nicht erstellt',
  projectCreatedOpen: 'Projekt erstellt · Öffnen',
  aNewProject: 'Ein neues Projekt',
  draftIntro:
    'Sagen Sie im Chat, worum es bei der Arbeit geht. Poneva erstellt hier einen Projektentwurf mit den hinzuzufügenden Inhalten und den Personen, mit denen Sie ihn teilen können. Nichts wird erstellt, bevor Sie es bestätigen.',
  draft: 'Entwurf',
  projectCreatedAccess: 'Erstellt. Alles darin behält seinen eigenen Zugriff.',
  changeInChatDraft: 'Ändern Sie alles, indem Sie es im Chat sagen.',
  chatOwnerCreate: 'Nur die Person, der dieser Chat gehört, kann es erstellen.',
  open: 'Öffnen',
  creating: 'Wird erstellt…',
  cannotOpenDraft:
    '{people} können {title} nicht öffnen, daher würden ihre Chats hier ohne es antworten. Sagen Sie im Chat, ob der Besitzer oder die Besitzerin gebeten werden soll, es zu teilen, oder ob es weggelassen werden soll.',
  bringsIn: 'Fügt {count} hinzu',
  thisChat: 'Dieser Chat',
  takenOutDraft: 'Im Entwurf {count} entfernt',
  nothingYet: 'Noch nichts. Benennen Sie im Chat, was hierher gehört.',
  leftOut: 'Ausgelassen: {items}.',
  whoCanUse: 'Wer es nutzen kann',
  youLead: 'Sie, Projektleitung',
  beingInProject:
    'Die Aufnahme in ein Projekt öffnet nichts. Jedes Element behält seinen eigenen Zugriff.',
  onlyYouUntilShare: 'Es bleibt bei „Nur Sie“, bis Sie es teilen.',
  colour: 'Farbe',
  sand: 'Sand',
  green: 'Grün',
  blue: 'Blau',
  grey: 'Grau',
  firstProject: 'Starten Sie Ihr erstes Projekt',
  firstProjectDescription:
    'Benennen Sie es, und jeder Chat, den Sie darin starten, liest dasselbe Briefing. Fügen Sie bereits vorhandene Arbeit hinzu und teilen Sie sie, wenn andere dort mitarbeiten sollen.',
  loadingProjects: 'Projekte werden geladen…',
  thisChatMoves:
    'Dieser Chat wird in das Projekt verschoben. Wer ihn öffnen kann, ändert sich nicht.',
  whatIsWork: 'Worum geht es bei der Arbeit?',
  optional: 'Optional',
  writeFromChat: 'Aus diesem Chat schreiben',
  briefPlaceholder:
    'Wofür es gedacht ist, welche Regeln zu befolgen sind und welche Termine wichtig sind.',
  briefDraftHelp:
    'Jeder Chat im Projekt liest dies zuerst. Mit „Aus diesem Chat schreiben“ bitten Sie Poneva, es neben dem Chat zu entwerfen; Sie entscheiden weiterhin über „Erstellen“.',
  briefLaterHelp:
    'Jeder Chat im Projekt liest dies zuerst. Sie können es später in jedem Chat dort ändern.',
  sendClearFirst:
    'Senden Sie oder löschen Sie zuerst Ihre nicht gesendete Nachricht und Ihre Anhänge, um das Briefing aus diesem Chat zu schreiben.',
  createProjectError: 'Das Projekt konnte nicht erstellt werden. Versuchen Sie es erneut.',
  onlyYouUntil: 'Nur Sie, bis Sie es teilen',
  whereChat: 'Wo dieser Chat liegt',
  whereChatHelp:
    'Ein Chat kann jeweils nur in einem Projekt liegen. Durch das Verschieben ändert sich nicht, wer ihn öffnen kann.',
  searchCreateProject: 'Projekt suchen oder erstellen',
  noProject: 'Kein Projekt',
  inCompanyChats: 'In Ihren Chats bei {company}',
  newProjectWithChat: 'Neues Projekt mit diesem Chat',
  newProjectNamedWithChat: 'Neues Projekt „{name}“ mit diesem Chat',
  makingProject: 'Neues Projekt wird erstellt',
  moveToProject: 'Diesen Chat zu {name} verschieben',
  chatInProject: 'Dieser Chat ist in {name}.',
  looksLikeWork: 'Das sieht nach Arbeit für {name} aus. Dorthin verschieben?',
  accessBriefNext:
    'Wer ihn öffnen kann, hat sich nicht geändert. Ab Ihrer nächsten Nachricht liest er das Projekt-Briefing.',
  moveFailed:
    'Der Chat konnte nicht verschoben werden. Versuchen Sie es erneut oder verwenden Sie seinen Platz in der Kopfzeile.',
  accessBriefNextTypographic:
    'Wer ihn öffnen kann, ändert sich nicht. Ab Ihrer nächsten Nachricht liest er das Projekt-Briefing.',
  openProject: 'Projekt öffnen',
  move: 'Verschieben',
  movedOut: 'Aus seinem Projekt verschoben. Wer ihn öffnen kann, hat sich nicht geändert.',
  chatLivesHere: 'Dieser Chat liegt jetzt hier. Wer ihn öffnen kann, hat sich nicht geändert.',
  addedTo: '{item} zu {project} hinzugefügt',
  addedAccess:
    'Der eigene Zugriff bleibt bestehen. Wenn Sie es hier hinzufügen, teilen Sie es mit niemandem.',
  removedOut:
    '{item} wurde aus {project} entfernt. Es bleibt an seinem bisherigen Ort, und wer es öffnen kann, hat sich nicht geändert.',
  itIs: 'Es ist',
  couldntMoveChat: 'Dieser Chat konnte nicht verschoben werden.',
  sharingCheckFailed:
    'Der Zugriff auf die Elemente, die zuerst gelesen werden, konnte nicht geprüft werden. Überprüfen Sie ihren Zugriff, bevor Sie dieses Projekt teilen.',
  cannotOpenShare: '{people} können {title} nicht öffnen.',
  readsFirstShare:
    'Jeder Chat in diesem Projekt liest es zuerst und würde daher hier ohne es antworten. Das Teilen des Projekts ändert daran nichts.',
  sharingSavedUnread: 'Freigabe gespeichert. {name} konnte gerade nicht erneut gelesen werden.',
  formerColleague: 'Ein ehemaliger Kollege',
  madeInChatHere: 'in einem Chat hier erstellt',
  latestStarted: '{name} hat {title} gestartet',
  latestStartedYou: 'Sie haben {title} gestartet',
  latestContinued: '{name} hat {title} fortgesetzt',
  latestContinuedYou: 'Sie haben {title} fortgesetzt',
  latestMade: '{name} hat {title} erstellt',
  latestMadeYou: 'Sie haben {title} erstellt',
  latestAdded: '{name} hat {title} hinzugefügt',
  latestAddedYou: 'Sie haben {title} hinzugefügt',
  projectChipLives:
    'Dieser Chat gehört zu {name} und liest dessen Briefing. Verschieben Sie ihn über den ersten Teil der Kopfzeile.',
  addExistingWork: 'Vorhandene Arbeit hinzufügen',
  nameLabel: 'Name',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} Element',
  itemsMany: '{count} Elemente',
  itemsAllStillHere: '{items}, alle noch da',
  projectsOverviewDescription:
    'Ein Ort für jede Arbeit. Etwas in ein Projekt zu legen ändert nie, wer es öffnen kann.',
  noProjectMatchesHint: 'Kein Projekt passt. Versuchen Sie ein Wort aus dem Namen oder Briefing.',
  aboutProject: 'Über dieses Projekt',
  aboutShort: 'Info',
  workingIn: 'Sie arbeiten in {name}',
  noBriefHome:
    'Noch kein Briefing. Sagen Sie in einem Chat hier, worum es bei der Arbeit geht; jeder Chat im Projekt liest es zuerst.',
  tabAll: 'Alle',
  tabChats: 'Chats',
  tabResults: 'Ergebnisse',
  tabFiles: 'Dateien',
  emptyChats: 'Noch keine Chats hier. Starten Sie oben einen.',
  emptyResults:
    'Hier ist noch nichts entstanden. Was Sie in einem Chat hier erstellen, landet hier.',
  emptyFiles:
    'Noch keine Dateien hier. Dateien, die Sie in einem Chat hier hinzufügen, landen hier.',
  showTabs: 'Anzeigen',
  newestShown: 'Die neuesten {shown} von {count} werden hier angezeigt.',
  nothingHereYet: 'Hier ist noch nichts.',
  homeEmptyHelp:
    'Chats, die Sie oben starten, landen hier, ebenso die Dateien, die Sie hinzufügen, und die Ergebnisse, die Sie darin erstellen.',
  shareWithPeopleDoingIt: 'Mit den Beteiligten teilen',
  briefWrittenBy: '{version} · geschrieben von {name}, {when}',
  briefChangedBy: '{version} · geändert von {name}, {when}',
  personWorksInIt: '{people} arbeitet darin.',
  peopleWorkInIt: '{people} arbeiten darin.',
  aboutUnavailable:
    'Dieses Projekt ist nicht verfügbar. Es wurde möglicherweise gelöscht oder nicht mit Ihnen geteilt.',
  landedIn: 'In {name} · {access}',
  landedOnlyYou: 'Nur Sie können es öffnen',
  youWorkInIt: 'Sie arbeiten darin.',
  youAndPeopleWorkInIt: 'Sie und {people} arbeiten darin.',
  landedCompanyCanOpen: 'Alle bei {company} können es öffnen',
  landedMembersCanOpen: 'Ausgewählte Kollegen können es öffnen',
  briefWrittenByYou: '{version} · geschrieben von Ihnen, {when}',
  briefChangedByYou: '{version} · geändert von Ihnen, {when}',
  briefWrittenByFormer: '{version} · geschrieben von einem ehemaligen Kollegen, {when}',
  briefChangedByFormer: '{version} · geändert von einem ehemaligen Kollegen, {when}',
  addedByFormer: 'von einem ehemaligen Kollegen hinzugefügt',
  formerColleagueLeadsIt: 'Ein ehemaliger Kollege leitet es.',
  projectLoadFailed: 'Das Projekt konnte nicht geladen werden.',
  personCannotOpenWithout:
    '{people} kann dies nicht öffnen. Die Chats dieser Person hier antworten daher ohne es.',
  peopleCannotOpenWithout:
    '{people} können dies nicht öffnen. Deren Chats hier antworten daher ohne es.',
};
const el: Copy = {
  projects: 'Έργα',
  newProject: 'Νέο έργο',
  searchProjects: 'Αναζήτηση έργων',
  finished: 'Ολοκληρωμένα',
  people: 'Άτομα',
  skill: 'Δεξιότητα',
  noBrief: 'Δεν υπάρχει ακόμη περίληψη.',
  createProject: 'Δημιουργία έργου',
  knowledgePages: 'Σελίδες γνώσης',
  searchPages: 'Αναζήτηση σελίδων',
  formatting: 'Μορφοποίηση',
  pageTitle: 'Τίτλος σελίδας',
  suggestions: 'Προτάσεις',
  current: 'Τρέχον',
  agent: 'Πράκτορας',
  runs: 'Εκτελέσεις',
  goal: 'Στόχος',
  instructions: 'Οδηγίες',
  noRuns: 'Δεν υπάρχουν ακόμη εκτελέσεις.',
  runNow: 'Εκτέλεση τώρα',
  schedule: 'Πρόγραμμα',
  editors: 'Συντάκτες',
  now: 'Τώρα',
  moreFor: 'Περισσότερα για {name}',
  brief: 'Σύνοψη',
  version: 'Έκδοση {count}',
  noBriefLong:
    'Δεν υπάρχει ακόμη σύνοψη. Πες σε μια συνομιλία τι είναι αυτή η εργασία και ποιοι είναι οι κανόνες της.',
  changeInChat: 'Αλλαγή στη συνομιλία',
  everyChatFollows: 'Κάθε συνομιλία εδώ ακολουθεί',
  andReadsFirst: 'Και διαβάζει πρώτα',
  file: 'Αρχείο',
  knowledge: 'Γνώση',
  youLeadIt: 'Εσύ έχεις την ευθύνη.',
  personLeadsIt: 'Ο/Η {name} έχει την ευθύνη.',
  everyoneAtCanFind: 'Όλοι στην {company} μπορούν να το βρουν.',
  shareWhenOthers: 'Κοινοποίησέ το όταν πρέπει να εργαστούν και άλλοι εδώ.',
  projectAccessNote:
    'Η συμμετοχή στο έργο δεν παρέχει πρόσβαση σε τίποτα. Κάθε στοιχείο έχει τη δική του πρόσβαση και οι συνομιλίες εδώ εκτελούνται ως το άτομο που τις ξεκινά.',
  project: 'Έργο',
  needsYou: 'Χρειάζεται εσένα',
  review: 'Έλεγχος',
  inThisProject: 'Σε αυτό το έργο',
  deleteQuestion: 'Διαγραφή του {name};',
  deleteDescription:
    'Μόνο το έργο θα διαγραφεί. Οι συνομιλίες, τα αρχεία και τα αποτελέσματά του παραμένουν με τα άτομα που τα κατέχουν, εκεί όπου βρίσκονταν πριν.',
  deleteConfirm: 'Διαγραφή του {name}',
  projectDeleted:
    'Το {name} διαγράφηκε. Οι συνομιλίες και η εργασία του παραμένουν εκεί όπου βρίσκονταν.',
  couldntDelete: 'Δεν ήταν δυνατή η διαγραφή του {name}.',
  itemOutSuccess: 'Το {item} αφαιρέθηκε από το {project}. Δεν άλλαξε τίποτα άλλο.',
  itemOutError: 'Δεν ήταν δυνατή η αφαίρεση του {item} από το {project}.',
  moveOutProject: 'Μετακίνηση εκτός έργου',
  takeOutProject: 'Αφαίρεση από το έργο',
  unavailableTitle: 'Αυτό το έργο δεν είναι διαθέσιμο',
  unavailableDescription:
    'Μπορεί να έχει διαγραφεί ή να μην έχει κοινοποιηθεί σε εσένα. Τίποτα μέσα σε αυτό δεν άλλαξε για εσένα.',
  allProjects: 'Όλα τα έργα',
  openingProject: 'Άνοιγμα του έργου…',
  ended: 'Ολοκληρώθηκε',
  ends: 'Λήγει',
  yesterday: 'Χθες',
  roleLead: 'Επικεφαλής',
  roleCanEdit: 'Μπορεί να επεξεργαστεί',
  roleCanUse: 'Μπορεί να χρησιμοποιήσει',
  visibilityCompany: 'Όλοι στην {company}',
  visibilityMembers: 'Επιλεγμένοι συνάδελφοι',
  visibilityPrivate: 'Μόνο εσύ',
  kindApp: 'Εφαρμογή',
  kindDeck: 'Παρουσίαση',
  kindSheet: 'Φύλλο',
  kindChart: 'Γράφημα',
  kindDashboard: 'Πίνακας ελέγχου',
  kindReport: 'Αναφορά',
  kindChat: 'Συνομιλία',
  kindFile: 'Αρχείο',
  kindMeeting: 'Συνάντηση',
  kindAgent: 'Πράκτορας',
  kindDocument: 'Έγγραφο',
  you: 'Εσύ',
  gettingAnswer: 'Λήψη απάντησης',
  gettingAnswerOther: '{name} λαμβάνει απάντηση',
  addedByYou: 'προστέθηκε από εσένα',
  addedByOther: 'προστέθηκε από τον/την {name}',
  renameProjectDescription: 'Μετονόμασέ το, άλλαξε τη σύνοψη ή την ημερομηνία λήξης του',
  deleteProject: 'Διαγραφή έργου',
  openToShare: 'Άνοιξέ το για κοινή χρήση',
  sharingSaved:
    'Οι ρυθμίσεις κοινής χρήσης αποθηκεύτηκαν. Το {name} δεν είναι πλέον κοινόχρηστο μαζί σου.',
  onlyOwnerPrivate: 'Μόνο ο/η {name} μπορεί να το κάνει ιδιωτικό',
  add: 'Προσθήκη',
  addTo: 'Προσθήκη στο {name}',
  addAnything:
    'Οτιδήποτε μπορείς να ανοίξεις. Διατηρεί τη δική του πρόσβαση: η προσθήκη του εδώ δεν το κοινοποιεί σε κανέναν.',
  couldntAdd: 'Δεν ήταν δυνατή η προσθήκη του/της {name}.',
  projectReadyChat:
    'Το {name} είναι έτοιμο και αυτή η συνομιλία βρίσκεται σε αυτό. Δεν έχει αλλάξει ποιος μπορεί να ανοίξει τη συνομιλία.',
  projectReadyPrivate: 'Το {name} είναι έτοιμο. Μόνο εσείς μπορείτε να το ανοίξετε.',
  projectCreatedNotice:
    'Το {name} δημιουργήθηκε. Ό,τι περιέχει διατηρεί τα δικά του δικαιώματα πρόσβασης.',
  latestAnswerYou: 'Λαμβάνετε απάντηση',
  latestAnswerOther: '{name} λαμβάνει απάντηση',
  inProjectMove: 'Στο {name}. Μετακίνηση αυτής της συνομιλίας',
  notInProjectMove: 'Δεν ανήκει σε έργο. Μετακίνηση αυτής της συνομιλίας',
  movedTo: 'Μετακινήθηκε σε',
  accessUnchanged: 'Δεν άλλαξε ποιος μπορεί να ανοίξει αυτή τη συνομιλία.',
  theProject: 'το έργο',
  in: 'Σε',
  stopMakingProject: 'Διακοπή δημιουργίας νέου έργου σε αυτή τη συνομιλία',
  searchYourWork: 'Αναζήτηση στην εργασία σου',
  searchDocuments: 'Αναζήτηση σε έγγραφα, αρχεία και συσκέψεις…',
  yourWork: 'Η εργασία σου',
  looking: 'Αναζήτηση…',
  nothingMatchesChat:
    'Δεν βρέθηκε κάτι. Για να προσθέσεις μια συνομιλία, άνοιξέ την και χρησιμοποίησε τη θέση της στην κεφαλίδα.',
  typeToFind: 'Πληκτρολόγησε για να βρεις εργασία που μπορείς να ανοίξεις.',
  newProjectDraft: 'Νέο έργο · Πρόχειρο {count} · Δεν έχει δημιουργηθεί ακόμη',
  projectCreatedOpen: 'Το έργο δημιουργήθηκε · Άνοιξέ το',
  aNewProject: 'Ένα νέο έργο',
  draftIntro:
    'Πες στη συνομιλία τι αφορά η εργασία. Η Poneva συντάσσει εδώ το έργο, μαζί με όσα πρέπει να προστεθούν και τα άτομα με τα οποία πρέπει να κοινοποιηθεί. Δεν δημιουργείται τίποτα μέχρι να το επιβεβαιώσεις.',
  draft: 'Πρόχειρο',
  projectCreatedAccess: 'Δημιουργήθηκε. Κάθε στοιχείο του διατηρεί τη δική του πρόσβαση.',
  changeInChatDraft: 'Άλλαξε οτιδήποτε ζητώντας το στη συνομιλία.',
  chatOwnerCreate: 'Μόνο το άτομο που κατέχει αυτήν τη συνομιλία μπορεί να το δημιουργήσει.',
  open: 'Άνοιγμα',
  creating: 'Δημιουργία…',
  cannotOpenDraft:
    'Οι {people} δεν μπορούν να ανοίξουν το {title}, επομένως οι συνομιλίες τους εδώ θα απαντούν χωρίς αυτό. Πες στη συνομιλία αν πρέπει να ζητηθεί από τον κάτοχό του να το κοινοποιήσει ή να παραλειφθεί.',
  bringsIn: 'Προσθέτει {count}',
  thisChat: 'Αυτή η συνομιλία',
  takenOutDraft: 'Αφαιρέθηκε στο πρόχειρο {count}',
  nothingYet: 'Τίποτα ακόμη. Ανέφερε στη συνομιλία τι ανήκει εδώ.',
  leftOut: 'Παραλείφθηκαν: {items}.',
  whoCanUse: 'Ποιος μπορεί να το χρησιμοποιήσει',
  youLead: 'Εσύ, υπεύθυνος',
  beingInProject:
    'Η συμμετοχή στο έργο δεν ανοίγει τίποτα. Κάθε στοιχείο διατηρεί τη δική του πρόσβαση.',
  onlyYouUntilShare: 'Παραμένει διαθέσιμο μόνο σε εσένα μέχρι να το κοινοποιήσεις.',
  colour: 'Χρώμα',
  sand: 'Άμμος',
  green: 'Πράσινο',
  blue: 'Μπλε',
  grey: 'Γκρι',
  firstProject: 'Ξεκίνα το πρώτο σου έργο',
  firstProjectDescription:
    'Δώσε του όνομα και κάθε συνομιλία που ξεκινάς σε αυτό θα διαβάζει το ίδιο πλαίσιο. Πρόσθεσε εργασία που έχεις ήδη και κοινοποίησέ την όταν πρέπει να εργαστούν και άλλοι σε αυτήν.',
  loadingProjects: 'Φόρτωση έργων…',
  thisChatMoves:
    'Αυτή η συνομιλία μετακινείται στο έργο. Το ποιος μπορεί να την ανοίξει δεν αλλάζει.',
  whatIsWork: 'Τι αφορά η εργασία;',
  optional: 'Προαιρετικό',
  writeFromChat: 'Σύνταξη από αυτήν τη συνομιλία',
  briefPlaceholder:
    'Ο σκοπός της, οι κανόνες που πρέπει να ακολουθηθούν και οι σημαντικές ημερομηνίες.',
  briefDraftHelp:
    'Κάθε συνομιλία στο έργο το διαβάζει πρώτο. Η επιλογή «Σύνταξη από αυτήν τη συνομιλία» ζητά από την Poneva να το συντάξει δίπλα στη συνομιλία· εσύ επιλέγεις πότε θα πατήσεις «Δημιουργία».',
  briefLaterHelp:
    'Κάθε συνομιλία στο έργο το διαβάζει πρώτο. Άλλαξέ το αργότερα ζητώντας το σε οποιαδήποτε συνομιλία του έργου.',
  sendClearFirst:
    'Στείλε ή διέγραψε πρώτα το μη απεσταλμένο μήνυμα και τα συνημμένα για να συντάξεις το πλαίσιο από αυτήν τη συνομιλία.',
  createProjectError: 'Δεν ήταν δυνατή η δημιουργία του έργου. Δοκίμασε ξανά.',
  onlyYouUntil: 'Μόνο εσύ, μέχρι να το κοινοποιήσεις',
  whereChat: 'Πού βρίσκεται αυτή η συνομιλία',
  whereChatHelp:
    'Μια συνομιλία βρίσκεται σε ένα έργο κάθε φορά. Η μετακίνησή της δεν αλλάζει ποτέ ποιος μπορεί να την ανοίξει.',
  searchCreateProject: 'Αναζήτηση ή δημιουργία έργου',
  noProject: 'Χωρίς έργο',
  inCompanyChats: 'Στις συνομιλίες σου στην {company}',
  newProjectWithChat: 'Νέο έργο με αυτήν τη συνομιλία',
  newProjectNamedWithChat: 'Νέο έργο «{name}» με αυτήν τη συνομιλία',
  makingProject: 'Δημιουργία νέου έργου',
  moveToProject: 'Μετακίνηση αυτής της συνομιλίας στο {name}',
  chatInProject: 'Αυτή η συνομιλία βρίσκεται στο {name}.',
  looksLikeWork: 'Αυτό μοιάζει με εργασία του {name}. Να μετακινηθεί εκεί;',
  accessBriefNext:
    'Το ποιος μπορεί να την ανοίξει δεν έχει αλλάξει. Θα διαβάζει το πλαίσιο του έργου από το επόμενο μήνυμά σου.',
  moveFailed:
    'Δεν ήταν δυνατή η μετακίνησή της. Δοκίμασε ξανά ή χρησιμοποίησε τη θέση της στην κεφαλίδα.',
  accessBriefNextTypographic:
    'Το ποιος μπορεί να την ανοίξει δεν αλλάζει. Θα διαβάζει το πλαίσιο του έργου από το επόμενο μήνυμά σου.',
  openProject: 'Άνοιγμα έργου',
  move: 'Μετακίνηση',
  movedOut: 'Μετακινήθηκε εκτός του έργου της. Το ποιος μπορεί να την ανοίξει δεν έχει αλλάξει.',
  chatLivesHere:
    'Αυτή η συνομιλία βρίσκεται πλέον εδώ. Το ποιος μπορεί να την ανοίξει δεν έχει αλλάξει.',
  addedTo: 'Προστέθηκε το {item} στο {project}',
  addedAccess: 'Διατηρεί τη δική του πρόσβαση. Η προσθήκη του εδώ δεν το κοινοποιεί σε κανέναν.',
  removedOut:
    'Το {item} αφαιρέθηκε από το {project}. Παραμένει στη θέση του και το ποιος μπορεί να το ανοίξει δεν έχει αλλάξει.',
  itIs: 'Είναι',
  couldntMoveChat: 'Δεν ήταν δυνατή η μετακίνηση αυτής της συνομιλίας.',
  sharingCheckFailed:
    'Δεν ήταν δυνατός ο έλεγχος του ποιος μπορεί να ανοίξει τα στοιχεία που διαβάζονται πρώτα. Έλεγξε την πρόσβασή τους πριν κοινοποιήσεις αυτό το έργο.',
  cannotOpenShare: 'Οι {people} δεν μπορούν να ανοίξουν το {title}.',
  readsFirstShare:
    'Κάθε συνομιλία σε αυτό το έργο το διαβάζει πρώτη, επομένως οι συνομιλίες τους εδώ θα απαντούν χωρίς αυτό. Η κοινοποίηση του έργου δεν αλλάζει αυτό.',
  sharingSavedUnread:
    'Η κοινή χρήση αποθηκεύτηκε. Το {name} δεν μπόρεσε να διαβαστεί ξανά αυτή τη στιγμή.',
  formerColleague: 'Ένας πρώην συνάδελφος',
  madeInChatHere: 'δημιουργήθηκε σε συνομιλία εδώ',
  latestStarted: '{name} ξεκίνησε {title}',
  latestStartedYou: 'Ξεκίνησες {title}',
  latestContinued: '{name} συνέχισε {title}',
  latestContinuedYou: 'Συνέχισες {title}',
  latestMade: '{name} δημιούργησε {title}',
  latestMadeYou: 'Δημιούργησες {title}',
  latestAdded: '{name} πρόσθεσε {title}',
  latestAddedYou: 'Πρόσθεσες {title}',
  projectChipLives:
    'Αυτή η συνομιλία ανήκει στο {name} και διαβάζει τη σύνοψή του. Μετακίνησέ την από το πρώτο τμήμα της κεφαλίδας.',
  addExistingWork: 'Πρόσθεσε εργασία που έχεις ήδη',
  nameLabel: 'Όνομα',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} στοιχείο',
  itemsMany: '{count} στοιχεία',
  itemsAllStillHere: '{items}, όλα εδώ',
  projectsOverviewDescription:
    'Ένα μέρος για κάθε εργασία. Η προσθήκη κάτι σε ένα έργο δεν αλλάζει ποιος μπορεί να το ανοίξει.',
  noProjectMatchesHint:
    'Κανένα έργο δεν ταιριάζει. Δοκίμασε μια λέξη από το όνομα ή τη σύνοψή του.',
  aboutProject: 'Σχετικά με αυτό το έργο',
  aboutShort: 'Σχετικά',
  workingIn: 'Εργασία στο {name}',
  noBriefHome:
    'Δεν υπάρχει ακόμη σύνοψη. Πες σε μια συνομιλία εδώ ποια είναι η εργασία· κάθε συνομιλία του έργου τη διαβάζει πρώτη.',
  tabAll: 'Όλα',
  tabChats: 'Συνομιλίες',
  tabResults: 'Αποτελέσματα',
  tabFiles: 'Αρχεία',
  emptyChats: 'Δεν υπάρχουν ακόμη συνομιλίες εδώ. Ξεκίνα μία παραπάνω.',
  emptyResults:
    'Δεν έχει δημιουργηθεί τίποτα εδώ ακόμη. Ό,τι δημιουργείς σε μια συνομιλία εδώ εμφανίζεται εδώ.',
  emptyFiles:
    'Δεν υπάρχουν ακόμη αρχεία εδώ. Τα αρχεία που προσθέτεις σε μια συνομιλία εδώ εμφανίζονται εδώ.',
  showTabs: 'Εμφάνιση',
  newestShown: 'Εμφανίζονται τα {shown} νεότερα από {count}.',
  nothingHereYet: 'Δεν υπάρχει ακόμη τίποτα εδώ.',
  homeEmptyHelp:
    'Οι συνομιλίες που ξεκινάς παραπάνω εμφανίζονται εδώ, όπως και τα αρχεία που προσθέτεις και τα αποτελέσματα που δημιουργείς σε αυτές.',
  shareWithPeopleDoingIt: 'Κοινοποίηση στους ανθρώπους που εργάζονται σε αυτό',
  briefWrittenBy: '{version} · γράφτηκε από {name}, {when}',
  briefChangedBy: '{version} · άλλαξε από {name}, {when}',
  personWorksInIt: '{people} εργάζεται σε αυτό.',
  peopleWorkInIt: '{people} εργάζονται σε αυτό.',
  aboutUnavailable:
    'Αυτό το έργο δεν είναι διαθέσιμο. Ίσως έχει διαγραφεί ή δεν έχει κοινοποιηθεί σε εσένα.',
  landedIn: 'Στο {name} · {access}',
  landedOnlyYou: 'Μόνο εσύ μπορείς να το ανοίξεις',
  youWorkInIt: 'Εσύ εργάζεσαι σε αυτό.',
  youAndPeopleWorkInIt: 'Εσύ και {people} εργάζεστε σε αυτό.',
  landedCompanyCanOpen: 'Όλοι στην {company} μπορούν να το ανοίξουν',
  landedMembersCanOpen: 'Επιλεγμένοι συνάδελφοι μπορούν να το ανοίξουν',
  briefWrittenByYou: '{version} · γράφτηκε από εσένα, {when}',
  briefChangedByYou: '{version} · άλλαξε από εσένα, {when}',
  briefWrittenByFormer: '{version} · γράφτηκε από πρώην συνάδελφο, {when}',
  briefChangedByFormer: '{version} · άλλαξε από πρώην συνάδελφο, {when}',
  addedByFormer: 'προστέθηκε από πρώην συνάδελφο',
  formerColleagueLeadsIt: 'Ένας πρώην συνάδελφος έχει την ευθύνη.',
  projectLoadFailed: 'Δεν ήταν δυνατή η φόρτωση αυτού του έργου.',
  personCannotOpenWithout:
    '{people} δεν μπορεί να το ανοίξει, επομένως οι συνομιλίες αυτού του ατόμου εδώ απαντούν χωρίς αυτό.',
  peopleCannotOpenWithout:
    '{people} δεν μπορούν να το ανοίξουν, επομένως οι συνομιλίες τους εδώ απαντούν χωρίς αυτό.',
};
const es: Copy = {
  projects: 'Proyectos',
  newProject: 'Nuevo proyecto',
  searchProjects: 'Buscar proyectos',
  finished: 'Terminados',
  people: 'Personas',
  skill: 'Habilidad',
  noBrief: 'Aún no hay resumen.',
  createProject: 'Crear proyecto',
  knowledgePages: 'Páginas de conocimiento',
  searchPages: 'Buscar páginas',
  formatting: 'Formato',
  pageTitle: 'Título de la página',
  suggestions: 'Sugerencias',
  current: 'Actual',
  agent: 'Agente',
  runs: 'Ejecuciones',
  goal: 'Objetivo',
  instructions: 'Instrucciones',
  noRuns: 'Aún no hay ejecuciones.',
  runNow: 'Ejecutar ahora',
  schedule: 'Programación',
  editors: 'Editores',
  now: 'Ahora',
  moreFor: 'Más para {name}',
  brief: 'Resumen',
  version: 'Versión {count}',
  noBriefLong:
    'Aún no hay resumen. Di en un chat en qué consiste este trabajo y cuáles son sus reglas.',
  changeInChat: 'Cambiar en el chat',
  everyChatFollows: 'Todos los chats de aquí siguen',
  andReadsFirst: 'Y leen primero',
  file: 'Archivo',
  knowledge: 'Conocimientos',
  youLeadIt: 'Tú lo diriges.',
  personLeadsIt: '{name} lo dirige.',
  everyoneAtCanFind: 'Todos en {company} pueden encontrarlo.',
  shareWhenOthers: 'Compártelo cuando otras personas deban trabajar aquí.',
  projectAccessNote:
    'Estar en el proyecto no da acceso a nada. Cada elemento mantiene su propio acceso y los chats de aquí se ejecutan como la persona que los inicia.',
  project: 'Proyecto',
  needsYou: 'Requiere tu atención',
  review: 'Revisar',
  inThisProject: 'En este proyecto',
  deleteQuestion: '¿Eliminar {name}?',
  deleteDescription:
    'Solo desaparecerá el proyecto. Sus chats, archivos y resultados permanecerán con las personas que los poseen, donde estaban antes.',
  deleteConfirm: 'Eliminar {name}',
  projectDeleted: '{name} se eliminó. Sus chats y su trabajo permanecen donde estaban.',
  couldntDelete: 'No se pudo eliminar {name}.',
  itemOutSuccess: '{item} se quitó de {project}. No cambió nada más.',
  itemOutError: 'No se pudo quitar {item} de {project}.',
  moveOutProject: 'Mover fuera del proyecto',
  takeOutProject: 'Sacar del proyecto',
  unavailableTitle: 'Este proyecto no está disponible',
  unavailableDescription:
    'Es posible que se haya eliminado o que no se haya compartido contigo. Nada de su contenido cambió para ti.',
  allProjects: 'Todos los proyectos',
  openingProject: 'Abriendo el proyecto…',
  ended: 'Finalizado',
  ends: 'Finaliza',
  yesterday: 'Ayer',
  roleLead: 'Responsable',
  roleCanEdit: 'Puede editar',
  roleCanUse: 'Puede usar',
  visibilityCompany: 'Todos en {company}',
  visibilityMembers: 'Colegas seleccionados',
  visibilityPrivate: 'Solo tú',
  kindApp: 'Aplicación',
  kindDeck: 'Presentación',
  kindSheet: 'Hoja de cálculo',
  kindChart: 'Gráfico',
  kindDashboard: 'Panel',
  kindReport: 'Informe',
  kindChat: 'Chat',
  kindFile: 'Archivo',
  kindMeeting: 'Reunión',
  kindAgent: 'Agente',
  kindDocument: 'Documento',
  you: 'Tú',
  gettingAnswer: 'Obteniendo una respuesta',
  gettingAnswerOther: '{name} está obteniendo una respuesta',
  addedByYou: 'añadido por ti',
  addedByOther: 'añadido por {name}',
  renameProjectDescription: 'Cámbiale el nombre, modifica el resumen o su fecha de finalización',
  deleteProject: 'Eliminar proyecto',
  openToShare: 'Ábrelo para compartirlo',
  sharingSaved: 'Configuración de uso compartido guardada. {name} ya no se comparte contigo.',
  onlyOwnerPrivate: 'Solo {name} puede hacerlo privado',
  add: 'Añadir',
  addTo: 'Añadir a {name}',
  addAnything:
    'Cualquier cosa que puedas abrir. Mantiene su propio acceso: añadirla aquí no la comparte con nadie.',
  couldntAdd: 'No se pudo añadir a {name}.',
  projectReadyChat:
    '{name} está listo y este chat está en él. Quién puede abrir el chat no ha cambiado.',
  projectReadyPrivate: '{name} está listo. Solo tú puedes abrirlo.',
  projectCreatedNotice: '{name} se creó. Todo lo que contiene conserva su propio acceso.',
  latestAnswerYou: 'Estás recibiendo una respuesta',
  latestAnswerOther: '{name} está recibiendo una respuesta',
  inProjectMove: 'En {name}. Mover este chat',
  notInProjectMove: 'No está en un proyecto. Mover este chat',
  movedTo: 'Se movió a',
  accessUnchanged: 'No ha cambiado quién puede abrir este chat.',
  theProject: 'el proyecto',
  in: 'En',
  stopMakingProject: 'Dejar de crear un proyecto nuevo en este chat',
  searchYourWork: 'Buscar en tu trabajo',
  searchDocuments: 'Buscar documentos, archivos y reuniones…',
  yourWork: 'Tu trabajo',
  looking: 'Buscando…',
  nothingMatchesChat:
    'No hay coincidencias. Para traer un chat, ábrelo y usa su ubicación en el encabezado.',
  typeToFind: 'Escribe para buscar trabajo que puedas abrir.',
  newProjectDraft: 'Nuevo proyecto · Borrador {count} · Aún no creado',
  projectCreatedOpen: 'Proyecto creado · Abrirlo',
  aNewProject: 'Un nuevo proyecto',
  draftIntro:
    'Di en el chat en qué consiste el trabajo. Poneva prepara aquí el proyecto, con lo que se incluirá y con quién se compartirá. No se crea nada hasta que lo confirmes.',
  draft: 'Borrador',
  projectCreatedAccess: 'Creado. Todo lo que contiene mantiene su propio acceso.',
  changeInChatDraft: 'Cambia lo que quieras diciéndolo en el chat.',
  chatOwnerCreate: 'Solo la persona propietaria de este chat puede crearlo.',
  open: 'Abrir',
  creating: 'Creando…',
  cannotOpenDraft:
    '{people} no puede abrir {title}, así que sus chats aquí responderían sin ello. Di en el chat si quieres pedir a su propietario que lo comparta o dejarlo fuera.',
  bringsIn: 'Incluye {count}',
  thisChat: 'Este chat',
  takenOutDraft: 'Quitado en el borrador {count}',
  nothingYet: 'Aún no hay nada. Indica en el chat qué debe incluirse aquí.',
  leftOut: 'Fuera: {items}.',
  whoCanUse: 'Quién puede usarlo',
  youLead: 'Tú, responsable',
  beingInProject: 'Estar en el proyecto no abre nada. Cada elemento mantiene su propio acceso.',
  onlyYouUntilShare: 'Seguirá siendo Solo tú hasta que lo compartas.',
  colour: 'Color',
  sand: 'Arena',
  green: 'Verde',
  blue: 'Azul',
  grey: 'Gris',
  firstProject: 'Empieza tu primer proyecto',
  firstProjectDescription:
    'Ponle un nombre y todos los chats que inicies en él leerán el mismo resumen. Incluye el trabajo que ya tienes y compártelo cuando otras personas deban trabajar allí.',
  loadingProjects: 'Cargando proyectos…',
  thisChatMoves: 'Este chat se moverá al proyecto. No cambiará quién puede abrirlo.',
  whatIsWork: '¿En qué consiste el trabajo?',
  optional: 'Opcional',
  writeFromChat: 'Escribir desde este chat',
  briefPlaceholder: 'Para qué sirve, qué reglas seguir y qué fechas tener en cuenta.',
  briefDraftHelp:
    'Todos los chats del proyecto leen esto primero. Escribir desde este chat pide a Poneva que lo prepare junto al chat; tú seguirás eligiendo Crear.',
  briefLaterHelp:
    'Todos los chats del proyecto leen esto primero. Puedes cambiarlo más tarde pidiéndolo en cualquier chat del proyecto.',
  sendClearFirst:
    'Envía o borra primero el mensaje y los archivos adjuntos sin enviar para escribir el resumen desde este chat.',
  createProjectError: 'No se pudo crear el proyecto. Inténtalo de nuevo.',
  onlyYouUntil: 'Solo tú, hasta que lo compartas',
  whereChat: 'Dónde está este chat',
  whereChatHelp:
    'Un chat solo puede estar en un proyecto a la vez. Moverlo nunca cambia quién puede abrirlo.',
  searchCreateProject: 'Buscar o crear un proyecto',
  noProject: 'Sin proyecto',
  inCompanyChats: 'En tus chats de {company}',
  newProjectWithChat: 'Nuevo proyecto con este chat',
  newProjectNamedWithChat: 'Nuevo proyecto «{name}» con este chat',
  makingProject: 'Creando un nuevo proyecto',
  moveToProject: 'Mover este chat a {name}',
  chatInProject: 'Este chat está en {name}.',
  looksLikeWork: 'Parece trabajo de {name}. ¿Quieres moverlo allí?',
  accessBriefNext:
    'No cambiará quién puede abrirlo. Leerá el resumen del proyecto a partir de tu próximo mensaje.',
  moveFailed: 'No se pudo mover. Inténtalo de nuevo o usa su ubicación en el encabezado.',
  accessBriefNextTypographic:
    'No cambiará quién puede abrirlo. Leerá el resumen del proyecto a partir de tu próximo mensaje.',
  openProject: 'Abrir proyecto',
  move: 'Mover',
  movedOut: 'Se ha movido fuera de su proyecto. No cambiará quién puede abrirlo.',
  chatLivesHere: 'Este chat está aquí ahora. No cambiará quién puede abrirlo.',
  addedTo: '{item} añadido a {project}',
  addedAccess: 'Mantiene su propio acceso. Añadirlo aquí no lo comparte con nadie.',
  removedOut:
    '{item} está fuera de {project}. Se queda donde estaba y no cambiará quién puede abrirlo.',
  itIs: 'Es',
  couldntMoveChat: 'No se pudo mover este chat.',
  sharingCheckFailed:
    'No se pudo comprobar quién puede abrir los elementos que se leen primero. Revisa sus permisos antes de compartir este proyecto.',
  cannotOpenShare: '{people} no puede abrir {title}.',
  readsFirstShare:
    'Todos los chats de este proyecto lo leen primero, así que sus chats aquí responderán sin ello. Compartir el proyecto no cambia eso.',
  sharingSavedUnread: 'Uso compartido guardado. No se pudo volver a leer {name} ahora mismo.',
  formerColleague: 'Un antiguo compañero',
  madeInChatHere: 'hecho en un chat de aquí',
  latestStarted: '{name} ha iniciado {title}',
  latestStartedYou: 'Has iniciado {title}',
  latestContinued: '{name} ha continuado {title}',
  latestContinuedYou: 'Has continuado {title}',
  latestMade: '{name} ha hecho {title}',
  latestMadeYou: 'Has hecho {title}',
  latestAdded: '{name} ha añadido {title}',
  latestAddedYou: 'Has añadido {title}',
  projectChipLives:
    'Este chat está en {name} y lee su resumen. Muévelo desde la primera parte del encabezado.',
  addExistingWork: 'Añade el trabajo que ya tienes',
  nameLabel: 'Nombre',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} elemento',
  itemsMany: '{count} elementos',
  itemsAllStillHere: '{items}, todos siguen aquí',
  projectsOverviewDescription:
    'Un lugar para cada trabajo. Poner algo en un proyecto nunca cambia quién puede abrirlo.',
  noProjectMatchesHint: 'Ningún proyecto coincide. Prueba con una palabra de su nombre o resumen.',
  aboutProject: 'Acerca de este proyecto',
  aboutShort: 'Acerca de',
  workingIn: 'Trabajando en {name}',
  noBriefHome:
    'Aún no hay resumen. Di en un chat de aquí en qué consiste el trabajo; todos los chats del proyecto lo leen primero.',
  tabAll: 'Todo',
  tabChats: 'Chats',
  tabResults: 'Resultados',
  tabFiles: 'Archivos',
  emptyChats: 'Aún no hay chats aquí. Inicia uno arriba.',
  emptyResults: 'Aún no se ha hecho nada aquí. Lo que hagas en un chat de aquí aparecerá aquí.',
  emptyFiles:
    'Aún no hay archivos aquí. Los archivos que añadas en un chat de aquí aparecerán aquí.',
  showTabs: 'Mostrar',
  newestShown: 'Aquí se muestran los {shown} más recientes de {count}.',
  nothingHereYet: 'Aún no hay nada aquí.',
  homeEmptyHelp:
    'Los chats que inicies arriba aparecerán aquí, igual que los archivos que añadas y los resultados que hagas en ellos.',
  shareWithPeopleDoingIt: 'Compartir con quienes lo hacen',
  briefWrittenBy: '{version} · escrito por {name}, {when}',
  briefChangedBy: '{version} · modificado por {name}, {when}',
  personWorksInIt: '{people} trabaja en él.',
  peopleWorkInIt: '{people} trabajan en él.',
  aboutUnavailable:
    'Este proyecto no está disponible. Puede que se haya eliminado o que no esté compartido contigo.',
  landedIn: 'En {name} · {access}',
  landedOnlyYou: 'Solo tú puedes abrirlo',
  youWorkInIt: 'Tú trabajas en él.',
  youAndPeopleWorkInIt: 'Tú y {people} trabajáis en él.',
  landedCompanyCanOpen: 'Todos en {company} pueden abrirlo',
  landedMembersCanOpen: 'Los colegas seleccionados pueden abrirlo',
  briefWrittenByYou: '{version} · escrito por ti, {when}',
  briefChangedByYou: '{version} · modificado por ti, {when}',
  briefWrittenByFormer: '{version} · escrito por un antiguo compañero, {when}',
  briefChangedByFormer: '{version} · modificado por un antiguo compañero, {when}',
  addedByFormer: 'añadido por un antiguo compañero',
  formerColleagueLeadsIt: 'Un antiguo compañero lo dirige.',
  projectLoadFailed: 'No se pudo cargar este proyecto.',
  personCannotOpenWithout:
    '{people} no puede abrir esto, así que sus chats aquí responden sin ello.',
  peopleCannotOpenWithout:
    '{people} no pueden abrir esto, así que sus chats aquí responden sin ello.',
};
const et: Copy = {
  projects: 'Projektid',
  newProject: 'Uus projekt',
  searchProjects: 'Otsi projekte',
  finished: 'Lõpetatud',
  people: 'Inimesed',
  skill: 'Oskus',
  noBrief: 'Kokkuvõtet veel pole.',
  createProject: 'Loo projekt',
  knowledgePages: 'Teadmiste lehed',
  searchPages: 'Otsi lehti',
  formatting: 'Vormindus',
  pageTitle: 'Lehe pealkiri',
  suggestions: 'Soovitused',
  current: 'Praegune',
  agent: 'Agent',
  runs: 'Käivitused',
  goal: 'Eesmärk',
  instructions: 'Juhised',
  noRuns: 'Käivitusi veel pole.',
  runNow: 'Käivita nüüd',
  schedule: 'Ajakava',
  editors: 'Toimetajad',
  now: 'Praegu',
  moreFor: 'Veel {name} jaoks',
  brief: 'Ülevaade',
  version: 'Versioon {count}',
  noBriefLong:
    'Ülevaadet pole veel. Ütle vestluses, millega see töö tegeleb ja millised on selle reeglid.',
  changeInChat: 'Muuda vestluses',
  everyChatFollows: 'Iga siinne vestlus järgib',
  andReadsFirst: 'Ja loeb esmalt',
  file: 'Fail',
  knowledge: 'Teadmised',
  youLeadIt: 'Sina juhid seda.',
  personLeadsIt: '{name} juhib seda.',
  everyoneAtCanFind: 'Kõik ettevõttes {company} leiavad selle üles.',
  shareWhenOthers: 'Jaga seda, kui teised peaksid siin töötama.',
  projectAccessNote:
    'Projektis olemine ei anna millelegi juurdepääsu. Igal üksusel on oma juurdepääs ning siinsed vestlused toimuvad need alustanud inimese nimel.',
  project: 'Projekt',
  needsYou: 'Vajab sinu tähelepanu',
  review: 'Ülevaatamine',
  inThisProject: 'Selles projektis',
  deleteQuestion: 'Kas kustutada {name}?',
  deleteDescription:
    'Kaob ainult projekt. Selle vestlused, failid ja tulemused jäävad neid omavatele inimestele sinna, kus need enne olid.',
  deleteConfirm: 'Kustuta {name}',
  projectDeleted: '{name} on kustutatud. Selle vestlused ja töö jäävad alles sinna, kus need olid.',
  couldntDelete: '{name} kustutamine ebaõnnestus.',
  moveOutProject: 'Teisalda projektist välja',
  takeOutProject: 'Eemalda projektist',
  unavailableTitle: 'See projekt pole saadaval',
  unavailableDescription:
    'See võidi kustutada või pole seda sinuga jagatud. Sinu jaoks pole selles midagi muutunud.',
  allProjects: 'Kõik projektid',
  openingProject: 'Projekti avamine…',
  ended: 'Lõppenud',
  ends: 'Lõpeb',
  yesterday: 'Eile',
  roleLead: 'Juht',
  roleCanEdit: 'Saab muuta',
  roleCanUse: 'Saab kasutada',
  visibilityCompany: 'Kõik ettevõttes {company}',
  visibilityMembers: 'Valitud kolleegid',
  visibilityPrivate: 'Ainult sina',
  kindApp: 'Rakendus',
  kindDeck: 'Esitlus',
  kindSheet: 'Tabel',
  kindChart: 'Diagramm',
  kindDashboard: 'Juhtpaneel',
  kindReport: 'Aruanne',
  kindChat: 'Vestlus',
  kindFile: 'Fail',
  kindMeeting: 'Koosolek',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Sina',
  gettingAnswer: 'Vastuse saamine',
  gettingAnswerOther: '{name} saab vastust',
  addedByYou: 'lisasid sina',
  addedByOther: 'lisas {name}',
  itemOutSuccess: '{item} eemaldati projektist {project}. Midagi muud ei muudetud.',
  itemOutError: '{item} eemaldamine projektist {project} ebaõnnestus.',
  renameProjectDescription: 'Nimeta see ümber, muuda ülevaadet või lõppkuupäeva',
  deleteProject: 'Kustuta projekt',
  openToShare: 'Ava jagamiseks',
  sharingSaved: 'Jagamise muudatused salvestati. {name} ei ole enam teiega jagatud.',
  onlyOwnerPrivate: 'Ainult {name} saab selle privaatseks muuta',
  add: 'Lisa',
  addTo: 'Lisa üksusele {name}',
  addAnything:
    'Kõik, mida saad avada. Selle juurdepääs jääb samaks: siia lisamine ei jaga seda kellegagi.',
  couldntAdd: '{name} lisamine ebaõnnestus.',
  projectReadyChat:
    '{name} on valmis ja see vestlus on selles. Vestluse avamise õigus pole muutunud.',
  projectReadyPrivate: '{name} on valmis. Ainult sina saad selle avada.',
  projectCreatedNotice:
    '{name} on loodud. Kõigil selles olevatel üksustel säilivad oma juurdepääsuõigused.',
  latestAnswerYou: 'Sulle koostatakse vastust',
  latestAnswerOther: 'Kasutajale {name} koostatakse vastust',
  inProjectMove: 'Asukohas {name}. Teisalda see vestlus',
  notInProjectMove: 'Projekt puudub. Teisalda see vestlus',
  movedTo: 'Teisaldatud asukohta',
  accessUnchanged: 'Selle vestluse avamise õigused pole muutunud.',
  theProject: 'projekt',
  in: 'Asukohas',
  stopMakingProject: 'Lõpeta selles vestluses uue projekti loomine',
  searchYourWork: 'Otsi oma tööst',
  searchDocuments: 'Otsi dokumente, faile ja koosolekuid…',
  yourWork: 'Sinu töö',
  looking: 'Otsin…',
  nothingMatchesChat:
    'Sobivat ei leitud. Vestluse kaasamiseks ava see ja kasuta päises olevat asukohta.',
  typeToFind: 'Sisesta, et leida avatavat tööd.',
  newProjectDraft: 'Uus projekt · Mustand {count} · Pole veel loodud',
  projectCreatedOpen: 'Projekt loodud · Ava see',
  aNewProject: 'Uus projekt',
  draftIntro:
    'Ütle vestluses, milles töö seisneb. Poneva koostab siia projekti, lisades selle, mida kaasata, ja inimesed, kellega jagada. Midagi ei looda enne, kui seda ütled.',
  draft: 'Mustand',
  projectCreatedAccess: 'Loodud. Kõigi selles olevate üksuste juurdepääs jääb samaks.',
  changeInChatDraft: 'Muuda midagi, öeldes seda vestluses.',
  chatOwnerCreate: 'Selle saab luua ainult selle vestluse omanik.',
  open: 'Ava',
  creating: 'Loon…',
  cannotOpenDraft:
    '{people} ei saa avada üksust {title}, seega vastaksid nende siinsed vestlused ilma selleta. Ütle vestluses, kas paluda selle omanikul juurdepääsu jagada või jätta see välja.',
  bringsIn: 'Kaasab {count}',
  thisChat: 'See vestlus',
  takenOutDraft: 'Mustandis {count} välja jäetud',
  nothingYet: 'Veel mitte midagi. Ütle vestluses, mis siia kuulub.',
  leftOut: 'Välja jäetud: {items}.',
  whoCanUse: 'Kes saab seda kasutada',
  youLead: 'Sina, eestvedaja',
  beingInProject: 'Projektis olemine ei ava midagi. Kõigi üksuste juurdepääs jääb samaks.',
  onlyYouUntilShare: 'See on ainult sinu jaoks, kuni seda jagad.',
  colour: 'Värv',
  sand: 'Liiv',
  green: 'Roheline',
  blue: 'Sinine',
  grey: 'Hall',
  firstProject: 'Alusta oma esimest projekti',
  firstProjectDescription:
    'Pane sellele nimi ja iga selles alustatud vestlus loeb sama lähteülevaadet. Kaasa juba olemasolev töö ja jaga seda siis, kui teised peaksid seal töötama.',
  loadingProjects: 'Laadin projekte…',
  thisChatMoves: 'See vestlus liigub projekti. See, kes seda avada saab, ei muutu.',
  whatIsWork: 'Mis tööga on tegu?',
  optional: 'Valikuline',
  writeFromChat: 'Koosta selle vestluse põhjal',
  briefPlaceholder: 'Milleks see on, milliseid reegleid järgida ja millised kuupäevad on olulised.',
  briefDraftHelp:
    'Iga projekti vestlus loeb seda esmalt. Selle vestluse põhjal koostamine palub Poneval selle vestluse kõrvale mustandi teha; sina otsustad endiselt, kas valida „Loo“ või mitte.',
  briefLaterHelp:
    'Iga projekti vestlus loeb seda esmalt. Muuda seda hiljem, paludes seda mõnes sealses vestluses.',
  sendClearFirst:
    'Lähteülevaate koostamiseks selle vestluse põhjal saada või kustuta esmalt saatmata sõnum ja manused.',
  createProjectError: 'Projekti ei saanud luua. Proovi uuesti.',
  onlyYouUntil: 'Ainult sinu jaoks, kuni seda jagad',
  whereChat: 'Kus see vestlus asub',
  whereChatHelp:
    'Vestlus saab korraga asuda ainult ühes projektis. Selle teisaldamine ei muuda seda, kes saab seda avada.',
  searchCreateProject: 'Otsi projekti või loo see',
  noProject: 'Projekt puudub',
  inCompanyChats: 'Vestlustes ettevõttes {company}',
  newProjectWithChat: 'Uus projekt selle vestlusega',
  newProjectNamedWithChat: 'Uus projekt „{name}“ selle vestlusega',
  makingProject: 'Loon uut projekti',
  moveToProject: 'Teisalda see vestlus projekti {name}',
  chatInProject: 'See vestlus on projektis {name}.',
  looksLikeWork: 'See näib olevat töö projektis {name}. Kas teisaldada see sinna?',
  accessBriefNext:
    'See, kes seda avada saab, ei muutu. Alates sinu järgmisest sõnumist loeb vestlus projekti lähteülevaadet.',
  moveFailed: 'Seda ei saanud teisaldada. Proovi uuesti või kasuta päises olevat asukohta.',
  accessBriefNextTypographic:
    'See, kes seda avada saab, ei muutu. Alates sinu järgmisest sõnumist loeb vestlus projekti lähteülevaadet.',
  openProject: 'Ava projekt',
  move: 'Teisalda',
  movedOut: 'Teisaldatud projektist välja. See, kes seda avada saab, ei muutu.',
  chatLivesHere: 'See vestlus asub nüüd siin. See, kes seda avada saab, ei muutu.',
  addedTo: '{item} lisati projekti {project}',
  addedAccess: 'Selle juurdepääs jääb samaks. Siia lisamine ei jaga seda kellegagi.',
  removedOut:
    '{item} eemaldati projektist {project}. See jääb sinna, kus asub, ja see, kes seda avada saab, ei muutu.',
  itIs: 'See on',
  couldntMoveChat: 'Seda vestlust ei saanud teisaldada.',
  sharingCheckFailed:
    'Ei saanud kontrollida, kes saab avada esmalt loetavaid üksusi. Vaata nende juurdepääs enne selle projekti jagamist üle.',
  cannotOpenShare: '{people} ei saa avada üksust {title}.',
  readsFirstShare:
    'Iga projekti vestlus loeb seda esmalt, seega vastavad nende siinsed vestlused selle sisuta. Projekti jagamine seda ei muuda.',
  sharingSavedUnread: 'Jagamine salvestati. Üksust {name} ei õnnestunud praegu uuesti lugeda.',
  formerColleague: 'Endine kolleeg',
  madeInChatHere: 'tehtud siin vestluses',
  latestStarted: '{name} alustas: {title}',
  latestStartedYou: 'Sina alustasid: {title}',
  latestContinued: '{name} jätkas: {title}',
  latestContinuedYou: 'Sina jätkasid: {title}',
  latestMade: '{name} tegi: {title}',
  latestMadeYou: 'Sina tegid: {title}',
  latestAdded: '{name} lisas: {title}',
  latestAddedYou: 'Sina lisasid: {title}',
  projectChipLives:
    'See vestlus asub projektis {name} ja loeb selle ülevaadet. Teisalda see päise esimesest osast.',
  addExistingWork: 'Lisa töö, mis sul juba on',
  nameLabel: 'Nimi',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} üksus',
  itemsMany: '{count} üksust',
  itemsAllStillHere: '{items}, kõik alles',
  projectsOverviewDescription:
    'Üks koht iga töö jaoks. Projekti lisamine ei muuda kunagi seda, kes selle avada saab.',
  noProjectMatchesHint: 'Ükski projekt ei sobi. Proovi sõna nimest või ülevaatest.',
  aboutProject: 'Selle projekti kohta',
  aboutShort: 'Info',
  workingIn: 'Töötad projektis {name}',
  noBriefHome:
    'Ülevaadet veel pole. Ütle siinses vestluses, mis töö see on; iga projekti vestlus loeb seda esimesena.',
  tabAll: 'Kõik',
  tabChats: 'Vestlused',
  tabResults: 'Tulemused',
  tabFiles: 'Failid',
  emptyChats: 'Vestlusi veel pole. Alusta ülal üks.',
  emptyResults: 'Siin pole veel midagi tehtud. Mida siinses vestluses teed, jõuab siia.',
  emptyFiles: 'Faile veel pole. Failid, mille siinses vestluses lisad, jõuavad siia.',
  showTabs: 'Näita',
  newestShown: 'Siin on näha {count} uusimast {shown}.',
  nothingHereYet: 'Siin pole veel midagi.',
  homeEmptyHelp:
    'Ülal alustatud vestlused jõuavad siia, samuti neis lisatud failid ja tehtud tulemused.',
  shareWithPeopleDoingIt: 'Jaga töö tegijatega',
  briefWrittenBy: '{version} · kirjutas {name}, {when}',
  briefChangedBy: '{version} · muutis {name}, {when}',
  personWorksInIt: '{people} töötab selles.',
  peopleWorkInIt: '{people} töötavad selles.',
  aboutUnavailable: 'See projekt pole saadaval. See võib olla kustutatud või pole sinuga jagatud.',
  landedIn: 'Projektis {name} · {access}',
  landedOnlyYou: 'Ainult sina saad selle avada',
  youWorkInIt: 'Sina töötad selles.',
  youAndPeopleWorkInIt: 'Sina ja {people} töötate selles.',
  landedCompanyCanOpen: 'Kõik ettevõttes {company} saavad selle avada',
  landedMembersCanOpen: 'Valitud kolleegid saavad selle avada',
  briefWrittenByYou: '{version} · kirjutasid sina, {when}',
  briefChangedByYou: '{version} · muutsid sina, {when}',
  briefWrittenByFormer: '{version} · kirjutas endine kolleeg, {when}',
  briefChangedByFormer: '{version} · muutis endine kolleeg, {when}',
  addedByFormer: 'lisas endine kolleeg',
  formerColleagueLeadsIt: 'Endine kolleeg juhib seda.',
  projectLoadFailed: 'Seda projekti ei õnnestunud laadida.',
  personCannotOpenWithout:
    '{people} ei saa seda avada, seega saavad tema siinsed vestlused vastuseid ilma selleta.',
  peopleCannotOpenWithout:
    '{people} ei saa seda avada, seega saavad nende siinsed vestlused vastuseid ilma selleta.',
};
const fi: Copy = {
  projects: 'Projektit',
  newProject: 'Uusi projekti',
  searchProjects: 'Hae projekteja',
  finished: 'Valmiit',
  people: 'Ihmiset',
  skill: 'Taito',
  noBrief: 'Ohjetta ei ole vielä.',
  createProject: 'Luo projekti',
  knowledgePages: 'Tietosivut',
  searchPages: 'Hae sivuja',
  formatting: 'Muotoilu',
  pageTitle: 'Sivun otsikko',
  suggestions: 'Ehdotukset',
  current: 'Nykyinen',
  agent: 'Agentti',
  runs: 'Suoritukset',
  goal: 'Tavoite',
  instructions: 'Ohjeet',
  noRuns: 'Suorituksia ei vielä ole.',
  runNow: 'Suorita nyt',
  schedule: 'Ajoitus',
  editors: 'Muokkaajat',
  now: 'Nyt',
  moreFor: 'Lisää kohteelle {name}',
  brief: 'Ohjeistus',
  version: 'Versio {count}',
  noBriefLong:
    'Ohjeistusta ei vielä ole. Kerro keskustelussa, mitä tämä työ on ja mitä sääntöjä siihen liittyy.',
  changeInChat: 'Muuta keskustelussa',
  everyChatFollows: 'Jokainen tämän projektin chat noudattaa',
  andReadsFirst: 'Ja lukee ensin',
  file: 'Tiedosto',
  knowledge: 'Tietopohja',
  youLeadIt: 'Sinä johdat sitä.',
  personLeadsIt: '{name} johtaa sitä.',
  everyoneAtCanFind: 'Kaikki yrityksessä {company} voivat löytää sen.',
  shareWhenOthers: 'Jaa se, kun muiden pitäisi työskennellä täällä.',
  projectAccessNote:
    'Projektin jäsenyys ei avaa mitään. Jokaisella kohteella on omat käyttöoikeutensa, ja täällä käytävät keskustelut käydään niiden aloittajan oikeuksilla.',
  project: 'Projekti',
  needsYou: 'Vaatii sinua',
  review: 'Tarkista',
  inThisProject: 'Tässä projektissa',
  deleteQuestion: 'Poistetaanko {name}?',
  deleteDescription:
    'Vain projekti poistuu. Sen keskustelut, tiedostot ja tulokset säilyvät omistajillaan siellä, missä ne olivat aiemmin.',
  deleteConfirm: 'Poista {name}',
  projectDeleted: '{name} on poistettu. Sen keskustelut ja työ säilyvät ennallaan.',
  couldntDelete: 'Kohteen {name} poistaminen ei onnistunut.',
  itemOutSuccess: '{item} poistettiin projektista {project}. Mikään muu ei muuttunut.',
  itemOutError: 'Kohteen {item} poistaminen projektista {project} ei onnistunut.',
  moveOutProject: 'Siirrä pois projektista',
  takeOutProject: 'Poista projektista',
  unavailableTitle: 'Tämä projekti ei ole käytettävissä',
  unavailableDescription:
    'Se on ehkä poistettu tai sitä ei ole jaettu kanssasi. Mikään sen sisältö ei muuttunut sinun osaltasi.',
  allProjects: 'Kaikki projektit',
  openingProject: 'Avataan projektia…',
  ended: 'Päättynyt',
  ends: 'Päättyy',
  yesterday: 'Eilen',
  roleLead: 'Johtaja',
  roleCanEdit: 'Voi muokata',
  roleCanUse: 'Voi käyttää',
  visibilityCompany: 'Kaikki yrityksessä {company}',
  visibilityMembers: 'Valitut työtoverit',
  visibilityPrivate: 'Vain sinä',
  kindApp: 'Sovellus',
  kindDeck: 'Esitys',
  kindSheet: 'Taulukko',
  kindChart: 'Kaavio',
  kindDashboard: 'Kojelauta',
  kindReport: 'Raportti',
  kindChat: 'Keskustelu',
  kindFile: 'Tiedosto',
  kindMeeting: 'Kokous',
  kindAgent: 'Agentti',
  kindDocument: 'Asiakirja',
  you: 'Sinä',
  gettingAnswer: 'Haetaan vastausta',
  gettingAnswerOther: '{name} hakee vastausta',
  addedByYou: 'sinun lisäämäsi',
  addedByOther: 'käyttäjän {name} lisäämä',
  renameProjectDescription: 'Nimeä projekti uudelleen tai muuta ohjeistusta tai päättymispäivää',
  deleteProject: 'Poista projekti',
  openToShare: 'Avaa jakaaksesi',
  sharingSaved: 'Jakamisasetukset tallennettu. {name} ei ole enää jaettu kanssasi.',
  onlyOwnerPrivate: 'Vain {name} voi tehdä siitä yksityisen',
  add: 'Lisää',
  addTo: 'Lisää kohteeseen {name}',
  addAnything:
    'Kaikki, minkä voit avata. Sen käyttöoikeudet säilyvät ennallaan: sen lisääminen tänne ei jaa sitä kenellekään.',
  couldntAdd: 'Kohdetta {name} ei voitu lisätä.',
  projectReadyChat:
    '{name} on valmis, ja tämä keskustelu on siinä. Keskustelun käyttöoikeudet eivät muuttuneet.',
  projectReadyPrivate: '{name} on valmis. Vain sinä voit avata sen.',
  projectCreatedNotice: '{name} on luotu. Kaiken sen sisältämän käyttöoikeudet säilyvät ennallaan.',
  latestAnswerYou: 'Saat parhaillaan vastausta',
  latestAnswerOther: '{name} saa parhaillaan vastausta',
  inProjectMove: 'Projektissa {name}. Siirrä tämä keskustelu',
  notInProjectMove: 'Ei projektissa. Siirrä tämä keskustelu',
  movedTo: 'Siirretty kohteeseen',
  accessUnchanged: 'Tämän keskustelun avaamisoikeudet eivät ole muuttuneet.',
  theProject: 'projekti',
  in: 'Kohteessa',
  stopMakingProject: 'Lopeta uuden projektin luominen tässä keskustelussa',
  searchYourWork: 'Hae töistäsi',
  searchDocuments: 'Hae asiakirjoista, tiedostoista ja kokouksista…',
  yourWork: 'Työsi',
  looking: 'Haetaan…',
  nothingMatchesChat: 'Ei osumia. Tuo chat avaamalla se ja käyttämällä otsakkeen sijaintia.',
  typeToFind: 'Etsi avattavaa työtä kirjoittamalla.',
  newProjectDraft: 'Uusi projekti · Luonnos {count} · Ei vielä luotu',
  projectCreatedOpen: 'Projekti luotu · Avaa se',
  aNewProject: 'Uusi projekti',
  draftIntro:
    'Kerro chatissa, mitä työ pitää sisällään. Poneva laatii projektin tänne sekä ehdottaa, mitä siihen tuodaan ja kenen kanssa se jaetaan. Mitään ei luoda, ennen kuin vahvistat sen.',
  draft: 'Luonnos',
  projectCreatedAccess: 'Luotu. Kaikkien sisältöjen omat käyttöoikeudet säilyvät ennallaan.',
  changeInChatDraft: 'Muuta mitä tahansa kertomalla siitä chatissa.',
  chatOwnerCreate: 'Vain tämän chatin omistaja voi luoda sen.',
  open: 'Avaa',
  creating: 'Luodaan…',
  cannotOpenDraft:
    '{people} eivät voi avata kohdetta {title}, joten heidän chatinsa täällä vastaisivat ilman sitä. Kerro chatissa, pyydetäänkö sen omistajaa jakamaan se vai jätetäänkö se pois.',
  bringsIn: 'Tuo mukaan {count}',
  thisChat: 'Tämä chat',
  takenOutDraft: 'Poistettu luonnoksessa {count}',
  nothingYet: 'Ei vielä mitään. Kerro chatissa, mikä tänne kuuluu.',
  leftOut: 'Jätetty pois: {items}.',
  whoCanUse: 'Kuka voi käyttää',
  youLead: 'Sinä, vetäjä',
  beingInProject:
    'Projektissa oleminen ei avaa mitään. Kunkin kohteen omat käyttöoikeudet säilyvät ennallaan.',
  onlyYouUntilShare: 'Se näkyy vain sinulle, kunnes jaat sen.',
  colour: 'Väri',
  sand: 'Hiekka',
  green: 'Vihreä',
  blue: 'Sininen',
  grey: 'Harmaa',
  firstProject: 'Aloita ensimmäinen projektisi',
  firstProjectDescription:
    'Anna sille nimi, niin jokainen siinä aloittamasi chat käyttää samaa ohjetta. Tuo mukaan jo olemassa oleva työ ja jaa se, kun muiden pitää työskennellä siellä.',
  loadingProjects: 'Ladataan projekteja…',
  thisChatMoves: 'Tämä chat siirretään projektiin. Se, kuka voi avata sen, ei muutu.',
  whatIsWork: 'Mitä työ koskee?',
  optional: 'Valinnainen',
  writeFromChat: 'Kirjoita tästä chatista',
  briefPlaceholder:
    'Mihin sitä käytetään, mitä sääntöjä noudatetaan ja mitkä päivämäärät ovat tärkeitä.',
  briefDraftHelp:
    'Jokainen projektin chat lukee tämän ensin. Kirjoita tästä chatista pyytää Ponevaa laatimaan sen chatin viereen; valitset silti itse Luo.',
  briefLaterHelp:
    'Jokainen projektin chat lukee tämän ensin. Muuta sitä myöhemmin pyytämällä muutosta missä tahansa projektin chatissa.',
  sendClearFirst:
    'Lähetä tai tyhjennä lähettämätön viestisi ja liitteesi ensin, jotta voit kirjoittaa ohjeen tästä chatista.',
  createProjectError: 'Projektia ei voitu luoda. Yritä uudelleen.',
  onlyYouUntil: 'Vain sinä, kunnes jaat sen',
  whereChat: 'Missä tämä chat sijaitsee',
  whereChatHelp:
    'Chat voi olla kerrallaan vain yhdessä projektissa. Sen siirtäminen ei muuta sitä, kuka voi avata sen.',
  searchCreateProject: 'Hae projektia tai luo projekti',
  noProject: 'Ei projektia',
  inCompanyChats: 'Keskusteluissasi yrityksessä {company}',
  newProjectWithChat: 'Uusi projekti tämän chatin kanssa',
  newProjectNamedWithChat: 'Uusi projekti ”{name}” tämän chatin kanssa',
  makingProject: 'Luodaan uutta projektia',
  moveToProject: 'Siirrä tämä chat kohteeseen {name}',
  chatInProject: 'Tämä chat on kohteessa {name}.',
  looksLikeWork: 'Tämä näyttää {name}-työltä. Siirretäänkö se sinne?',
  accessBriefNext:
    'Se, kuka voi avata sen, ei ole muuttunut. Chat lukee projektin ohjeen seuraavasta viestistäsi alkaen.',
  moveFailed: 'Siirtäminen ei onnistunut. Yritä uudelleen tai käytä otsakkeen sijaintia.',
  accessBriefNextTypographic:
    'Se, kuka voi avata sen, ei muutu. Chat lukee projektin ohjeen seuraavasta viestistäsi alkaen.',
  openProject: 'Avaa projekti',
  move: 'Siirrä',
  movedOut: 'Siirretty pois projektista. Se, kuka voi avata sen, ei ole muuttunut.',
  chatLivesHere: 'Tämä chat on nyt täällä. Se, kuka voi avata sen, ei ole muuttunut.',
  addedTo: 'Lisätty kohde {item} projektiin {project}',
  addedAccess:
    'Sen omat käyttöoikeudet säilyvät ennallaan. Sen lisääminen tänne ei jaa sitä kenellekään.',
  removedOut:
    '{item} poistettiin projektista {project}. Se pysyy siellä, missä se sijaitsee, eikä se, kuka voi avata sen, ole muuttunut.',
  itIs: 'Se on',
  couldntMoveChat: 'Tätä chatia ei voitu siirtää.',
  sharingCheckFailed:
    'Sen tarkistaminen, kuka voi avata ensin luettavat kohteet, ei onnistunut. Tarkista niiden käyttöoikeudet ennen tämän projektin jakamista.',
  cannotOpenShare: '{people} eivät voi avata kohdetta {title}.',
  readsFirstShare:
    'Jokainen tämän projektin chat lukee sen ensin, joten chatit täällä vastaavat ilman sitä. Projektin jakaminen ei muuta tätä.',
  sharingSavedUnread:
    'Jakaminen tallennettiin. Kohdetta {name} ei voitu juuri nyt lukea uudelleen.',
  formerColleague: 'Entinen kollega',
  madeInChatHere: 'tehty täällä keskustelussa',
  latestStarted: '{name} aloitti: {title}',
  latestStartedYou: 'Aloitit: {title}',
  latestContinued: '{name} jatkoi: {title}',
  latestContinuedYou: 'Jatkoit: {title}',
  latestMade: '{name} teki: {title}',
  latestMadeYou: 'Teit: {title}',
  latestAdded: '{name} lisäsi: {title}',
  latestAddedYou: 'Lisäsit: {title}',
  projectChipLives:
    'Tämä keskustelu kuuluu projektiin {name} ja lukee sen ohjeistuksen. Siirrä se otsikon ensimmäisestä osasta.',
  addExistingWork: 'Lisää työ, joka sinulla jo on',
  nameLabel: 'Nimi',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} kohde',
  itemsMany: '{count} kohdetta',
  itemsAllStillHere: '{items}, kaikki tallessa',
  projectsOverviewDescription:
    'Yksi paikka jokaiselle työlle. Projektiin lisääminen ei koskaan muuta sitä, kuka voi avata kohteen.',
  noProjectMatchesHint: 'Mikään projekti ei täsmää. Kokeile sanaa nimestä tai ohjeistuksesta.',
  aboutProject: 'Tietoja projektista',
  aboutShort: 'Tietoja',
  workingIn: 'Työskentelet projektissa {name}',
  noBriefHome:
    'Ei vielä ohjeistusta. Kerro täällä keskustelussa, mistä työssä on kyse; jokainen projektin keskustelu lukee sen ensin.',
  tabAll: 'Kaikki',
  tabChats: 'Keskustelut',
  tabResults: 'Tulokset',
  tabFiles: 'Tiedostot',
  emptyChats: 'Ei vielä keskusteluja. Aloita yksi yllä.',
  emptyResults: 'Täällä ei ole vielä mitään tehtyä. Täällä keskustelussa tekemäsi päätyy tänne.',
  emptyFiles: 'Ei vielä tiedostoja. Täällä keskustelussa lisäämäsi tiedostot päätyvät tänne.',
  showTabs: 'Näytä',
  newestShown: '{count} uusimmasta näytetään tässä {shown}.',
  nothingHereYet: 'Täällä ei ole vielä mitään.',
  homeEmptyHelp:
    'Yllä aloittamasi keskustelut päätyvät tänne, samoin niihin lisäämäsi tiedostot ja niissä tekemäsi tulokset.',
  shareWithPeopleDoingIt: 'Jaa työtä tekevien kanssa',
  briefWrittenBy: '{version} · kirjoittaja {name}, {when}',
  briefChangedBy: '{version} · muuttanut {name}, {when}',
  personWorksInIt: '{people} työskentelee siinä.',
  peopleWorkInIt: '{people} työskentelevät siinä.',
  aboutUnavailable:
    'Tämä projekti ei ole käytettävissä. Se on voitu poistaa, tai sitä ei ole jaettu sinulle.',
  landedIn: 'Projektissa {name} · {access}',
  landedOnlyYou: 'Vain sinä voit avata sen',
  youWorkInIt: 'Sinä työskentelet siinä.',
  youAndPeopleWorkInIt: 'Sinä ja {people} työskentelette siinä.',
  landedCompanyCanOpen: 'Kaikki yrityksessä {company} voivat avata sen',
  landedMembersCanOpen: 'Valitut työtoverit voivat avata sen',
  briefWrittenByYou: '{version} · sinun kirjoittamasi, {when}',
  briefChangedByYou: '{version} · sinun muuttamasi, {when}',
  briefWrittenByFormer: '{version} · entisen kollegan kirjoittama, {when}',
  briefChangedByFormer: '{version} · entisen kollegan muuttama, {when}',
  addedByFormer: 'entisen kollegan lisäämä',
  formerColleagueLeadsIt: 'Entinen kollega johtaa sitä.',
  projectLoadFailed: 'Projektia ei voitu ladata.',
  personCannotOpenWithout:
    '{people} ei voi avata tätä, joten hänen keskustelunsa täällä eivät voi hyödyntää sitä.',
  peopleCannotOpenWithout:
    '{people} eivät voi avata tätä, joten heidän keskustelunsa täällä eivät voi hyödyntää sitä.',
};
const fr: Copy = {
  projects: 'Projets',
  newProject: 'Nouveau projet',
  searchProjects: 'Rechercher des projets',
  finished: 'Terminés',
  people: 'Personnes',
  skill: 'Compétence',
  noBrief: 'Aucun brief pour le moment.',
  createProject: 'Créer le projet',
  knowledgePages: 'Pages de connaissances',
  searchPages: 'Rechercher des pages',
  formatting: 'Mise en forme',
  pageTitle: 'Titre de la page',
  suggestions: 'Suggestions',
  current: 'Actuel',
  agent: 'Agent',
  runs: 'Exécutions',
  goal: 'Objectif',
  instructions: 'Instructions',
  noRuns: 'Aucune exécution pour le moment.',
  runNow: 'Exécuter maintenant',
  schedule: 'Planification',
  editors: 'Éditeurs',
  now: 'Maintenant',
  moreFor: 'Plus pour {name}',
  brief: 'Brief',
  version: 'Version {count}',
  noBriefLong:
    'Aucun brief pour le moment. Décrivez dans un chat en quoi consiste ce travail et quelles sont ses règles.',
  changeInChat: 'Modifier dans le chat',
  everyChatFollows: 'Chaque conversation ici suit',
  andReadsFirst: 'Et lit en premier',
  file: 'Fichier',
  knowledge: 'Connaissances',
  youLeadIt: 'Vous le dirigez.',
  personLeadsIt: '{name} le dirige.',
  everyoneAtCanFind: 'Tout le monde chez {company} peut le trouver.',
  shareWhenOthers: 'Partagez-le lorsque d’autres personnes doivent travailler ici.',
  projectAccessNote:
    'Être dans le projet n’ouvre aucun élément. Chaque élément conserve ses propres accès, et les chats ici s’exécutent au nom de la personne qui les démarre.',
  project: 'Projet',
  needsYou: 'Nécessite votre attention',
  review: 'À examiner',
  inThisProject: 'Dans ce projet',
  deleteQuestion: 'Supprimer {name} ?',
  deleteDescription:
    'Seul le projet sera supprimé. Ses chats, fichiers et résultats restent avec les personnes qui en sont propriétaires, à leur emplacement d’origine.',
  deleteConfirm: 'Supprimer {name}',
  projectDeleted: '{name} a été supprimé. Ses chats et son travail restent à leur emplacement.',
  couldntDelete: 'Impossible de supprimer {name}.',
  itemOutSuccess: '{item} a été retiré de {project}. Rien d’autre n’a changé.',
  itemOutError: 'Impossible de retirer {item} de {project}.',
  moveOutProject: 'Sortir du projet',
  takeOutProject: 'Retirer du projet',
  unavailableTitle: 'Ce projet n’est pas disponible',
  unavailableDescription:
    'Il a peut-être été supprimé ou n’a peut-être pas été partagé avec vous. Rien de ce qu’il contient n’a changé pour vous.',
  allProjects: 'Tous les projets',
  openingProject: 'Ouverture du projet…',
  ended: 'Terminé',
  ends: 'Se termine',
  yesterday: 'Hier',
  roleLead: 'Responsable',
  roleCanEdit: 'Peut modifier',
  roleCanUse: 'Peut utiliser',
  visibilityCompany: 'Tout le monde chez {company}',
  visibilityMembers: 'Collègues sélectionnés',
  visibilityPrivate: 'Vous seul',
  kindApp: 'Application',
  kindDeck: 'Présentation',
  kindSheet: 'Feuille de calcul',
  kindChart: 'Graphique',
  kindDashboard: 'Tableau de bord',
  kindReport: 'Rapport',
  kindChat: 'Chat',
  kindFile: 'Fichier',
  kindMeeting: 'Réunion',
  kindAgent: 'Agent',
  kindDocument: 'Document',
  you: 'Vous',
  gettingAnswer: 'Recherche d’une réponse',
  gettingAnswerOther: '{name} recherche une réponse',
  addedByYou: 'ajouté par vous',
  addedByOther: 'ajouté par {name}',
  renameProjectDescription: 'Renommez-le, modifiez le brief ou sa date de fin',
  deleteProject: 'Supprimer le projet',
  add: 'Ajouter',
  addTo: 'Ajouter à {name}',
  addAnything:
    'Tout ce que vous pouvez ouvrir. Chaque élément conserve son propre accès : l’ajouter ici ne le partage avec personne.',
  couldntAdd: "Impossible d'ajouter {name}.",
  projectReadyChat:
    "{name} est prêt et cette conversation y est. Les personnes pouvant ouvrir la conversation n'ont pas changé.",
  projectReadyPrivate: "{name} est prêt. Vous seul pouvez l'ouvrir.",
  projectCreatedNotice: "{name} est créé. Tout ce qu'il contient conserve ses propres accès.",
  latestAnswerYou: 'Vous obtenez une réponse',
  latestAnswerOther: '{name} reçoit une réponse',
  inProjectMove: 'Dans {name}. Déplacer cette discussion',
  notInProjectMove: 'Pas dans un projet. Déplacer cette discussion',
  movedTo: 'Déplacé vers',
  accessUnchanged: 'Les personnes pouvant ouvrir cette discussion n’ont pas changé.',
  theProject: 'le projet',
  in: 'Dans',
  stopMakingProject: 'Ne plus créer de projet dans cette discussion',
  searchYourWork: 'Rechercher dans votre travail',
  searchDocuments: 'Rechercher des documents, fichiers et réunions…',
  yourWork: 'Votre travail',
  looking: 'Recherche en cours…',
  nothingMatchesChat:
    'Aucun résultat. Pour ajouter une conversation, ouvrez-la et utilisez son emplacement dans l’en-tête.',
  typeToFind: 'Saisissez du texte pour trouver du travail que vous pouvez ouvrir.',
  newProjectDraft: 'Nouveau projet · Brouillon {count} · Pas encore créé',
  projectCreatedOpen: 'Projet créé · Ouvrir',
  aNewProject: 'Un nouveau projet',
  draftIntro:
    'Indiquez dans la conversation en quoi consiste le travail. Poneva prépare ici le projet, avec les éléments à ajouter et les personnes avec qui le partager. Rien n’est créé tant que vous ne le demandez pas.',
  draft: 'Brouillon',
  projectCreatedAccess: 'Créé. Chaque élément conserve son propre accès.',
  changeInChatDraft: 'Demandez toute modification dans la conversation.',
  chatOwnerCreate: 'Seule la personne propriétaire de cette conversation peut le créer.',
  open: 'Ouvrir',
  creating: 'Création…',
  cannotOpenDraft:
    '{people} ne peut pas ouvrir {title}, leurs conversations ici répondraient donc sans cet élément. Demandez dans la conversation s’il faut demander à son propriétaire de le partager, ou le laisser de côté.',
  bringsIn: 'Ajoute {count}',
  thisChat: 'Cette conversation',
  takenOutDraft: 'Retiré du brouillon {count}',
  nothingYet: 'Rien pour l’instant. Indiquez dans la conversation ce qui doit figurer ici.',
  leftOut: 'Laissé de côté : {items}.',
  whoCanUse: 'Qui peut l’utiliser',
  youLead: 'Vous, responsable',
  beingInProject:
    'Le fait d’être dans le projet n’ouvre aucun accès. Chaque élément conserve son propre accès.',
  onlyYouUntilShare: 'Il reste accessible à vous seul jusqu’à ce que vous le partagiez.',
  colour: 'Couleur',
  sand: 'Sable',
  green: 'Vert',
  blue: 'Bleu',
  grey: 'Gris',
  firstProject: 'Commencer votre premier projet',
  firstProjectDescription:
    'Nommez-le, et chaque conversation que vous y démarrez lira le même brief. Ajoutez le travail que vous avez déjà, puis partagez-le lorsque d’autres personnes devront y travailler.',
  loadingProjects: 'Chargement des projets…',
  thisChatMoves:
    'Cette conversation sera déplacée dans le projet. Les personnes qui peuvent l’ouvrir ne changent pas.',
  whatIsWork: 'En quoi consiste le travail ?',
  optional: 'Facultatif',
  writeFromChat: 'Le rédiger depuis cette conversation',
  briefPlaceholder: 'Son objectif, les règles à suivre, les dates importantes.',
  briefDraftHelp:
    'Chaque conversation du projet le lit en premier. « Le rédiger depuis cette conversation » demande à Poneva de le préparer à côté de la conversation ; vous choisissez toujours Créer.',
  briefLaterHelp:
    'Chaque conversation du projet le lit en premier. Modifiez-le plus tard en le demandant dans n’importe quelle conversation du projet.',
  sendClearFirst:
    'Envoyez ou effacez d’abord votre message et vos pièces jointes non envoyés pour rédiger le brief depuis cette conversation.',
  createProjectError: 'Impossible de créer le projet. Réessayez.',
  onlyYouUntil: 'Vous uniquement, jusqu’à ce que vous le partagiez',
  whereChat: 'Emplacement de cette conversation',
  whereChatHelp:
    'Une conversation ne peut appartenir qu’à un seul projet à la fois. La déplacer ne change jamais qui peut l’ouvrir.',
  searchCreateProject: 'Rechercher ou créer un projet',
  noProject: 'Aucun projet',
  inCompanyChats: 'Dans vos conversations chez {company}',
  newProjectWithChat: 'Nouveau projet avec cette conversation',
  newProjectNamedWithChat: 'Nouveau projet « {name} » avec cette conversation',
  makingProject: 'Création d’un nouveau projet',
  moveToProject: 'Déplacer cette conversation vers {name}',
  chatInProject: 'Cette conversation se trouve dans {name}.',
  looksLikeWork: 'Cela ressemble au travail {name}. La déplacer ici ?',
  accessBriefNext:
    'Les personnes qui peuvent l’ouvrir ne changent pas. Elle lira le brief du projet à partir de votre prochain message.',
  moveFailed: 'Impossible de la déplacer. Réessayez ou utilisez son emplacement dans l’en-tête.',
  accessBriefNextTypographic:
    'Les personnes qui peuvent l’ouvrir ne changent pas. Elle lira le brief du projet à partir de votre prochain message.',
  openProject: 'Ouvrir le projet',
  move: 'Déplacer',
  movedOut: 'Déplacée hors de son projet. Les personnes qui peuvent l’ouvrir ne changent pas.',
  chatLivesHere:
    'Cette conversation se trouve maintenant ici. Les personnes qui peuvent l’ouvrir ne changent pas.',
  addedTo: '{item} ajouté à {project}',
  addedAccess:
    'Chaque élément conserve son propre accès. L’ajouter ici ne le partage avec personne.',
  removedOut:
    '{item} a été retiré de {project}. Il reste à son emplacement, et les personnes qui peuvent l’ouvrir ne changent pas.',
  itIs: 'Il s’agit de',
  couldntMoveChat: 'Impossible de déplacer cette conversation.',
  sharingCheckFailed:
    'Impossible de vérifier qui peut ouvrir les éléments lus en premier. Vérifiez leurs accès avant de partager ce projet.',
  cannotOpenShare: '{people} ne peut pas ouvrir {title}.',
  readsFirstShare:
    'Chaque conversation de ce projet le lit en premier ; leurs conversations ici répondent donc sans cet élément. Partager le projet ne change rien à cela.',
  openToShare: 'Ouvrez-le pour le partager',
  sharingSaved: 'Partage enregistré. {name} n’est désormais plus partagé avec vous.',
  onlyOwnerPrivate: 'Seul {name} peut le rendre privé',
  sharingSavedUnread: 'Partage enregistré. {name} n’a pas pu être relu à l’instant.',
  formerColleague: 'Un ancien collègue',
  madeInChatHere: 'créé dans un chat ici',
  latestStarted: '{name} a lancé {title}',
  latestStartedYou: 'Vous avez lancé {title}',
  latestContinued: '{name} a poursuivi {title}',
  latestContinuedYou: 'Vous avez poursuivi {title}',
  latestMade: '{name} a créé {title}',
  latestMadeYou: 'Vous avez créé {title}',
  latestAdded: '{name} a ajouté {title}',
  latestAddedYou: 'Vous avez ajouté {title}',
  projectChipLives:
    'Ce chat se trouve dans {name} et lit son brief. Déplacez-le depuis la première partie de l’en-tête.',
  addExistingWork: 'Ajouter un travail existant',
  nameLabel: 'Nom',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} élément',
  itemsMany: '{count} éléments',
  itemsAllStillHere: '{items}, tous toujours là',
  projectsOverviewDescription:
    'Un endroit pour chaque travail. Mettre quelque chose dans un projet ne change jamais qui peut l’ouvrir.',
  noProjectMatchesHint: 'Aucun projet ne correspond. Essayez un mot de son nom ou de son brief.',
  aboutProject: 'À propos de ce projet',
  aboutShort: 'À propos',
  workingIn: 'Vous travaillez dans {name}',
  noBriefHome:
    'Pas encore de brief. Dites dans un chat ici en quoi consiste le travail ; tous les chats du projet le lisent en premier.',
  tabAll: 'Tout',
  tabChats: 'Chats',
  tabResults: 'Résultats',
  tabFiles: 'Fichiers',
  emptyChats: 'Aucun chat ici pour l’instant. Lancez-en un ci-dessus.',
  emptyResults: 'Rien n’a encore été créé ici. Ce que vous créez dans un chat ici arrive ici.',
  emptyFiles:
    'Aucun fichier ici pour l’instant. Les fichiers que vous ajoutez dans un chat ici arrivent ici.',
  showTabs: 'Afficher',
  newestShown: 'Les {shown} plus récents sur {count} sont affichés ici.',
  nothingHereYet: 'Rien ici pour l’instant.',
  homeEmptyHelp:
    'Les chats que vous lancez ci-dessus arrivent ici, tout comme les fichiers que vous ajoutez et les résultats que vous y créez.',
  shareWithPeopleDoingIt: 'Partager avec les personnes concernées',
  briefWrittenBy: '{version} · écrit par {name}, {when}',
  briefChangedBy: '{version} · modifié par {name}, {when}',
  personWorksInIt: '{people} y travaille.',
  peopleWorkInIt: '{people} y travaillent.',
  aboutUnavailable:
    'Ce projet n’est pas disponible. Il a peut-être été supprimé, ou il n’est pas partagé avec vous.',
  landedIn: 'Dans {name} · {access}',
  landedOnlyYou: 'Vous seul pouvez l’ouvrir',
  youWorkInIt: 'Vous y travaillez.',
  youAndPeopleWorkInIt: 'Vous et {people} y travaillez.',
  landedCompanyCanOpen: 'Tout le monde chez {company} peut l’ouvrir',
  landedMembersCanOpen: 'Les collègues sélectionnés peuvent l’ouvrir',
  briefWrittenByYou: '{version} · écrit par vous, {when}',
  briefChangedByYou: '{version} · modifié par vous, {when}',
  briefWrittenByFormer: '{version} · écrit par un ancien collègue, {when}',
  briefChangedByFormer: '{version} · modifié par un ancien collègue, {when}',
  addedByFormer: 'ajouté par un ancien collègue',
  formerColleagueLeadsIt: 'Un ancien collègue le dirige.',
  projectLoadFailed: 'Le projet n’a pas pu être chargé.',
  personCannotOpenWithout:
    '{people} ne peut pas ouvrir cet élément. Ses chats ici y répondent donc sans lui.',
  peopleCannotOpenWithout:
    '{people} ne peuvent pas ouvrir cet élément. Leurs chats ici y répondent donc sans lui.',
};
const ga: Copy = {
  projects: 'Tionscadail',
  newProject: 'Tionscadal nua',
  searchProjects: 'Cuardaigh tionscadail',
  finished: 'Críochnaithe',
  people: 'Daoine',
  skill: 'Scil',
  noBrief: 'Níl achoimre ann fós.',
  createProject: 'Cruthaigh tionscadal',
  knowledgePages: 'Leathanaigh eolais',
  searchPages: 'Cuardaigh leathanaigh',
  formatting: 'Formáidiú',
  pageTitle: 'Teideal an leathanaigh',
  suggestions: 'Moltaí',
  current: 'Reatha',
  agent: 'Gníomhaire',
  runs: 'Ritheanna',
  goal: 'Sprioc',
  instructions: 'Treoracha',
  noRuns: 'Níl aon rith ann fós.',
  runNow: 'Rith anois',
  schedule: 'Sceideal',
  editors: 'Eagarthóirí',
  now: 'Anois',
  moreFor: 'Tuilleadh do {name}',
  brief: 'Achoimre',
  version: 'Leagan {count}',
  noBriefLong:
    'Níl aon achoimre ann fós. Abair i gcomhrá cad é an obair seo agus cad iad na rialacha a bhaineann léi.',
  changeInChat: 'Athraigh sa chomhrá',
  everyChatFollows: 'Leanann gach comhrá anseo',
  andReadsFirst: 'Agus léann sé ar dtús',
  file: 'Comhad',
  knowledge: 'Eolas',
  youLeadIt: 'Is tusa a stiúrann é.',
  personLeadsIt: 'Is é {name} a stiúrann é.',
  everyoneAtCanFind: 'Is féidir le gach duine ag {company} é a aimsiú.',
  shareWhenOthers: 'Roinn é nuair ba cheart do dhaoine eile obair anseo.',
  projectAccessNote:
    'Ní osclaítear aon rud díreach toisc a bheith sa tionscadal. Coinníonn gach mír a rochtain féin, agus ritheann na comhráite anseo mar an duine a chuireann tús leo.',
  project: 'Tionscadal',
  needsYou: 'Teastaíonn d’aird',
  review: 'Athbhreithniú',
  inThisProject: 'Sa tionscadal seo',
  deleteQuestion: 'Scrios {name}?',
  deleteDescription:
    'Ní imíonn ach an tionscadal. Fanann a chomhráite, a chomhaid agus a thorthaí leis na daoine ar leo iad, san áit ina raibh siad.',
  deleteConfirm: 'Scrios {name}',
  projectDeleted:
    'Scriosadh {name}. Fanann a chomhráite agus a chuid oibre san áit ina raibh siad.',
  couldntDelete: 'Níorbh fhéidir {name} a scriosadh.',
  itemOutSuccess: 'Baineadh {item} de {project}. Níor athraíodh aon rud eile.',
  itemOutError: 'Níorbh fhéidir {item} a bhaint de {project}.',
  moveOutProject: 'Bog amach as an tionscadal',
  takeOutProject: 'Bain den tionscadal',
  unavailableTitle: 'Níl an tionscadal seo ar fáil',
  unavailableDescription:
    'Seans gur scriosadh é, nó nach bhfuil sé roinnte leat. Níor athraíodh aon rud ann duit.',
  allProjects: 'Gach tionscadal',
  openingProject: 'An tionscadal á oscailt…',
  ended: 'Críochnaithe',
  ends: 'Críochnaíonn',
  yesterday: 'Inné',
  roleLead: 'Ceannaire',
  roleCanEdit: 'Is féidir eagarthóireacht a dhéanamh',
  roleCanUse: 'Is féidir é a úsáid',
  visibilityCompany: 'Gach duine ag {company}',
  visibilityMembers: 'Comhghleacaithe roghnaithe',
  visibilityPrivate: 'Tusa amháin',
  kindApp: 'Aip',
  kindDeck: 'Deic',
  kindSheet: 'Bileog',
  kindChart: 'Cairt',
  kindDashboard: 'Deais',
  kindReport: 'Tuairisc',
  kindChat: 'Comhrá',
  kindFile: 'Comhad',
  kindMeeting: 'Cruinniú',
  kindAgent: 'Gníomhaire',
  kindDocument: 'Doiciméad',
  you: 'Tusa',
  gettingAnswer: 'Freagra á fháil',
  gettingAnswerOther: 'Tá {name} ag fáil freagra',
  addedByYou: 'curtha leis agat',
  addedByOther: 'curtha leis ag {name}',
  renameProjectDescription: 'Athainmnigh é, athraigh an achoimre nó a dháta deiridh',
  deleteProject: 'Scrios tionscadal',
  openToShare: 'Oscail é lena roinnt',
  sharingSaved: 'Sábháladh an chomhroinnt. Níl {name} á roinnt leat a thuilleadh.',
  onlyOwnerPrivate: 'Ní féidir ach le {name} é a dhéanamh príobháideach',
  add: 'Cuir leis',
  addTo: 'Cuir le {name}',
  addAnything:
    'Aon rud is féidir leat a oscailt. Coinníonn sé a rochtain féin: ní roinneann é a chur leis anseo le haon duine é.',
  couldntAdd: 'Níorbh fhéidir {name} a chur leis.',
  projectReadyChat:
    'Tá {name} réidh, agus tá an comhrá seo ann. Níor athraíodh cé atá in ann an comhrá a oscailt.',
  projectReadyPrivate: 'Tá {name} réidh. Ní féidir ach leatsa é a oscailt.',
  projectCreatedNotice: 'Cruthaíodh {name}. Coinníonn gach rud atá ann a chead rochtana féin.',
  latestAnswerYou: 'Tá freagra á fháil agat',
  latestAnswerOther: 'Tá {name} ag fáil freagra',
  inProjectMove: 'I {name}. Bog an comhrá seo',
  notInProjectMove: 'Níl sé i dtionscadal. Bog an comhrá seo',
  movedTo: 'Bogtha go',
  accessUnchanged: 'Níor athraíodh cé atá in ann an comhrá seo a oscailt.',
  theProject: 'an tionscadal',
  in: 'I',
  stopMakingProject: 'Stop ag cruthú tionscadail nua sa chomhrá seo',
  searchYourWork: 'Cuardaigh do chuid oibre',
  searchDocuments: 'Cuardaigh cáipéisí, comhaid agus cruinnithe…',
  yourWork: 'Do chuid oibre',
  looking: 'Ag cuardach…',
  nothingMatchesChat:
    'Níor aimsíodh aon rud. Chun comhrá a thabhairt isteach, oscail é agus bain úsáid as a shuíomh sa cheanntásc.',
  typeToFind: 'Clóscríobh chun obair is féidir leat a oscailt a aimsiú.',
  newProjectDraft: 'Dréacht tionscadail nua · {count} · Níl sé cruthaithe fós',
  projectCreatedOpen: 'Cruthaíodh an tionscadal · Oscail é',
  aNewProject: 'Tionscadal nua',
  draftIntro:
    'Abair sa chomhrá cén obair atá i gceist. Déanann Poneva dréacht den tionscadal anseo, leis an méid atá le tabhairt isteach agus cé leis é a roinnt. Ní chruthaítear tada go dtí go ndeir tú é.',
  draft: 'Dréacht',
  projectCreatedAccess: 'Cruthaithe. Coinníonn gach rud ann a rochtain féin.',
  changeInChatDraft: 'Athraigh rud ar bith ach é a rá sa chomhrá.',
  chatOwnerCreate: 'Is é úinéir an chomhrá amháin atá in ann é a chruthú.',
  open: 'Oscail',
  creating: 'Á chruthú…',
  cannotOpenDraft:
    'Ní féidir le {people} {title} a oscailt, mar sin d’fhreagródh a gcomhráite anseo gan é. Abair sa chomhrá ar cheart iarraidh ar a úinéir é a roinnt, nó é a fhágáil ar lár.',
  bringsIn: 'Tugann sé {count} isteach',
  thisChat: 'An comhrá seo',
  takenOutDraft: 'Bainte amach sa dréacht {count}',
  nothingYet: 'Fós rud ar bith. Ainmnigh sa chomhrá an méid a bhaineann leis seo.',
  leftOut: 'Fágtha ar lár: {items}.',
  whoCanUse: 'Cé atá in ann é a úsáid',
  youLead: 'Tú, ceannaire',
  beingInProject:
    'Ní osclaítear tada ach é a bheith sa tionscadal. Coinníonn gach mír a rochtain féin.',
  onlyYouUntilShare: 'Fanann sé do Thú amháin go dtí go roinneann tú é.',
  colour: 'Dath',
  sand: 'Gaineamh',
  green: 'Glas',
  blue: 'Gorm',
  grey: 'Liath',
  firstProject: 'Cuir tús le do chéad tionscadal',
  firstProjectDescription:
    'Ainmnigh é, agus léann gach comhrá a thosaíonn tú ann an treoir chéanna. Tabhair isteach obair atá agat cheana féin, agus roinn í nuair is ceart do dhaoine eile oibriú ann.',
  loadingProjects: 'Tionscadail á lódáil…',
  thisChatMoves:
    'Bogtar an comhrá seo isteach sa tionscadal. Ní athraíonn cé atá in ann é a oscailt.',
  whatIsWork: 'Cén obair atá i gceist?',
  optional: 'Roghnach',
  writeFromChat: 'Scríobh ón gcomhrá seo é',
  briefPlaceholder: 'Céard dó a bhfuil sé, na rialacha le leanúint, agus na dátaí tábhachtacha.',
  briefDraftHelp:
    'Léann gach comhrá sa tionscadal é seo ar dtús. Iarrann “Scríobh ón gcomhrá seo é” ar Poneva dréacht a dhéanamh in aice leis an gcomhrá; roghnaíonn tú Cruthaigh fós.',
  briefLaterHelp:
    'Léann gach comhrá sa tionscadal é seo ar dtús. Athraigh é níos déanaí ach é a iarraidh i gcomhrá ar bith ann.',
  sendClearFirst:
    'Seol nó glan do theachtaireacht agus do cheangaltáin nár seoladh ar dtús chun an treoir a scríobh ón gcomhrá seo.',
  createProjectError: 'Níorbh fhéidir an tionscadal a chruthú. Bain triail eile as.',
  onlyYouUntil: 'Tú amháin, go dtí go roinneann tú é',
  whereChat: 'Cá gcónaíonn an comhrá seo',
  whereChatHelp:
    'Cónaíonn comhrá i dtionscadal amháin ag an am. Ní athraíonn é a bhogadh cé atá in ann é a oscailt.',
  searchCreateProject: 'Cuardaigh nó cruthaigh tionscadal',
  noProject: 'Gan tionscadal',
  inCompanyChats: 'I do chuid comhráite ag {company}',
  newProjectWithChat: 'Tionscadal nua leis an gcomhrá seo',
  newProjectNamedWithChat: 'Tionscadal nua “{name}” leis an gcomhrá seo',
  makingProject: 'Tionscadal nua á chruthú',
  moveToProject: 'Bog an comhrá seo go {name}',
  chatInProject: 'Tá an comhrá seo in {name}.',
  looksLikeWork: 'Tá cuma {name} ar an obair seo. Bog chuige í?',
  accessBriefNext:
    'Níor athraigh cé atá in ann é a oscailt. Léann sé treoir an tionscadail ó do chéad teachtaireacht eile.',
  moveFailed:
    'Níorbh fhéidir é a bhogadh. Bain triail eile as, nó bain úsáid as a shuíomh sa cheanntásc.',
  accessBriefNextTypographic:
    'Ní athraíonn cé atá in ann é a oscailt. Léann sé treoir an tionscadail ó do chéad teachtaireacht eile.',
  openProject: 'Oscail an tionscadal',
  move: 'Bog',
  movedOut: 'Bogadh amach as a thionscadal é. Níor athraigh cé atá in ann é a oscailt.',
  chatLivesHere: 'Cónaíonn an comhrá seo anseo anois. Níor athraigh cé atá in ann é a oscailt.',
  addedTo: 'Cuireadh {item} le {project}',
  addedAccess: 'Coinníonn sé a rochtain féin. Ní roinneann é a chur leis anseo le haon duine é.',
  removedOut:
    'Tá {item} lasmuigh de {project}. Fanann sé san áit a gcónaíonn sé, agus níor athraigh cé atá in ann é a oscailt.',
  itIs: 'Is ea',
  couldntMoveChat: 'Níorbh fhéidir an comhrá seo a bhogadh.',
  sharingCheckFailed:
    'Níorbh fhéidir seiceáil cé atá in ann na míreanna a léitear ar dtús a oscailt. Seiceáil a rochtain sula roinneann tú an tionscadal seo.',
  cannotOpenShare: 'Ní féidir le {people} {title} a oscailt.',
  readsFirstShare:
    'Léann gach comhrá sa tionscadal seo é ar dtús, mar sin d’fhreagródh a gcomhráite anseo gan é. Ní athraíonn an tionscadal a roinnt é sin.',
  sharingSavedUnread: 'Sábháladh an roinnt. Níorbh fhéidir {name} a léamh arís díreach anois.',
  formerColleague: 'Iarchomhghleacaí',
  madeInChatHere: 'déanta i gcomhrá anseo',
  latestStarted: 'Thosaigh {name} {title}',
  latestStartedYou: 'Thosaigh tú {title}',
  latestContinued: 'Lean {name} ar aghaidh le {title}',
  latestContinuedYou: 'Lean tú ar aghaidh le {title}',
  latestMade: 'Rinne {name} {title}',
  latestMadeYou: 'Rinne tú {title}',
  latestAdded: 'Chuir {name} {title} leis',
  latestAddedYou: 'Chuir tú {title} leis',
  projectChipLives:
    'Tá an comhrá seo i {name} agus léann sé a achoimre. Bog é ó chéad chuid an cheannteidil.',
  addExistingWork: 'Cuir obair atá agat cheana leis',
  nameLabel: 'Ainm',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} mhír',
  itemsMany: 'Míreanna: {count}',
  itemsAllStillHere: '{items}, go léir fós anseo',
  projectsOverviewDescription:
    'Áit amháin do gach píosa oibre. Ní athraíonn rud a chur i dtionscadal cé a fhéadfaidh é a oscailt.',
  noProjectMatchesHint:
    'Níl aon tionscadal ag teacht leis. Bain triail as focal óna ainm nó óna achoimre.',
  aboutProject: 'Maidir leis an tionscadal seo',
  aboutShort: 'Maidir leis',
  workingIn: 'Ag obair i {name}',
  noBriefHome:
    'Níl achoimre ann go fóill. Inis i gcomhrá anseo cén obair í; léann gach comhrá sa tionscadal í ar dtús.',
  tabAll: 'Uile',
  tabChats: 'Comhráite',
  tabResults: 'Torthaí',
  tabFiles: 'Comhaid',
  emptyChats: 'Níl comhrá ar bith anseo go fóill. Tosaigh ceann thuas.',
  emptyResults:
    'Níl aon rud déanta anseo go fóill. Tagann an méid a dhéanann tú i gcomhrá anseo chun solais anseo.',
  emptyFiles:
    'Níl comhad ar bith anseo go fóill. Tagann na comhaid a chuireann tú le comhrá anseo chun solais anseo.',
  showTabs: 'Taispeáin',
  newestShown: 'Taispeántar an {shown} is nua as {count} anseo.',
  nothingHereYet: 'Níl aon rud anseo go fóill.',
  homeEmptyHelp:
    'Tagann na comhráite a thosaíonn tú thuas chun solais anseo, mar aon leis na comhaid a chuireann tú leo agus na torthaí a dhéanann tú iontu.',
  shareWithPeopleDoingIt: 'Roinn leis na daoine atá ag obair air',
  briefWrittenBy: '{version} · scríofa: {name}, {when}',
  briefChangedBy: '{version} · athraithe: {name}, {when}',
  personWorksInIt: 'Tá {people} ag obair air.',
  peopleWorkInIt: 'Tá {people} ag obair air.',
  aboutUnavailable:
    "Níl an tionscadal seo ar fáil. B'fhéidir go bhfuil sé scriosta, nó nach bhfuil sé roinnte leat.",
  landedIn: 'I {name} · {access}',
  landedOnlyYou: 'Ní féidir ach leatsa é a oscailt',
  youWorkInIt: 'Tá tú ag obair air.',
  youAndPeopleWorkInIt: 'Tá tú agus {people} ag obair air.',
  landedCompanyCanOpen: 'Is féidir le gach duine ag {company} é a oscailt',
  landedMembersCanOpen: 'Is féidir le comhghleacaithe roghnaithe é a oscailt',
  briefWrittenByYou: '{version} · scríofa agat, {when}',
  briefChangedByYou: '{version} · athraithe agat, {when}',
  briefWrittenByFormer: '{version} · scríofa ag iarchomhghleacaí, {when}',
  briefChangedByFormer: '{version} · athraithe ag iarchomhghleacaí, {when}',
  addedByFormer: 'curtha leis ag iarchomhghleacaí',
  formerColleagueLeadsIt: 'Is iarchomhghleacaí a stiúrann é.',
  projectLoadFailed: 'Níorbh fhéidir an tionscadal seo a luchtú.',
  personCannotOpenWithout:
    'Ní féidir le {people} é seo a oscailt, mar sin freagraíonn comhráite an duine sin anseo gan é.',
  peopleCannotOpenWithout:
    'Ní féidir le {people} é seo a oscailt, mar sin freagraíonn a gcomhráite anseo gan é.',
};
const hr: Copy = {
  projects: 'Projekti',
  newProject: 'Novi projekt',
  searchProjects: 'Pretraži projekte',
  finished: 'Dovršeno',
  people: 'Osobe',
  skill: 'Vještina',
  noBrief: 'Još nema sažetka.',
  createProject: 'Izradi projekt',
  knowledgePages: 'Stranice znanja',
  searchPages: 'Pretraži stranice',
  formatting: 'Oblikovanje',
  pageTitle: 'Naslov stranice',
  suggestions: 'Prijedlozi',
  current: 'Trenutno',
  agent: 'Agent',
  runs: 'Pokretanja',
  goal: 'Cilj',
  instructions: 'Upute',
  noRuns: 'Još nema pokretanja.',
  runNow: 'Pokreni sada',
  schedule: 'Raspored',
  editors: 'Urednici',
  now: 'Sada',
  moreFor: 'Više za {name}',
  brief: 'Sažetak',
  version: 'Verzija {count}',
  noBriefLong:
    'Još nema sažetka. U chatu recite što je ovaj posao i koja pravila za njega vrijede.',
  changeInChat: 'Promijenite u chatu',
  everyChatFollows: 'Svaki razgovor ovdje slijedi',
  andReadsFirst: 'I prvo čita',
  file: 'Datoteka',
  knowledge: 'Znanje',
  youLeadIt: 'Vi to vodite.',
  personLeadsIt: '{name} to vodi.',
  everyoneAtCanFind: 'Svi u tvrtki {company} to mogu pronaći.',
  shareWhenOthers: 'Podijelite ga kada bi drugi trebali raditi ovdje.',
  projectAccessNote:
    'Članstvo u projektu ne otvara ništa. Svaka stavka zadržava vlastiti pristup, a chatovi ovdje pokreću se u ime osobe koja ih započne.',
  project: 'Projekt',
  needsYou: 'Potrebno je vaše djelovanje',
  review: 'Pregled',
  inThisProject: 'U ovom projektu',
  deleteQuestion: 'Izbrisati {name}?',
  deleteDescription:
    'Nestaje samo projekt. Njegovi chatovi, datoteke i rezultati ostaju osobama koje ih posjeduju, na mjestu na kojem su bili.',
  deleteConfirm: 'Izbriši {name}',
  projectDeleted: '{name} je izbrisan. Njegovi chatovi i posao ostaju tamo gdje su bili.',
  couldntDelete: 'Nije moguće izbrisati {name}.',
  itemOutSuccess: '{item} je uklonjen iz projekta {project}. Ništa se drugo nije promijenilo.',
  itemOutError: 'Nije moguće ukloniti {item} iz projekta {project}.',
  moveOutProject: 'Premjesti izvan projekta',
  takeOutProject: 'Ukloni iz projekta',
  unavailableTitle: 'Ovaj projekt nije dostupan',
  unavailableDescription:
    'Možda je izbrisan ili nije podijeljen s vama. Ništa se u njemu za vas nije promijenilo.',
  allProjects: 'Svi projekti',
  openingProject: 'Otvaranje projekta…',
  ended: 'Završeno',
  ends: 'Završava',
  yesterday: 'Jučer',
  roleLead: 'Voditelj',
  roleCanEdit: 'Može uređivati',
  roleCanUse: 'Može koristiti',
  visibilityCompany: 'Svi u tvrtki {company}',
  visibilityMembers: 'Odabrani kolege',
  visibilityPrivate: 'Samo vi',
  kindApp: 'Aplikacija',
  kindDeck: 'Prezentacija',
  kindSheet: 'Proračunska tablica',
  kindChart: 'Grafikon',
  kindDashboard: 'Nadzorna ploča',
  kindReport: 'Izvješće',
  kindChat: 'Chat',
  kindFile: 'Datoteka',
  kindMeeting: 'Sastanak',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Vi',
  gettingAnswer: 'Dohvaćanje odgovora',
  gettingAnswerOther: '{name} dohvaća odgovor',
  addedByYou: 'dodali ste vi',
  addedByOther: 'dodao/la je {name}',
  renameProjectDescription: 'Preimenujte ga, promijenite sažetak ili datum završetka',
  deleteProject: 'Izbriši projekt',
  openToShare: 'Otvorite za dijeljenje',
  sharingSaved: 'Postavke dijeljenja spremljene. {name} više se ne dijeli s vama.',
  onlyOwnerPrivate: 'Samo {name} može ga postaviti kao privatnog',
  add: 'Dodaj',
  addTo: 'Dodaj u {name}',
  addAnything:
    'Sve što možete otvoriti. Zadržava vlastiti pristup: dodavanje ovdje ne dijeli ga ni s kim.',
  couldntAdd: 'Nije moguće dodati {name}.',
  projectReadyChat:
    '{name} je spreman, a ovaj je chat u njemu. Tko može otvoriti ovaj chat nije se promijenilo.',
  projectReadyPrivate: '{name} je spreman. Samo ga vi možete otvoriti.',
  projectCreatedNotice: '{name} je stvoren. Sve u njemu zadržava vlastite dozvole pristupa.',
  latestAnswerYou: 'Dobivate odgovor',
  latestAnswerOther: '{name} dobiva odgovor',
  inProjectMove: 'U projektu {name}. Premjesti ovaj chat',
  notInProjectMove: 'Nije u projektu. Premjesti ovaj chat',
  movedTo: 'Premješteno u',
  accessUnchanged: 'Nije se promijenilo tko može otvoriti ovaj chat.',
  theProject: 'projekt',
  in: 'U',
  stopMakingProject: 'Prestanite stvarati novi projekt u ovom chatu',
  searchYourWork: 'Pretražite svoj rad',
  searchDocuments: 'Pretražite dokumente, datoteke i sastanke…',
  yourWork: 'Vaš rad',
  looking: 'Traženje…',
  nothingMatchesChat:
    'Nema podudaranja. Da biste dodali razgovor, otvorite ga i upotrijebite njegovo mjesto u zaglavlju.',
  typeToFind: 'Upišite tekst da biste pronašli rad koji možete otvoriti.',
  newProjectDraft: 'Novi projekt · Skica {count} · Još nije izrađen',
  projectCreatedOpen: 'Projekt je izrađen · Otvori ga',
  aNewProject: 'Novi projekt',
  draftIntro:
    'U razgovoru recite što je potrebno napraviti. Poneva ovdje izrađuje skicu projekta, s onim što treba dodati i osobama s kojima ga treba podijeliti. Ništa se ne izrađuje dok to ne potvrdite.',
  draft: 'Skica',
  projectCreatedAccess: 'Izrađeno. Sve u njemu zadržava vlastiti pristup.',
  changeInChatDraft: 'Sve promjene zatražite u razgovoru.',
  chatOwnerCreate: 'Samo osoba koja je vlasnik ovog razgovora može ga izraditi.',
  open: 'Otvori',
  creating: 'Izrada…',
  cannotOpenDraft:
    '{people} ne mogu otvoriti {title}, pa bi njihovi razgovori ovdje odgovarali bez toga. U razgovoru recite želite li zamoliti vlasnika da to podijeli ili izostaviti.',
  bringsIn: 'Dodaje {count}',
  thisChat: 'Ovaj razgovor',
  takenOutDraft: 'Uklonjeno iz skice {count}',
  nothingYet: 'Još nema ničega. U razgovoru navedite što ovdje pripada.',
  leftOut: 'Izostavljeno: {items}.',
  whoCanUse: 'Tko ga može koristiti',
  youLead: 'Vi, voditelj',
  beingInProject: 'Biti u projektu ne otvara ništa. Svaka stavka zadržava vlastiti pristup.',
  onlyYouUntilShare: 'Ostaje vidljivo samo vama dok ga ne podijelite.',
  colour: 'Boja',
  sand: 'Pijesak',
  green: 'Zelena',
  blue: 'Plava',
  grey: 'Siva',
  firstProject: 'Započnite svoj prvi projekt',
  firstProjectDescription:
    'Dajte mu naziv i svaki razgovor koji započnete u njemu čitat će isti sažetak. Dodajte rad koji već imate i podijelite ga kada i drugi trebaju raditi u njemu.',
  loadingProjects: 'Učitavanje projekata…',
  thisChatMoves: 'Ovaj se razgovor premješta u projekt. Tko ga može otvoriti ne mijenja se.',
  whatIsWork: 'O čemu je riječ?',
  optional: 'Neobavezno',
  writeFromChat: 'Napiši iz ovog razgovora',
  briefPlaceholder: 'Čemu služi, koja pravila treba slijediti i koji su važni datumi.',
  briefDraftHelp:
    'Svaki razgovor u projektu prvo čita ovo. Opcija Napiši iz ovog razgovora traži od Poneve da to sastavi pokraj razgovora; vi i dalje birate Izradi.',
  briefLaterHelp:
    'Svaki razgovor u projektu prvo čita ovo. Kasnije ga promijenite tako da to zatražite u bilo kojem razgovoru u projektu.',
  sendClearFirst:
    'Najprije pošaljite ili izbrišite neposlanu poruku i privitke da biste napisali sažetak iz ovog razgovora.',
  createProjectError: 'Projekt nije moguće izraditi. Pokušajte ponovno.',
  onlyYouUntil: 'Samo vi, dok ga ne podijelite',
  whereChat: 'Gdje se ovaj razgovor nalazi',
  whereChatHelp:
    'Razgovor se istodobno može nalaziti samo u jednom projektu. Premještanje nikad ne mijenja tko ga može otvoriti.',
  searchCreateProject: 'Pretražite ili izradite projekt',
  noProject: 'Nema projekta',
  inCompanyChats: 'U vašim razgovorima u tvrtki {company}',
  newProjectWithChat: 'Novi projekt s ovim razgovorom',
  newProjectNamedWithChat: 'Novi projekt „{name}” s ovim razgovorom',
  makingProject: 'Izrada novog projekta',
  moveToProject: 'Premjesti ovaj razgovor u {name}',
  chatInProject: 'Ovaj je razgovor u projektu {name}.',
  looksLikeWork: 'Ovo izgleda kao rad za {name}. Želite li ga premjestiti tamo?',
  accessBriefNext:
    'Tko ga može otvoriti nije se promijenilo. Sažetak projekta čitat će od vaše sljedeće poruke.',
  moveFailed:
    'Premještanje nije uspjelo. Pokušajte ponovno ili upotrijebite njegovo mjesto u zaglavlju.',
  accessBriefNextTypographic:
    'Tko ga može otvoriti ne mijenja se. Sažetak projekta čitat će od vaše sljedeće poruke.',
  openProject: 'Otvori projekt',
  move: 'Premjesti',
  movedOut: 'Premješteno iz projekta. Tko to može otvoriti nije se promijenilo.',
  chatLivesHere: 'Ovaj se razgovor sada nalazi ovdje. Tko ga može otvoriti nije se promijenilo.',
  addedTo: 'Dodano {item} u {project}',
  addedAccess: 'Zadržava vlastiti pristup. Dodavanje ovdje ne dijeli ga ni s kim.',
  removedOut:
    '{item} je uklonjen iz projekta {project}. Ostaje tamo gdje se nalazi, a tko ga može otvoriti nije se promijenilo.',
  itIs: 'To je',
  couldntMoveChat: 'Ovaj razgovor nije moguće premjestiti.',
  sharingCheckFailed:
    'Nije moguće provjeriti tko može otvoriti stavke koje se prve čitaju. Prije dijeljenja ovog projekta provjerite njihov pristup.',
  cannotOpenShare: '{people} ne mogu otvoriti {title}.',
  readsFirstShare:
    'Svaki razgovor u ovom projektu prvo to čita, pa bi njihovi razgovori ovdje odgovarali bez toga. Dijeljenje projekta to ne mijenja.',
  sharingSavedUnread:
    'Dijeljenje je spremljeno. Stavku {name} sada nije bilo moguće ponovno pročitati.',
  formerColleague: 'Bivši kolega',
  madeInChatHere: 'izrađeno u chatu ovdje',
  latestStarted: '{name} je započeo/la {title}',
  latestStartedYou: 'Započeli ste {title}',
  latestContinued: '{name} je nastavio/la {title}',
  latestContinuedYou: 'Nastavili ste {title}',
  latestMade: '{name} je izradio/la {title}',
  latestMadeYou: 'Izradili ste {title}',
  latestAdded: '{name} je dodao/la {title}',
  latestAddedYou: 'Dodali ste {title}',
  projectChipLives:
    'Ovaj chat pripada projektu {name} i čita njegov sažetak. Premjestite ga iz prvog dijela zaglavlja.',
  addExistingWork: 'Dodajte rad koji već imate',
  nameLabel: 'Naziv',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} stavka',
  itemsMany: 'Stavke: {count}',
  itemsAllStillHere: '{items}, sve je još uvijek ovdje',
  projectsOverviewDescription:
    'Jedno mjesto za svaki rad. Dodavanje nečega u projekt nikad ne mijenja tko to može otvoriti.',
  noProjectMatchesHint: 'Nijedan projekt ne odgovara. Pokušajte s riječi iz naziva ili sažetka.',
  aboutProject: 'O ovom projektu',
  aboutShort: 'O projektu',
  workingIn: 'Radite u projektu {name}',
  noBriefHome:
    'Još nema sažetka. U chatu ovdje recite o kakvom je radu riječ; svaki chat u projektu prvo čita to.',
  tabAll: 'Sve',
  tabChats: 'Chatovi',
  tabResults: 'Rezultati',
  tabFiles: 'Datoteke',
  emptyChats: 'Ovdje još nema chatova. Započnite jedan iznad.',
  emptyResults: 'Ovdje još ništa nije izrađeno. Što izradite u chatu ovdje, pojavit će se ovdje.',
  emptyFiles: 'Ovdje još nema datoteka. Datoteke dodane u chatu ovdje pojavit će se ovdje.',
  showTabs: 'Prikaži',
  newestShown: 'Ovdje je prikazano najnovijih {shown} od {count}.',
  nothingHereYet: 'Ovdje još nema ničega.',
  homeEmptyHelp:
    'Chatovi koje započnete iznad pojavljuju se ovdje, kao i datoteke koje dodate i rezultati koje u njima izradite.',
  shareWithPeopleDoingIt: 'Podijelite s ljudima koji rade na tome',
  briefWrittenBy: '{version} · autor: {name}, {when}',
  briefChangedBy: '{version} · izmjena: {name}, {when}',
  personWorksInIt: '{people} radi na tome.',
  peopleWorkInIt: '{people} rade na tome.',
  aboutUnavailable: 'Ovaj projekt nije dostupan. Možda je izbrisan ili nije podijeljen s vama.',
  landedIn: 'U projektu {name} · {access}',
  landedOnlyYou: 'Samo vi to možete otvoriti',
  youWorkInIt: 'Vi radite na tome.',
  youAndPeopleWorkInIt: 'Vi i {people} radite na tome.',
  landedCompanyCanOpen: 'Svi u tvrtki {company} mogu to otvoriti',
  landedMembersCanOpen: 'Odabrani kolege mogu to otvoriti',
  briefWrittenByYou: '{version} · autor: vi, {when}',
  briefChangedByYou: '{version} · izmjena: vi, {when}',
  briefWrittenByFormer: '{version} · autor: bivši kolega, {when}',
  briefChangedByFormer: '{version} · izmjena: bivši kolega, {when}',
  addedByFormer: 'dodao je bivši kolega',
  formerColleagueLeadsIt: 'Vodi to bivši kolega.',
  projectLoadFailed: 'Ovaj projekt nije bilo moguće učitati.',
  personCannotOpenWithout:
    '{people} ovo ne može otvoriti pa chatovi te osobe ovdje odgovaraju bez toga.',
  peopleCannotOpenWithout:
    '{people} ovo ne mogu otvoriti pa njihovi chatovi ovdje odgovaraju bez toga.',
};
const hu: Copy = {
  projects: 'Projektek',
  newProject: 'Új projekt',
  searchProjects: 'Projektek keresése',
  finished: 'Befejezve',
  people: 'Személyek',
  skill: 'Készség',
  noBrief: 'Még nincs összefoglaló.',
  createProject: 'Projekt létrehozása',
  knowledgePages: 'Tudásoldalak',
  searchPages: 'Oldalak keresése',
  formatting: 'Formázás',
  pageTitle: 'Oldalcím',
  suggestions: 'Javaslatok',
  current: 'Aktuális',
  agent: 'Ügynök',
  runs: 'Futtatások',
  goal: 'Cél',
  instructions: 'Utasítások',
  noRuns: 'Még nincs futtatás.',
  runNow: 'Futtatás most',
  schedule: 'Ütemezés',
  editors: 'Szerkesztők',
  now: 'Most',
  moreFor: 'Továbbiak ehhez: {name}',
  brief: 'Brief',
  version: '{count}. verzió',
  noBriefLong:
    'Még nincs brief. Írd le egy csevegésben, miről szól ez a munka, és milyen szabályok vonatkoznak rá.',
  changeInChat: 'Módosítás csevegésben',
  everyChatFollows: 'Minden itt lévő csevegés ezt követi',
  andReadsFirst: 'És ezt olvassa el először',
  file: 'Fájl',
  knowledge: 'Tudás',
  youLeadIt: 'Te vezeted.',
  personLeadsIt: '{name} vezeti.',
  everyoneAtCanFind: 'A(z) {company} minden munkatársa megtalálhatja.',
  shareWhenOthers: 'Oszd meg, amikor másoknak is dolgozniuk kell benne.',
  projectAccessNote:
    'A projekt tagsága önmagában nem ad hozzáférést. Minden elem saját hozzáféréssel rendelkezik, az itteni csevegések pedig az azokat indító személy nevében futnak.',
  project: 'Projekt',
  needsYou: 'Te következel',
  review: 'Áttekintés',
  inThisProject: 'Ebben a projektben',
  deleteQuestion: 'Törlöd ezt: {name}?',
  deleteDescription:
    'Csak a projekt tűnik el. A csevegései, fájljai és eredményei azoknál maradnak, akiknek a tulajdonában vannak, a korábbi helyükön.',
  deleteConfirm: '{name} törlése',
  projectDeleted: '{name} törölve. A csevegései és a munkák ott maradnak, ahol voltak.',
  couldntDelete: 'Nem sikerült törölni: {name}.',
  itemOutSuccess: '{item} kikerült a(z) {project} projektből. Semmi más nem változott.',
  itemOutError: 'Nem sikerült kivenni innen: {item}: {project}.',
  moveOutProject: 'Kihelyezés a projektből',
  takeOutProject: 'Kivétel a projektből',
  unavailableTitle: 'Ez a projekt nem érhető el',
  unavailableDescription:
    'Lehet, hogy törölték, vagy nincs megosztva veled. Számodra semmi nem változott benne.',
  allProjects: 'Minden projekt',
  openingProject: 'Projekt megnyitása…',
  ended: 'Lezárult',
  ends: 'Lejár',
  yesterday: 'Tegnap',
  roleLead: 'Vezető',
  roleCanEdit: 'Szerkesztheti',
  roleCanUse: 'Használhatja',
  visibilityCompany: 'A(z) {company} minden munkatársa',
  visibilityMembers: 'Kiválasztott munkatársak',
  visibilityPrivate: 'Csak te',
  kindApp: 'Alkalmazás',
  kindDeck: 'Prezentáció',
  kindSheet: 'Munkalap',
  kindChart: 'Diagram',
  kindDashboard: 'Irányítópult',
  kindReport: 'Jelentés',
  kindChat: 'Csevegés',
  kindFile: 'Fájl',
  kindMeeting: 'Értekezlet',
  kindAgent: 'Ügynök',
  kindDocument: 'Dokumentum',
  you: 'Te',
  gettingAnswer: 'Válasz lekérése',
  gettingAnswerOther: '{name} választ kér le',
  addedByYou: 'általad hozzáadva',
  addedByOther: '{name} által hozzáadva',
  renameProjectDescription: 'Nevezd át, módosítsd a briefet vagy a záró dátumát',
  deleteProject: 'Projekt törlése',
  openToShare: 'Nyisd meg a megosztáshoz',
  sharingSaved: 'A megosztás mentve. {name} többé nem osztja meg veled.',
  onlyOwnerPrivate: 'Csak {name} teheti priváttá',
  add: 'Hozzáadás',
  addTo: 'Hozzáadás ehhez: {name}',
  addAnything:
    'Bármi, amit meg tudsz nyitni. Megőrzi a saját hozzáférését: ha ide hozzáadod, senkivel sem osztod meg.',
  couldntAdd: 'Nem sikerült hozzáadni: {name}.',
  projectReadyChat:
    '{name} elkészült, és ez a csevegés benne van. Nem változott, hogy ki nyithatja meg a csevegést.',
  projectReadyPrivate: '{name} elkészült. Csak te nyithatod meg.',
  projectCreatedNotice:
    '{name} létrejött. Minden benne található elem megtartja a saját hozzáférését.',
  latestAnswerYou: 'Választ kapsz',
  latestAnswerOther: '{name} választ kap',
  inProjectMove: 'A(z) {name} projektben. A csevegés áthelyezése',
  notInProjectMove: 'Nincs projektben. A csevegés áthelyezése',
  movedTo: 'Áthelyezve ide',
  accessUnchanged: 'Nem változott, hogy ki nyithatja meg ezt a csevegést.',
  theProject: 'a projekt',
  in: 'Ebben',
  stopMakingProject: 'Ne hozz létre új projektet ebben a csevegésben',
  searchYourWork: 'Keresés a munkáid között',
  searchDocuments: 'Dokumentumok, fájlok és megbeszélések keresése…',
  yourWork: 'Munkáid',
  looking: 'Keresés…',
  nothingMatchesChat:
    'Nincs találat. Ha egy csevegést szeretnél idehozni, nyisd meg, majd használd a fejlécben található helyét.',
  typeToFind: 'Írj be valamit a megnyitható munkák kereséséhez.',
  newProjectDraft: 'Új projekt · {count}. vázlat · Még nincs létrehozva',
  projectCreatedOpen: 'Projekt létrehozva · Megnyitás',
  aNewProject: 'Új projekt',
  draftIntro:
    'Mondd el a csevegésben, miről szól a munka. A Poneva itt elkészíti a projekt vázlatát, megjelölve, mit kell hozzáadni és kivel kell megosztani. Semmi nem jön létre, amíg nem hagyod jóvá.',
  draft: 'Vázlat',
  projectCreatedAccess: 'Létrehozva. Minden benne lévő elem megőrzi a saját hozzáférését.',
  changeInChatDraft: 'Bármit megváltoztathatsz, ha ezt kéred a csevegésben.',
  chatOwnerCreate: 'Csak a csevegés tulajdonosa hozhatja létre.',
  open: 'Megnyitás',
  creating: 'Létrehozás…',
  cannotOpenDraft:
    '{people} nem tudja megnyitni: {title}, ezért az itteni csevegései enélkül válaszolnának. Mondd meg a csevegésben, hogy kérje-e meg a tulajdonosát a megosztásra, vagy hagyja ki.',
  bringsIn: 'Hozzáadva: {count}',
  thisChat: 'Ez a csevegés',
  takenOutDraft: 'Kivétel a(z) {count}. vázlatban',
  nothingYet: 'Még nincs semmi. Nevezd meg a csevegésben, minek kell ide kerülnie.',
  leftOut: 'Kihagyva: {items}.',
  whoCanUse: 'Ki használhatja',
  youLead: 'Te, vezetőként',
  beingInProject:
    'Attól, hogy egy elem a projektben van, még semmi nem válik megnyithatóvá. Minden elem megőrzi a saját hozzáférését.',
  onlyYouUntilShare: 'A megosztásig csak te férsz hozzá.',
  colour: 'Szín',
  sand: 'Homokszínű',
  green: 'Zöld',
  blue: 'Kék',
  grey: 'Szürke',
  firstProject: 'Kezdd el az első projektedet',
  firstProjectDescription:
    'Nevezd el, és minden benne indított csevegés ugyanazt a leírást olvassa el. Hozd be a már meglévő munkáidat, és oszd meg őket, amikor másoknak is itt kell dolgozniuk.',
  loadingProjects: 'Projektek betöltése…',
  thisChatMoves: 'Ez a csevegés átkerül a projektbe. Nem változik, ki nyithatja meg.',
  whatIsWork: 'Miről szól a munka?',
  optional: 'Opcionális',
  writeFromChat: 'Megírás ebből a csevegésből',
  briefPlaceholder: 'Mire szolgál, milyen szabályokat kell követni, mely dátumok fontosak.',
  briefDraftHelp:
    'A projekt minden csevegése ezt olvassa el először. A „Megírás ebből a csevegésből” lehetőséggel megkérheted a Ponevát, hogy a csevegés mellett készítse el a vázlatot; a Létrehozás gombot továbbra is neked kell kiválasztanod.',
  briefLaterHelp:
    'A projekt minden csevegése ezt olvassa el először. Később bármelyik itteni csevegésben kérve módosíthatod.',
  sendClearFirst:
    'Előbb küldd el vagy töröld a még el nem küldött üzenetedet és mellékleteidet, hogy ebből a csevegésből megírhasd a leírást.',
  createProjectError: 'Nem sikerült létrehozni a projektet. Próbáld újra.',
  onlyYouUntil: 'A megosztásig csak te férsz hozzá',
  whereChat: 'Hol található ez a csevegés?',
  whereChatHelp:
    'Egy csevegés egyszerre egy projektben lehet. Áthelyezése soha nem változtatja meg, ki nyithatja meg.',
  searchCreateProject: 'Projekt keresése vagy létrehozása',
  noProject: 'Nincs projekt',
  inCompanyChats: 'A(z) {company} vállalatnál folytatott csevegéseidben',
  newProjectWithChat: 'Új projekt ezzel a csevegéssel',
  newProjectNamedWithChat: 'Új „{name}” projekt ezzel a csevegéssel',
  makingProject: 'Új projekt létrehozása',
  moveToProject: 'A csevegés áthelyezése ide: {name}',
  chatInProject: 'Ez a csevegés itt található: {name}.',
  looksLikeWork: 'Ez {name} munkájának tűnik. Áthelyezed oda?',
  accessBriefNext:
    'Nem változott, ki nyithatja meg. A következő üzenetedtől kezdve a projekt leírását olvassa.',
  moveFailed: 'Nem sikerült áthelyezni. Próbáld újra, vagy használd a fejlécben található helyét.',
  accessBriefNextTypographic:
    'Nem változik, ki nyithatja meg. A következő üzenetedtől kezdve a projekt leírását olvassa.',
  openProject: 'Projekt megnyitása',
  move: 'Áthelyezés',
  movedOut: 'Kikerült a projektből. Nem változott, ki nyithatja meg.',
  chatLivesHere: 'Ez a csevegés mostantól itt található. Nem változott, ki nyithatja meg.',
  addedTo: '{item} hozzáadva ehhez: {project}',
  addedAccess: 'Megőrzi a saját hozzáférését. Ha ide hozzáadod, senkivel sem osztod meg.',
  removedOut:
    '{item} kikerült innen: {project}. Ott marad, ahol található, és nem változott, ki nyithatja meg.',
  itIs: 'Ez',
  couldntMoveChat: 'Nem sikerült áthelyezni ezt a csevegést.',
  sharingCheckFailed:
    'Nem sikerült ellenőrizni, ki nyithatja meg az elsőként olvasott elemeket. A projekt megosztása előtt ellenőrizd a hozzáférésüket.',
  cannotOpenShare: '{people} nem tudja megnyitni: {title}.',
  readsFirstShare:
    'A projekt minden csevegése ezt olvassa el először, ezért az itteni csevegéseik enélkül válaszolnának. A projekt megosztása ezen nem változtat.',
  sharingSavedUnread: 'A megosztás mentve. A(z) {name} projektet most nem sikerült újra beolvasni.',
  formerColleague: 'Egy volt munkatárs',
  madeInChatHere: 'itt, egy csevegésben készült',
  latestStarted: '{name} elindította: {title}',
  latestStartedYou: 'Elindítottad: {title}',
  latestContinued: '{name} folytatta: {title}',
  latestContinuedYou: 'Folytattad: {title}',
  latestMade: '{name} elkészítette: {title}',
  latestMadeYou: 'Elkészítetted: {title}',
  latestAdded: '{name} hozzáadta: {title}',
  latestAddedYou: 'Hozzáadtad: {title}',
  projectChipLives:
    'Ez a csevegés a(z) {name} projektben van, és elolvassa a briefjét. Az áthelyezéséhez használd a fejléc első részét.',
  addExistingWork: 'Add hozzá a már meglévő munkáidat',
  nameLabel: 'Név',
  projectNameExample: 'Fekete péntek 2026',
  itemsOne: '{count} elem',
  itemsMany: '{count} elem',
  itemsAllStillHere: '{items}, mind a helyén',
  projectsOverviewDescription:
    'Egy hely minden munkához. Attól, hogy valami egy projektbe kerül, nem változik, ki nyithatja meg.',
  noProjectMatchesHint: 'Nincs egyező projekt. Próbálj meg egy szót a nevéből vagy a briefjéből.',
  aboutProject: 'A projektről',
  aboutShort: 'Névjegy',
  workingIn: 'Munka itt: {name}',
  noBriefHome:
    'Még nincs brief. Írd le egy itteni csevegésben, miről szól a munka; a projekt minden csevegése ezt olvassa el először.',
  tabAll: 'Összes',
  tabChats: 'Csevegések',
  tabResults: 'Eredmények',
  tabFiles: 'Fájlok',
  emptyChats: 'Még nincs itt csevegés. Indíts egyet fent.',
  emptyResults:
    'Még nem készült itt semmi. Amit egy itteni csevegésben készítesz, itt jelenik meg.',
  emptyFiles: 'Még nincs itt fájl. Az itteni csevegésben hozzáadott fájlok itt jelennek meg.',
  showTabs: 'Megjelenítés',
  newestShown: 'A(z) {count} elemből a legújabb {shown} látható itt.',
  nothingHereYet: 'Itt még nincs semmi.',
  homeEmptyHelp:
    'A fent indított csevegések itt jelennek meg, ahogy a hozzáadott fájlok és a bennük készített eredmények is.',
  shareWithPeopleDoingIt: 'Megosztás azokkal, akik dolgoznak rajta',
  briefWrittenBy: '{version} · írta: {name}, {when}',
  briefChangedBy: '{version} · módosította: {name}, {when}',
  personWorksInIt: '{people} dolgozik rajta.',
  peopleWorkInIt: '{people} dolgoznak rajta.',
  aboutUnavailable: 'Ez a projekt nem érhető el. Lehet, hogy törölték, vagy nincs megosztva veled.',
  landedIn: 'Itt: {name} · {access}',
  landedOnlyYou: 'Csak te nyithatod meg',
  youWorkInIt: 'Te dolgozol rajta.',
  youAndPeopleWorkInIt: 'Te és {people} dolgoztok rajta.',
  landedCompanyCanOpen: 'A(z) {company} minden munkatársa megnyithatja',
  landedMembersCanOpen: 'Kiválasztott munkatársak megnyithatják',
  briefWrittenByYou: '{version} · általad írva, {when}',
  briefChangedByYou: '{version} · általad módosítva, {when}',
  briefWrittenByFormer: '{version} · egy volt munkatárs által írva, {when}',
  briefChangedByFormer: '{version} · egy volt munkatárs által módosítva, {when}',
  addedByFormer: 'egy volt munkatárs által hozzáadva',
  formerColleagueLeadsIt: 'Egy volt munkatárs vezeti.',
  projectLoadFailed: 'Ezt a projektet nem sikerült betölteni.',
  personCannotOpenWithout:
    '{people} nem tudja megnyitni ezt, ezért az itteni csevegései enélkül válaszolnak.',
  peopleCannotOpenWithout:
    '{people} nem tudják megnyitni ezt, ezért az itteni csevegéseik enélkül válaszolnak.',
};
const it: Copy = {
  projects: 'Progetti',
  newProject: 'Nuovo progetto',
  searchProjects: 'Cerca progetti',
  finished: 'Completati',
  people: 'Persone',
  skill: 'Competenza',
  noBrief: 'Nessun brief ancora.',
  createProject: 'Crea progetto',
  knowledgePages: 'Pagine della conoscenza',
  searchPages: 'Cerca pagine',
  formatting: 'Formattazione',
  pageTitle: 'Titolo della pagina',
  suggestions: 'Suggerimenti',
  current: 'Attuale',
  agent: 'Agente',
  runs: 'Esecuzioni',
  goal: 'Obiettivo',
  instructions: 'Istruzioni',
  noRuns: 'Nessuna esecuzione ancora.',
  runNow: 'Esegui ora',
  schedule: 'Pianificazione',
  editors: 'Redattori',
  now: 'Ora',
  moreFor: 'Altro per {name}',
  brief: 'Brief',
  version: 'Versione {count}',
  noBriefLong:
    'Ancora nessun brief. In una chat, descrivi in cosa consiste questo lavoro e quali sono le regole.',
  changeInChat: 'Modifica nella chat',
  everyChatFollows: 'Ogni chat qui segue',
  andReadsFirst: 'E legge per prima cosa',
  file: 'File',
  knowledge: 'Conoscenze',
  youLeadIt: 'Lo gestisci tu.',
  personLeadsIt: '{name} lo gestisce.',
  everyoneAtCanFind: 'Tutti in {company} possono trovarlo.',
  shareWhenOthers: 'Condividilo quando altre persone devono lavorarci.',
  projectAccessNote:
    'Essere nel progetto non dà accesso a nulla. Ogni elemento mantiene il proprio accesso e le chat qui vengono eseguite dalla persona che le avvia.',
  project: 'Progetto',
  needsYou: 'Richiede il tuo intervento',
  review: 'Revisione',
  inThisProject: 'In questo progetto',
  deleteQuestion: 'Eliminare {name}?',
  deleteDescription:
    'Scompare solo il progetto. Le sue chat, i file e i risultati restano alle persone che ne sono proprietarie, nella posizione in cui si trovavano.',
  deleteConfirm: 'Elimina {name}',
  projectDeleted:
    '{name} è stato eliminato. Le sue chat e il suo lavoro restano dove si trovavano.',
  couldntDelete: 'Impossibile eliminare {name}.',
  itemOutSuccess: '{item} è stato rimosso da {project}. Non è cambiato altro.',
  itemOutError: 'Impossibile rimuovere {item} da {project}.',
  moveOutProject: 'Sposta fuori dal progetto',
  takeOutProject: 'Rimuovi dal progetto',
  unavailableTitle: 'Questo progetto non è disponibile',
  unavailableDescription:
    'Potrebbe essere stato eliminato oppure non è condiviso con te. Nulla al suo interno è cambiato per te.',
  allProjects: 'Tutti i progetti',
  openingProject: 'Apertura del progetto…',
  ended: 'Terminato',
  ends: 'Termina',
  yesterday: 'Ieri',
  roleLead: 'Responsabile',
  roleCanEdit: 'Può modificare',
  roleCanUse: 'Può usare',
  visibilityCompany: 'Tutti in {company}',
  visibilityMembers: 'Colleghi selezionati',
  visibilityPrivate: 'Solo tu',
  kindApp: 'App',
  kindDeck: 'Presentazione',
  kindSheet: 'Foglio',
  kindChart: 'Grafico',
  kindDashboard: 'Dashboard',
  kindReport: 'Report',
  kindChat: 'Chat',
  kindFile: 'File',
  kindMeeting: 'Riunione',
  kindAgent: 'Agente',
  kindDocument: 'Documento',
  you: 'Tu',
  gettingAnswer: 'Ricerca di una risposta',
  gettingAnswerOther: '{name} sta cercando una risposta',
  addedByYou: 'aggiunto da te',
  addedByOther: 'aggiunto da {name}',
  renameProjectDescription: 'Rinominalo, modifica il brief o la data di fine',
  deleteProject: 'Elimina progetto',
  openToShare: 'Aprilo per condividerlo',
  sharingSaved: 'Condivisione salvata. {name} non è più condiviso con te.',
  onlyOwnerPrivate: 'Solo {name} può renderlo privato',
  add: 'Aggiungi',
  addTo: 'Aggiungi a {name}',
  addAnything:
    'Qualsiasi cosa tu possa aprire. Mantiene i propri accessi: aggiungerla qui non la condivide con nessuno.',
  couldntAdd: 'Impossibile aggiungere {name}.',
  projectReadyChat:
    '{name} è pronto e questa chat è al suo interno. Chi può aprire la chat non è cambiato.',
  projectReadyPrivate: '{name} è pronto. Solo tu puoi aprirlo.',
  projectCreatedNotice: '{name} è stato creato. Tutto ciò che contiene mantiene i propri accessi.',
  latestAnswerYou: 'Stai ricevendo una risposta',
  latestAnswerOther: '{name} sta ricevendo una risposta',
  inProjectMove: 'In {name}. Sposta questa chat',
  notInProjectMove: 'Non in un progetto. Sposta questa chat',
  movedTo: 'Spostata in',
  accessUnchanged: 'Chi può aprire questa chat non è cambiato.',
  theProject: 'il progetto',
  in: 'In',
  stopMakingProject: 'Smetti di creare un nuovo progetto in questa chat',
  searchYourWork: 'Cerca nel tuo lavoro',
  searchDocuments: 'Cerca documenti, file e riunioni…',
  yourWork: 'Il tuo lavoro',
  looking: 'Ricerca…',
  nothingMatchesChat:
    "Nessuna corrispondenza. Per aggiungere una chat, aprila e usa la relativa opzione nell'intestazione.",
  typeToFind: 'Digita per trovare il lavoro che puoi aprire.',
  newProjectDraft: 'Nuovo progetto · Bozza {count} · Non ancora creato',
  projectCreatedOpen: 'Progetto creato · Aprilo',
  aNewProject: 'Un nuovo progetto',
  draftIntro:
    'Descrivi nella chat il lavoro da svolgere. Poneva prepara qui il progetto, indicando cosa includere e con chi condividerlo. Non viene creato nulla finché non lo confermi.',
  draft: 'Bozza',
  projectCreatedAccess: 'Creato. Ogni elemento mantiene i propri accessi.',
  changeInChatDraft: 'Modifica qualsiasi cosa chiedendolo nella chat.',
  chatOwnerCreate: 'Solo chi possiede questa chat può crearlo.',
  open: 'Apri',
  creating: 'Creazione…',
  cannotOpenDraft:
    '{people} non può aprire {title}, quindi le relative chat qui risponderebbero senza di esso. Indica nella chat se chiedere al proprietario di condividerlo o lasciarlo fuori.',
  bringsIn: 'Include {count}',
  thisChat: 'Questa chat',
  takenOutDraft: 'Escluso nella bozza {count}',
  nothingYet: 'Ancora nulla. Indica nella chat cosa deve appartenere a questo progetto.',
  leftOut: 'Esclusi: {items}.',
  whoCanUse: 'Chi può usarlo',
  youLead: 'Tu, responsabile',
  beingInProject:
    'Essere nel progetto non dà accesso a nulla. Ogni elemento mantiene i propri accessi.',
  onlyYouUntilShare: 'Resta visibile solo a te finché non lo condividi.',
  colour: 'Colore',
  sand: 'Sabbia',
  green: 'Verde',
  blue: 'Blu',
  grey: 'Grigio',
  firstProject: 'Inizia il tuo primo progetto',
  firstProjectDescription:
    'Assegnagli un nome: ogni chat che avvii al suo interno leggerà lo stesso brief. Includi il lavoro che hai già e condividilo quando altri dovranno lavorarci.',
  loadingProjects: 'Caricamento dei progetti…',
  thisChatMoves: 'Questa chat verrà spostata nel progetto. Chi può aprirla non cambia.',
  whatIsWork: 'Qual è il lavoro?',
  optional: 'Facoltativo',
  writeFromChat: 'Scrivilo da questa chat',
  briefPlaceholder: 'A cosa serve, quali regole seguire e quali sono le date importanti.',
  briefDraftHelp:
    'Ogni chat del progetto legge prima questo testo. Scrivilo da questa chat chiede a Poneva di prepararlo accanto alla chat; sarai comunque tu a scegliere Crea.',
  briefLaterHelp:
    'Ogni chat del progetto legge prima questo testo. Potrai modificarlo in seguito chiedendolo in una qualsiasi chat del progetto.',
  sendClearFirst:
    'Invia o cancella prima il messaggio e gli allegati non inviati per scrivere il brief da questa chat.',
  createProjectError: 'Non è stato possibile creare il progetto. Riprova.',
  onlyYouUntil: 'Solo tu, finché non lo condividi',
  whereChat: 'Dove si trova questa chat',
  whereChatHelp:
    'Una chat può trovarsi in un solo progetto alla volta. Spostarla non cambia chi può aprirla.',
  searchCreateProject: 'Cerca o crea un progetto',
  noProject: 'Nessun progetto',
  inCompanyChats: 'Nelle tue chat su {company}',
  newProjectWithChat: 'Nuovo progetto con questa chat',
  newProjectNamedWithChat: 'Nuovo progetto “{name}” con questa chat',
  makingProject: 'Creazione di un nuovo progetto',
  moveToProject: 'Sposta questa chat in {name}',
  chatInProject: 'Questa chat è in {name}.',
  looksLikeWork: 'Sembra un lavoro di {name}. Vuoi spostarla lì?',
  accessBriefNext:
    'Chi può aprirla non è cambiato. Dal tuo prossimo messaggio leggerà il brief del progetto.',
  moveFailed:
    "Non è stato possibile spostarla. Riprova o usa la relativa opzione nell'intestazione.",
  accessBriefNextTypographic:
    'Chi può aprirla non cambia. Dal tuo prossimo messaggio leggerà il brief del progetto.',
  openProject: 'Apri progetto',
  move: 'Sposta',
  movedOut: 'Spostata fuori dal progetto. Chi può aprirla non è cambiato.',
  chatLivesHere: 'Questa chat ora si trova qui. Chi può aprirla non è cambiato.',
  addedTo: '{item} aggiunto a {project}',
  addedAccess: 'Mantiene i propri accessi. Aggiungerlo qui non lo condivide con nessuno.',
  removedOut:
    '{item} è stato rimosso da {project}. Rimane nella posizione attuale e chi può aprirlo non è cambiato.',
  itIs: 'È',
  couldntMoveChat: 'Non è stato possibile spostare questa chat.',
  sharingCheckFailed:
    'Non è stato possibile verificare chi può aprire gli elementi letti per primi. Controlla i relativi accessi prima di condividere questo progetto.',
  cannotOpenShare: '{people} non può aprire {title}.',
  readsFirstShare:
    'Ogni chat di questo progetto lo legge per prima cosa, quindi le relative chat qui risponderebbero senza di esso. Condividere il progetto non cambia questa situazione.',
  sharingSavedUnread: 'Condivisione salvata. Non è stato possibile rileggere {name} proprio ora.',
  formerColleague: 'Un ex collega',
  madeInChatHere: 'creato in una chat qui',
  latestStarted: '{name} ha avviato {title}',
  latestStartedYou: 'Hai avviato {title}',
  latestContinued: '{name} ha proseguito {title}',
  latestContinuedYou: 'Hai proseguito {title}',
  latestMade: '{name} ha creato {title}',
  latestMadeYou: 'Hai creato {title}',
  latestAdded: '{name} ha aggiunto {title}',
  latestAddedYou: 'Hai aggiunto {title}',
  projectChipLives:
    'Questa chat si trova in {name} e ne legge il brief. Spostala dalla prima parte dell’intestazione.',
  addExistingWork: 'Aggiungi il lavoro che hai già',
  nameLabel: 'Nome',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} elemento',
  itemsMany: '{count} elementi',
  itemsAllStillHere: '{items}, tutti ancora qui',
  projectsOverviewDescription:
    'Un posto per ogni lavoro. Mettere qualcosa in un progetto non cambia mai chi può aprirlo.',
  noProjectMatchesHint: 'Nessun progetto corrisponde. Prova con una parola del nome o del brief.',
  aboutProject: 'Informazioni su questo progetto',
  aboutShort: 'Info',
  workingIn: 'Stai lavorando in {name}',
  noBriefHome:
    'Ancora nessun brief. Di’ in una chat qui in cosa consiste il lavoro; tutte le chat del progetto lo leggono per prime.',
  tabAll: 'Tutto',
  tabChats: 'Chat',
  tabResults: 'Risultati',
  tabFiles: 'File',
  emptyChats: 'Ancora nessuna chat qui. Avviane una qui sopra.',
  emptyResults: 'Ancora nulla di creato qui. Quello che crei in una chat qui finisce qui.',
  emptyFiles: 'Ancora nessun file qui. I file che aggiungi in una chat qui finiscono qui.',
  showTabs: 'Mostra',
  newestShown: 'Qui sono mostrati i {shown} più recenti su {count}.',
  nothingHereYet: 'Ancora niente qui.',
  homeEmptyHelp:
    'Le chat che avvii qui sopra finiscono qui, come i file che aggiungi e i risultati che crei al loro interno.',
  shareWithPeopleDoingIt: 'Condividi con chi ci lavora',
  briefWrittenBy: '{version} · scritto da {name}, {when}',
  briefChangedBy: '{version} · modificato da {name}, {when}',
  personWorksInIt: '{people} ci lavora.',
  peopleWorkInIt: '{people} ci lavorano.',
  aboutUnavailable:
    'Questo progetto non è disponibile. Potrebbe essere stato eliminato oppure non è condiviso con te.',
  landedIn: 'In {name} · {access}',
  landedOnlyYou: 'Solo tu puoi aprirlo',
  youWorkInIt: 'Ci lavori.',
  youAndPeopleWorkInIt: 'Tu e {people} ci lavorate.',
  landedCompanyCanOpen: 'Tutti in {company} possono aprirlo',
  landedMembersCanOpen: 'I colleghi selezionati possono aprirlo',
  briefWrittenByYou: '{version} · scritto da te, {when}',
  briefChangedByYou: '{version} · modificato da te, {when}',
  briefWrittenByFormer: '{version} · scritto da un ex collega, {when}',
  briefChangedByFormer: '{version} · modificato da un ex collega, {when}',
  addedByFormer: 'aggiunto da un ex collega',
  formerColleagueLeadsIt: 'Un ex collega lo gestisce.',
  projectLoadFailed: 'Non è stato possibile caricare questo progetto.',
  personCannotOpenWithout:
    '{people} non può aprirlo, quindi le sue chat qui rispondono senza questo contenuto.',
  peopleCannotOpenWithout:
    '{people} non possono aprirlo, quindi le loro chat qui rispondono senza questo contenuto.',
};
const lt: Copy = {
  projects: 'Projektai',
  newProject: 'Naujas projektas',
  searchProjects: 'Ieškoti projektų',
  finished: 'Baigti',
  people: 'Žmonės',
  skill: 'Įgūdis',
  noBrief: 'Aprašo dar nėra.',
  createProject: 'Sukurti projektą',
  knowledgePages: 'Žinių puslapiai',
  searchPages: 'Ieškoti puslapių',
  formatting: 'Formatavimas',
  pageTitle: 'Puslapio pavadinimas',
  suggestions: 'Pasiūlymai',
  current: 'Dabartinis',
  agent: 'Agentas',
  runs: 'Vykdymai',
  goal: 'Tikslas',
  instructions: 'Instrukcijos',
  noRuns: 'Vykdymų dar nėra.',
  runNow: 'Vykdyti dabar',
  schedule: 'Tvarkaraštis',
  editors: 'Redaktoriai',
  now: 'Dabar',
  moreFor: 'Daugiau apie {name}',
  brief: 'Aprašas',
  version: 'Versija {count}',
  noBriefLong:
    'Kol kas nėra aprašo. Pokalbyje parašykite, kas yra šis darbas ir kokios jo taisyklės.',
  changeInChat: 'Keisti pokalbyje',
  everyChatFollows: 'Kiekvienas čia esantis pokalbis vadovaujasi',
  andReadsFirst: 'Ir pirmiausia skaito',
  file: 'Failas',
  knowledge: 'Žinios',
  youLeadIt: 'Jūs vadovaujate.',
  personLeadsIt: '{name} vadovauja.',
  everyoneAtCanFind: 'Visi įmonės {company} darbuotojai gali jį rasti.',
  shareWhenOthers: 'Pasidalykite juo, kai kiti turėtų čia dirbti.',
  projectAccessNote:
    'Buvimas projekte nesuteikia prieigos prie nieko. Kiekvienas elementas turi savo prieigos teises, o pokalbiai čia vyksta juos pradėjusio asmens teisėmis.',
  project: 'Projektas',
  needsYou: 'Reikia jūsų',
  review: 'Peržiūra',
  inThisProject: 'Šiame projekte',
  deleteQuestion: 'Ištrinti {name}?',
  deleteDescription:
    'Bus pašalintas tik projektas. Jo pokalbiai, failai ir rezultatai liks juos valdančių žmonių paskyrose ten, kur buvo.',
  deleteConfirm: 'Ištrinti {name}',
  projectDeleted: '{name} ištrintas. Jo pokalbiai ir darbas liko ten, kur buvo.',
  couldntDelete: 'Nepavyko ištrinti {name}.',
  itemOutSuccess: '{item} pašalintas iš {project}. Daugiau niekas nepasikeitė.',
  itemOutError: 'Nepavyko pašalinti {item} iš {project}.',
  moveOutProject: 'Perkelti iš projekto',
  takeOutProject: 'Pašalinti iš projekto',
  unavailableTitle: 'Šis projektas nepasiekiamas',
  unavailableDescription:
    'Jis galėjo būti ištrintas arba nebuvo su jumis bendrinamas. Jums niekas jame nepasikeitė.',
  allProjects: 'Visi projektai',
  openingProject: 'Atidaromas projektas…',
  ended: 'Baigėsi',
  ends: 'Baigiasi',
  yesterday: 'Vakar',
  roleLead: 'Vadovas',
  roleCanEdit: 'Gali redaguoti',
  roleCanUse: 'Gali naudoti',
  visibilityCompany: 'Visi įmonės {company} darbuotojai',
  visibilityMembers: 'Pasirinkti kolegos',
  visibilityPrivate: 'Tik jūs',
  kindApp: 'Programa',
  kindDeck: 'Pateiktis',
  kindSheet: 'Skaičiuoklė',
  kindChart: 'Diagrama',
  kindDashboard: 'Valdymo skydas',
  kindReport: 'Ataskaita',
  kindChat: 'Pokalbis',
  kindFile: 'Failas',
  kindMeeting: 'Susitikimas',
  kindAgent: 'Agentas',
  kindDocument: 'Dokumentas',
  you: 'Jūs',
  gettingAnswer: 'Rengiamas atsakymas',
  gettingAnswerOther: '{name} rengia atsakymą',
  addedByYou: 'pridėjote jūs',
  addedByOther: 'pridėjo {name}',
  renameProjectDescription: 'Pervadinkite, pakeiskite aprašą arba pabaigos datą',
  deleteProject: 'Ištrinti projektą',
  openToShare: 'Atidarykite, kad galėtumėte bendrinti',
  sharingSaved: 'Bendrinimo nustatymai išsaugoti. {name} nebėra bendrinamas su jumis.',
  onlyOwnerPrivate: 'Tik {name} gali padaryti jį privatų',
  add: 'Pridėti',
  addTo: 'Pridėti į {name}',
  addAnything:
    'Bet ką, ką galite atidaryti. Jo prieiga valdoma atskirai: pridėjus čia, jis niekam netampa bendrinamas.',
  couldntAdd: 'Nepavyko pridėti {name}.',
  projectReadyChat:
    '{name} paruoštas, o šis pokalbis yra jame. Nepasikeitė, kas gali atidaryti pokalbį.',
  projectReadyPrivate: '{name} paruoštas. Tik jūs galite jį atidaryti.',
  projectCreatedNotice: '{name} sukurtas. Viskas jame išlaiko savo prieigos teises.',
  latestAnswerYou: 'Gaunate atsakymą',
  latestAnswerOther: '{name} gauna atsakymą',
  inProjectMove: 'Projekte „{name}“. Perkelti šį pokalbį',
  notInProjectMove: 'Ne projekte. Perkelti šį pokalbį',
  movedTo: 'Perkelta į',
  accessUnchanged: 'Kas gali atidaryti šį pokalbį, nepasikeitė.',
  theProject: 'projektą',
  in: 'Projekte',
  stopMakingProject: 'Nebekurti naujo projekto šiame pokalbyje',
  searchYourWork: 'Ieškoti savo darbo',
  searchDocuments: 'Ieškoti dokumentų, failų ir susitikimų…',
  yourWork: 'Jūsų darbas',
  looking: 'Ieškoma…',
  nothingMatchesChat:
    'Atitikmenų nėra. Norėdami įtraukti pokalbį, atidarykite jį ir naudokite jo vietą antraštėje.',
  typeToFind: 'Įveskite, kad rastumėte darbą, kurį galite atidaryti.',
  newProjectDraft: 'Naujas projektas · Juodraštis {count} · Dar nesukurtas',
  projectCreatedOpen: 'Projektas sukurtas · Atidaryti',
  aNewProject: 'Naujas projektas',
  draftIntro:
    'Pokalbyje pasakykite, koks yra darbas. Poneva čia parengs projektą, nurodydama, ką įtraukti ir su kuo bendrinti. Nieko nesukursime, kol to nepatvirtinsite.',
  draft: 'Juodraštis',
  projectCreatedAccess: 'Sukurta. Kiekvienas elementas išlaiko savo prieigą.',
  changeInChatDraft: 'Pokalbyje pasakykite, ką pakeisti.',
  chatOwnerCreate: 'Jį sukurti gali tik šio pokalbio savininkas.',
  open: 'Atidaryti',
  creating: 'Kuriama…',
  cannotOpenDraft:
    '{people} negali atidaryti {title}, todėl jų pokalbiai čia atsakytų be jo. Pokalbyje nurodykite, ar paprašyti jo savininko suteikti prieigą, ar jo neįtraukti.',
  bringsIn: 'Įtraukiama: {count}',
  thisChat: 'Šis pokalbis',
  takenOutDraft: 'Pašalinta iš juodraščio {count}',
  nothingYet: 'Kol kas nieko. Pokalbyje nurodykite, kas čia priklauso.',
  leftOut: 'Neįtraukta: {items}.',
  whoCanUse: 'Kas gali naudoti',
  youLead: 'Jūs, vadovas',
  beingInProject: 'Buvimas projekte nieko neatidaro. Kiekvienas elementas išlaiko savo prieigą.',
  onlyYouUntilShare: 'Kol nepasidalysite, jis bus matomas tik jums.',
  colour: 'Spalva',
  sand: 'Smėlio',
  green: 'Žalia',
  blue: 'Mėlyna',
  grey: 'Pilka',
  firstProject: 'Pradėkite pirmąjį projektą',
  firstProjectDescription:
    'Suteikite jam pavadinimą – kiekvienas jame pradėtas pokalbis matys tą pačią santrauką. Įtraukite jau turimą darbą ir bendrinkite jį, kai kiti turės jame dirbti.',
  loadingProjects: 'Įkeliami projektai…',
  thisChatMoves: 'Šis pokalbis bus perkeltas į projektą. Kas gali jį atidaryti, nesikeis.',
  whatIsWork: 'Koks tai darbas?',
  optional: 'Pasirenkama',
  writeFromChat: 'Parašyti iš šio pokalbio',
  briefPlaceholder: 'Kam jis skirtas, kokių taisyklių laikytis, kurios datos svarbios.',
  briefDraftHelp:
    'Kiekvienas projekto pokalbis pirmiausia skaito šią santrauką. Parinktis „Parašyti iš šio pokalbio“ paprašo Poneva parengti ją šalia pokalbio; vis tiek turėsite pasirinkti „Sukurti“.',
  briefLaterHelp:
    'Kiekvienas projekto pokalbis pirmiausia skaito šią santrauką. Vėliau ją galite pakeisti paprašę bet kuriame projekto pokalbyje.',
  sendClearFirst:
    'Pirmiausia išsiųskite arba išvalykite neišsiųstą žinutę ir priedus, kad galėtumėte parengti santrauką iš šio pokalbio.',
  createProjectError: 'Nepavyko sukurti projekto. Bandykite dar kartą.',
  onlyYouUntil: 'Tik jums, kol nepasidalysite',
  whereChat: 'Kur yra šis pokalbis',
  whereChatHelp:
    'Pokalbis vienu metu gali būti tik viename projekte. Jį perkėlus, teisė jį atidaryti nepasikeis.',
  searchCreateProject: 'Ieškoti projekto arba sukurti naują',
  noProject: 'Nėra projekto',
  inCompanyChats: 'Jūsų pokalbiai įmonėje {company}',
  newProjectWithChat: 'Naujas projektas su šiuo pokalbiu',
  newProjectNamedWithChat: 'Naujas projektas „{name}“ su šiuo pokalbiu',
  makingProject: 'Kuriamas naujas projektas',
  moveToProject: 'Perkelti šį pokalbį į {name}',
  chatInProject: 'Šis pokalbis yra projekte {name}.',
  looksLikeWork: 'Panašu, kad tai yra {name} darbas. Perkelti jį ten?',
  accessBriefNext:
    'Kas gali jį atidaryti, nepasikeitė. Nuo kitos jūsų žinutės jis skaitys projekto santrauką.',
  moveFailed: 'Nepavyko perkelti. Bandykite dar kartą arba naudokite jo vietą antraštėje.',
  accessBriefNextTypographic:
    'Kas gali jį atidaryti, nesikeičia. Nuo kitos jūsų žinutės jis skaitys projekto santrauką.',
  openProject: 'Atidaryti projektą',
  move: 'Perkelti',
  movedOut: 'Perkelta iš projekto. Kas gali jį atidaryti, nepasikeitė.',
  chatLivesHere: 'Šis pokalbis dabar yra čia. Kas gali jį atidaryti, nepasikeitė.',
  addedTo: '{item} pridėta į {project}',
  addedAccess: 'Jis išlaiko savo prieigą. Pridėjus čia, jis niekam netampa bendrinamas.',
  removedOut:
    '{item} pašalinta iš {project}. Ji lieka ten, kur yra, o kas gali ją atidaryti, nepasikeitė.',
  itIs: 'Tai yra',
  couldntMoveChat: 'Nepavyko perkelti šio pokalbio.',
  sharingCheckFailed:
    'Nepavyko patikrinti, kas gali atidaryti pirmiausia skaitomus elementus. Prieš bendrindami šį projektą patikrinkite jų prieigą.',
  cannotOpenShare: '{people} negali atidaryti {title}.',
  readsFirstShare:
    'Kiekvienas šio projekto pokalbis pirmiausia jį skaito, todėl jų pokalbiai čia atsakytų be jo. Projekto bendrinimas to nekeičia.',
  sharingSavedUnread:
    'Bendrinimas išsaugotas. Projekto {name} dabar nepavyko perskaityti iš naujo.',
  formerColleague: 'Buvęs kolega',
  madeInChatHere: 'sukurta čia vykusiame pokalbyje',
  latestStarted: '{name} pradėjo {title}',
  latestStartedYou: 'Jūs pradėjote {title}',
  latestContinued: '{name} tęsė {title}',
  latestContinuedYou: 'Jūs tęsėte {title}',
  latestMade: '{name} sukūrė {title}',
  latestMadeYou: 'Jūs sukūrėte {title}',
  latestAdded: '{name} pridėjo {title}',
  latestAddedYou: 'Jūs pridėjote {title}',
  projectChipLives:
    'Šis pokalbis priklauso projektui {name} ir skaito jo aprašą. Perkelkite jį iš pirmosios antraštės dalies.',
  addExistingWork: 'Pridėkite jau turimą darbą',
  nameLabel: 'Pavadinimas',
  projectNameExample: 'Juodasis penktadienis 2026',
  itemsOne: '{count} elementas',
  itemsMany: 'Elementų: {count}',
  itemsAllStillHere: '{items}, visi vis dar čia',
  projectsOverviewDescription:
    'Viena vieta kiekvienam darbui. Įdėjus ką nors į projektą, nepasikeičia, kas gali tai atidaryti.',
  noProjectMatchesHint: 'Nėra tinkamo projekto. Išbandykite žodį iš jo pavadinimo ar aprašo.',
  aboutProject: 'Apie šį projektą',
  aboutShort: 'Apie',
  workingIn: 'Dirbama projekte {name}',
  noBriefHome:
    'Aprašo dar nėra. Pokalbyje čia pasakykite, koks tai darbas; kiekvienas projekto pokalbis jį perskaito pirmiausia.',
  tabAll: 'Viskas',
  tabChats: 'Pokalbiai',
  tabResults: 'Rezultatai',
  tabFiles: 'Failai',
  emptyChats: 'Čia dar nėra pokalbių. Pradėkite vieną aukščiau.',
  emptyResults:
    'Čia dar nieko nesukurta. Tai, ką sukursite čia vykstančiame pokalbyje, atsiras čia.',
  emptyFiles:
    'Čia dar nėra failų. Failai, kuriuos pridėsite čia vykstančiame pokalbyje, atsiras čia.',
  showTabs: 'Rodyti',
  newestShown: 'Čia rodoma naujausių: {shown} iš {count}.',
  nothingHereYet: 'Čia dar nieko nėra.',
  homeEmptyHelp:
    'Aukščiau pradėti pokalbiai atsiras čia, taip pat ir juose pridėti failai bei sukurti rezultatai.',
  shareWithPeopleDoingIt: 'Bendrinti su juo dirbančiais žmonėmis',
  briefWrittenBy: '{version} · parašyta: {name}, {when}',
  briefChangedBy: '{version} · pakeista: {name}, {when}',
  personWorksInIt: '{people} dirba jame.',
  peopleWorkInIt: '{people} dirba jame.',
  aboutUnavailable:
    'Šis projektas nepasiekiamas. Gali būti, kad jis ištrintas arba nebendrinamas su jumis.',
  landedIn: 'Projekte {name} · {access}',
  landedOnlyYou: 'Tik jūs galite jį atidaryti',
  youWorkInIt: 'Jūs dirbate jame.',
  youAndPeopleWorkInIt: 'Jūs ir {people} dirbate jame.',
  landedCompanyCanOpen: 'Visi įmonės {company} darbuotojai gali jį atidaryti',
  landedMembersCanOpen: 'Pasirinkti kolegos gali jį atidaryti',
  briefWrittenByYou: '{version} · parašyta jūsų, {when}',
  briefChangedByYou: '{version} · pakeista jūsų, {when}',
  briefWrittenByFormer: '{version} · parašyta buvusio kolegos, {when}',
  briefChangedByFormer: '{version} · pakeista buvusio kolegos, {when}',
  addedByFormer: 'pridėjo buvęs kolega',
  formerColleagueLeadsIt: 'Buvęs kolega vadovauja.',
  projectLoadFailed: 'Šio projekto nepavyko įkelti.',
  personCannotOpenWithout:
    '{people} negali to atidaryti, todėl šio asmens pokalbiai čia pateiks atsakymus be to.',
  peopleCannotOpenWithout:
    '{people} negali to atidaryti, todėl jų pokalbiai čia pateiks atsakymus be to.',
};
const lv: Copy = {
  projects: 'Projekti',
  newProject: 'Jauns projekts',
  searchProjects: 'Meklēt projektus',
  finished: 'Pabeigti',
  people: 'Cilvēki',
  skill: 'Prasme',
  noBrief: 'Īsa apraksta vēl nav.',
  createProject: 'Izveidot projektu',
  knowledgePages: 'Zināšanu lapas',
  searchPages: 'Meklēt lapas',
  formatting: 'Formatēšana',
  pageTitle: 'Lapas nosaukums',
  suggestions: 'Ieteikumi',
  current: 'Pašreizējais',
  agent: 'Aģents',
  runs: 'Izpildes',
  goal: 'Mērķis',
  instructions: 'Norādes',
  noRuns: 'Izpildes vēl nav.',
  runNow: 'Palaist tagad',
  schedule: 'Grafiks',
  editors: 'Redaktori',
  now: 'Tagad',
  moreFor: 'Vairāk par {name}',
  brief: 'Īsais apraksts',
  version: 'Versija {count}',
  noBriefLong:
    'Pagaidām nav īsā apraksta. Pasaki tērzēšanā, kas ir šis darbs un kādi ir tā noteikumi.',
  changeInChat: 'Mainīt tērzēšanā',
  everyChatFollows: 'Katra šeit esošā saruna ievēro',
  andReadsFirst: 'Un vispirms izlasa',
  file: 'Fails',
  knowledge: 'Zināšanas',
  youLeadIt: 'Tu to vadi.',
  personLeadsIt: 'To vada {name}.',
  everyoneAtCanFind: 'Ikviens uzņēmumā {company} to var atrast.',
  shareWhenOthers: 'Nodod to citiem, kad viņiem šeit jāstrādā.',
  projectAccessNote:
    'Dalība projektā neko neatver. Katram vienumam ir sava piekļuve, un tērzēšanas šeit notiek tās personas vārdā, kura tās sāk.',
  project: 'Projekts',
  needsYou: 'Nepieciešama tava iesaiste',
  review: 'Izskatīt',
  inThisProject: 'Šajā projektā',
  deleteQuestion: 'Dzēst {name}?',
  deleteDescription:
    'Pazudīs tikai projekts. Tā tērzēšanas, faili un rezultāti paliks to īpašniekiem tur, kur tie bija.',
  deleteConfirm: 'Dzēst {name}',
  projectDeleted: '{name} ir izdzēsts. Tā tērzēšanas un darbi paliek tur, kur tie bija.',
  couldntDelete: 'Neizdevās izdzēst {name}.',
  itemOutSuccess: '{item} ir izņemts no {project}. Nekas cits nav mainījies.',
  itemOutError: 'Neizdevās izņemt {item} no {project}.',
  moveOutProject: 'Pārvietot ārpus projekta',
  takeOutProject: 'Izņemt no projekta',
  unavailableTitle: 'Šis projekts nav pieejams',
  unavailableDescription:
    'Iespējams, tas ir izdzēsts vai arī nav kopīgots ar tevi. Tev nekas tajā nav mainījies.',
  allProjects: 'Visi projekti',
  openingProject: 'Atver projektu…',
  ended: 'Beidzies',
  ends: 'Beidzas',
  yesterday: 'Vakar',
  roleLead: 'Vadītājs',
  roleCanEdit: 'Var rediģēt',
  roleCanUse: 'Var izmantot',
  visibilityCompany: 'Ikviens uzņēmumā {company}',
  visibilityMembers: 'Atlasītie kolēģi',
  visibilityPrivate: 'Tikai tu',
  kindApp: 'Lietotne',
  kindDeck: 'Prezentācija',
  kindSheet: 'Izklājlapa',
  kindChart: 'Diagramma',
  kindDashboard: 'Informācijas panelis',
  kindReport: 'Pārskats',
  kindChat: 'Tērzēšana',
  kindFile: 'Fails',
  kindMeeting: 'Sanāksme',
  kindAgent: 'Aģents',
  kindDocument: 'Dokuments',
  you: 'Tu',
  gettingAnswer: 'Tiek sagatavota atbilde',
  gettingAnswerOther: '{name} gatavo atbildi',
  addedByYou: 'pievienoji tu',
  addedByOther: 'pievienoja {name}',
  renameProjectDescription: 'Pārdēvē to, maini īso aprakstu vai beigu datumu',
  deleteProject: 'Dzēst projektu',
  openToShare: 'Atveriet, lai kopīgotu',
  sharingSaved: 'Kopīgošanas iestatījumi saglabāti. {name} vairs netiek kopīgots ar jums.',
  onlyOwnerPrivate: 'Tikai {name} var iestatīt privātu piekļuvi',
  add: 'Pievienot',
  addTo: 'Pievienot {name}',
  addAnything:
    'Viss, ko vari atvērt. Tam ir sava piekļuve: pievienošana šeit to nepadara pieejamu nevienam.',
  couldntAdd: 'Neizdevās pievienot {name}.',
  projectReadyChat:
    '{name} ir gatavs, un šī tērzēšana ir tajā. Nav mainījies, kas var atvērt šo tērzēšanu.',
  projectReadyPrivate: '{name} ir gatavs. Tikai jūs varat to atvērt.',
  projectCreatedNotice: '{name} ir izveidots. Visam tajā paliek savas piekļuves tiesības.',
  latestAnswerYou: 'Jūs saņemat atbildi',
  latestAnswerOther: '{name} saņem atbildi',
  inProjectMove: 'Projektā {name}. Pārvietot šo tērzēšanu',
  notInProjectMove: 'Nav projektā. Pārvietot šo tērzēšanu',
  movedTo: 'Pārvietota uz',
  accessUnchanged: 'Nav mainījies, kas var atvērt šo tērzēšanu.',
  theProject: 'projektu',
  in: 'Sadaļā',
  stopMakingProject: 'Pārtraukt jauna projekta izveidi šajā tērzēšanā',
  searchYourWork: 'Meklēt savā darbā',
  searchDocuments: 'Meklēt dokumentos, failos un sapulcēs…',
  yourWork: 'Tavs darbs',
  looking: 'Meklē…',
  nothingMatchesChat:
    'Nekas neatbilst. Lai pievienotu sarunu, atver to un izmanto tās atrašanās vietu galvenē.',
  typeToFind: 'Raksti, lai atrastu darbu, ko vari atvērt.',
  newProjectDraft: 'Jauns projekts · Melnraksts {count} · Vēl nav izveidots',
  projectCreatedOpen: 'Projekts izveidots · Atvērt',
  aNewProject: 'Jauns projekts',
  draftIntro:
    'Pasaki sarunā, kas ir jādara. Poneva šeit sagatavo projektu, norādot, ko pievienot un ar ko to kopīgot. Nekas netiek izveidots, kamēr to neapstiprināsi.',
  draft: 'Melnraksts',
  projectCreatedAccess: 'Izveidots. Katram elementam tiek saglabāta tā piekļuve.',
  changeInChatDraft: 'Maini jebko, pasakot to sarunā.',
  chatOwnerCreate: 'To izveidot var tikai šīs sarunas īpašnieks.',
  open: 'Atvērt',
  creating: 'Tiek izveidots…',
  cannotOpenDraft:
    '{people} nevar atvērt {title}, tāpēc viņu sarunas šeit atbildētu, neizmantojot to. Pasaki sarunā, vai lūgt tā īpašniekam piešķirt piekļuvi vai atstāt to ārpus projekta.',
  bringsIn: 'Iekļauj {count}',
  thisChat: 'Šī saruna',
  takenOutDraft: 'Izņemts no melnraksta {count}',
  nothingYet: 'Pagaidām nekā nav. Nosauc sarunā, kam šeit jābūt.',
  leftOut: 'Atstāts ārpusē: {items}.',
  whoCanUse: 'Kas to var izmantot',
  youLead: 'Tu — vadītājs',
  beingInProject:
    'Atrašanās projektā neatver piekļuvi nekam. Katram elementam tiek saglabāta tā piekļuve.',
  onlyYouUntilShare: 'Tas paliek pieejams tikai tev, līdz to kopīgo.',
  colour: 'Krāsa',
  sand: 'Smilšu',
  green: 'Zaļa',
  blue: 'Zila',
  grey: 'Pelēka',
  firstProject: 'Sāc savu pirmo projektu',
  firstProjectDescription:
    'Nosauc to, un katra tajā sākta saruna izlasīs to pašu aprakstu. Pievieno jau esošu darbu un kopīgo to, kad citiem tajā jāstrādā.',
  loadingProjects: 'Ielādē projektus…',
  thisChatMoves: 'Šī saruna tiks pārvietota uz projektu. Tas, kas to var atvērt, nemainīsies.',
  whatIsWork: 'Kas ir jādara?',
  optional: 'Neobligāti',
  writeFromChat: 'Uzrakstīt no šīs sarunas',
  briefPlaceholder: 'Kam tas paredzēts, kādi noteikumi jāievēro un kuri datumi ir svarīgi.',
  briefDraftHelp:
    'Katra projekta saruna vispirms izlasīs šo aprakstu. “Uzrakstīt no šīs sarunas” lūdz Poneva sagatavot to blakus sarunai; izveidi joprojām apstiprini tu.',
  briefLaterHelp:
    'Katra projekta saruna vispirms izlasīs šo aprakstu. Vēlāk to vari mainīt, palūdzot to jebkurā šī projekta sarunā.',
  sendClearFirst:
    'Vispirms nosūti vai notīri nenosūtīto ziņojumu un pielikumus, lai aprakstu uzrakstītu no šīs sarunas.',
  createProjectError: 'Neizdevās izveidot projektu. Mēģini vēlreiz.',
  onlyYouUntil: 'Tikai tev, līdz kopīgošanai',
  whereChat: 'Kur atrodas šī saruna',
  whereChatHelp:
    'Saruna vienlaikus var atrasties tikai vienā projektā. Tās pārvietošana nemaina to, kas to var atvērt.',
  searchCreateProject: 'Meklēt vai izveidot projektu',
  noProject: 'Nav projekta',
  inCompanyChats: 'Tavās sarunās uzņēmumā {company}',
  newProjectWithChat: 'Jauns projekts ar šo sarunu',
  newProjectNamedWithChat: 'Jauns projekts “{name}” ar šo sarunu',
  makingProject: 'Tiek veidots jauns projekts',
  moveToProject: 'Pārvietot šo sarunu uz {name}',
  chatInProject: 'Šī saruna atrodas projektā {name}.',
  looksLikeWork: 'Šķiet, ka tas ir {name} darbs. Pārvietot to tur?',
  accessBriefNext:
    'Tas, kas to var atvērt, nav mainījies. Sākot ar nākamo ziņojumu, saruna izlasīs projekta aprakstu.',
  moveFailed: 'Neizdevās to pārvietot. Mēģini vēlreiz vai izmanto tā atrašanās vietu galvenē.',
  accessBriefNextTypographic:
    'Tas, kas to var atvērt, nemainās. Sākot ar nākamo ziņojumu, saruna izlasīs projekta aprakstu.',
  openProject: 'Atvērt projektu',
  move: 'Pārvietot',
  movedOut: 'Izņemts no projekta. Tas, kas to var atvērt, nav mainījies.',
  chatLivesHere: 'Šī saruna tagad atrodas šeit. Tas, kas to var atvērt, nav mainījies.',
  addedTo: '{item} pievienots projektam {project}',
  addedAccess: 'Tam tiek saglabāta sava piekļuve. Pievienošana šeit to nepadara pieejamu nevienam.',
  removedOut:
    '{item} izņemts no {project}. Tas paliek savā atrašanās vietā, un tas, kas to var atvērt, nav mainījies.',
  itIs: 'Tas ir',
  couldntMoveChat: 'Neizdevās pārvietot šo sarunu.',
  sharingCheckFailed:
    'Neizdevās pārbaudīt, kas var atvērt elementus, kurus visas sarunas izlasa vispirms. Pirms šī projekta kopīgošanas pārbaudi to piekļuvi.',
  cannotOpenShare: '{people} nevar atvērt {title}.',
  readsFirstShare:
    'Katra šī projekta saruna to vispirms izlasīs, tāpēc viņu sarunas šeit atbildētu, neizmantojot to. Projekta kopīgošana to nemaina.',
  sharingSavedUnread: 'Kopīgošana saglabāta. Projektu {name} šobrīd neizdevās nolasīt vēlreiz.',
  formerColleague: 'Bijušais kolēģis',
  madeInChatHere: 'izveidots šeit notikušā tērzēšanā',
  latestStarted: '{name} sāka {title}',
  latestStartedYou: 'Jūs sākāt {title}',
  latestContinued: '{name} turpināja {title}',
  latestContinuedYou: 'Jūs turpinājāt {title}',
  latestMade: '{name} izveidoja {title}',
  latestMadeYou: 'Jūs izveidojāt {title}',
  latestAdded: '{name} pievienoja {title}',
  latestAddedYou: 'Jūs pievienojāt {title}',
  projectChipLives:
    'Šī tērzēšana ir projektā {name} un lasa tā īso aprakstu. Pārvietojiet to no galvenes pirmās daļas.',
  addExistingWork: 'Pievienojiet jau esošu darbu',
  nameLabel: 'Nosaukums',
  projectNameExample: 'Melnā piektdiena 2026',
  itemsOne: '{count} elements',
  itemsMany: 'Elementi: {count}',
  itemsAllStillHere: '{items}, viss joprojām šeit',
  projectsOverviewDescription:
    'Viena vieta katram darbam. Ievietojot kaut ko projektā, nemainās tas, kas to var atvērt.',
  noProjectMatchesHint:
    'Neviens projekts neatbilst. Izmēģiniet vārdu no tā nosaukuma vai īsā apraksta.',
  aboutProject: 'Par šo projektu',
  aboutShort: 'Par',
  workingIn: 'Darbs projektā {name}',
  noBriefHome:
    'Īsā apraksta vēl nav. Tērzēšanā šeit pasakiet, kāds ir darbs; katra projekta tērzēšana to izlasa vispirms.',
  tabAll: 'Viss',
  tabChats: 'Tērzēšanas',
  tabResults: 'Rezultāti',
  tabFiles: 'Faili',
  emptyChats: 'Šeit vēl nav tērzēšanu. Sāciet vienu augstāk.',
  emptyResults:
    'Šeit vēl nekas nav izveidots. Tas, ko izveidosiet šeit notiekošā tērzēšanā, parādīsies šeit.',
  emptyFiles:
    'Šeit vēl nav failu. Faili, ko pievienosiet šeit notiekošā tērzēšanā, parādīsies šeit.',
  showTabs: 'Rādīt',
  newestShown: 'Šeit redzami jaunākie: {shown} no {count}.',
  nothingHereYet: 'Šeit vēl nekā nav.',
  homeEmptyHelp:
    'Augstāk sāktās tērzēšanas parādīsies šeit, tāpat kā tajās pievienotie faili un izveidotie rezultāti.',
  shareWithPeopleDoingIt: 'Kopīgot ar cilvēkiem, kas pie tā strādā',
  briefWrittenBy: '{version} · uzrakstīja: {name}, {when}',
  briefChangedBy: '{version} · mainīja: {name}, {when}',
  personWorksInIt: '{people} strādā pie tā.',
  peopleWorkInIt: '{people} strādā pie tā.',
  aboutUnavailable:
    'Šis projekts nav pieejams. Iespējams, tas ir izdzēsts vai nav kopīgots ar jums.',
  landedIn: 'Projektā {name} · {access}',
  landedOnlyYou: 'Tikai jūs to varat atvērt',
  youWorkInIt: 'Jūs strādājat pie tā.',
  youAndPeopleWorkInIt: 'Jūs un {people} strādājat pie tā.',
  landedCompanyCanOpen: 'Ikviens uzņēmumā {company} to var atvērt',
  landedMembersCanOpen: 'Atlasītie kolēģi to var atvērt',
  briefWrittenByYou: '{version} · uzrakstījāt jūs, {when}',
  briefChangedByYou: '{version} · mainījāt jūs, {when}',
  briefWrittenByFormer: '{version} · uzrakstīja bijušais kolēģis, {when}',
  briefChangedByFormer: '{version} · mainīja bijušais kolēģis, {when}',
  addedByFormer: 'pievienoja bijušais kolēģis',
  formerColleagueLeadsIt: 'To vada bijušais kolēģis.',
  projectLoadFailed: 'Šo projektu nevarēja ielādēt.',
  personCannotOpenWithout:
    '{people} to nevar atvērt, tāpēc šīs personas tērzēšanas šeit notiek bez tā.',
  peopleCannotOpenWithout: '{people} to nevar atvērt, tāpēc viņu tērzēšanas šeit notiek bez tā.',
};
const mt: Copy = {
  projects: 'Proġetti',
  newProject: 'Proġett ġdid',
  searchProjects: 'Fittex proġetti',
  finished: 'Lesti',
  people: 'Nies',
  skill: 'Ħila',
  noBrief: 'Għad m’hemmx deskrizzjoni.',
  createProject: 'Oħloq proġett',
  knowledgePages: 'Paġni tal-għarfien',
  searchPages: 'Fittex paġni',
  formatting: 'Ifformattjar',
  pageTitle: 'Titlu tal-paġna',
  suggestions: 'Suġġerimenti',
  current: 'Kurrenti',
  agent: 'Aġent',
  runs: 'Ħidmiet',
  goal: 'Għan',
  instructions: 'Istruzzjonijiet',
  noRuns: 'Għad m’hemmx ħidmiet.',
  runNow: 'Ħaddem issa',
  schedule: 'Skeda',
  editors: 'Edituri',
  now: 'Issa',
  moreFor: 'Aktar għal {name}',
  brief: 'Brief',
  version: 'Verżjoni {count}',
  noBriefLong: "Għad m'hemmx brief. Għid f'chat x'inhu dan ix-xogħol u x'inhuma r-regoli tiegħu.",
  changeInChat: 'Ibdel fil-chat',
  everyChatFollows: 'Kull chat hawn isegwi',
  andReadsFirst: 'U jaqra l-ewwel',
  file: 'Fajl',
  knowledge: 'Għarfien',
  youLeadIt: 'Int tmexxih.',
  personLeadsIt: '{name} jmexxih.',
  everyoneAtCanFind: "Kulħadd f'{company} jista' jsibu.",
  shareWhenOthers: 'Aqsamha meta oħrajn għandhom jaħdmu hawn.',
  projectAccessNote:
    'Li tkun fil-proġett ma jiftaħ xejn. Kull oġġett iżomm l-aċċess tiegħu, u l-chats hawn jimxu bħala l-persuna li tibdahom.',
  project: 'Proġett',
  needsYou: 'Jeħtieġek',
  review: 'Reviżjoni',
  inThisProject: "F'dan il-proġett",
  deleteQuestion: 'Tħassar {name}?',
  deleteDescription:
    'Jitneħħa l-proġett biss. Il-chats, il-fajls u r-riżultati tiegħu jibqgħu man-nies li għandhomhom, fejn kienu qabel.',
  deleteConfirm: 'Ħassar {name}',
  projectDeleted: '{name} tħassar. Il-chats u x-xogħol tiegħu jibqgħu fejn kienu.',
  couldntDelete: 'Ma setax jitħassar {name}.',
  itemOutSuccess: '{item} tneħħa minn {project}. Xejn aktar ma nbidel.',
  itemOutError: 'Ma setax jitneħħa {item} minn {project}.',
  moveOutProject: 'Mexxi barra mill-proġett',
  takeOutProject: 'Neħħi mill-proġett',
  unavailableTitle: 'Dan il-proġett mhux disponibbli',
  unavailableDescription:
    "Jista' jkun tħassar, jew mhux maqsum miegħek. Xejn fih ma nbidel għalik.",
  allProjects: 'Il-proġetti kollha',
  openingProject: 'Qed jinfetaħ il-proġett…',
  ended: 'Spiċċa',
  ends: 'Jispiċċa',
  yesterday: 'Ilbieraħ',
  roleLead: 'Mexxej',
  roleCanEdit: "Jista' jeditja",
  roleCanUse: "Jista' juża",
  visibilityCompany: "Kulħadd f'{company}",
  visibilityMembers: 'Kollegi magħżula',
  visibilityPrivate: 'Int biss',
  kindApp: 'App',
  kindDeck: 'Preżentazzjoni',
  kindSheet: 'Folja',
  kindChart: 'Grafika',
  kindDashboard: "Pannell ta' kontroll",
  kindReport: 'Rapport',
  kindChat: 'Chat',
  kindFile: 'Fajl',
  kindMeeting: 'Laqgħa',
  kindAgent: 'Aġent',
  kindDocument: 'Dokument',
  you: 'Int',
  gettingAnswer: 'Qed tinkiseb tweġiba',
  gettingAnswerOther: '{name} qed jikseb tweġiba',
  addedByYou: 'miżjud minnek',
  addedByOther: 'miżjud minn {name}',
  renameProjectDescription: 'Semmih mill-ġdid, ibdel il-brief jew id-data tat-tmiem tiegħu',
  deleteProject: 'Ħassar il-proġett',
  openToShare: 'Iftaħha biex taqsamha',
  sharingSaved: "Il-kondiviżjoni ġiet salvata. {name} m'għadux kondiviż miegħek.",
  onlyOwnerPrivate: "Huwa biss {name} li jista' jagħmilha privata",
  add: 'Żid',
  addTo: 'Żid ma’ {name}',
  addAnything:
    'Kull ħaġa li tista’ tiftaħ. Żżomm l-aċċess tagħha stess: jekk iżżidha hawn ma taqsamha ma’ ħadd.',
  couldntAdd: 'Ma setax iżid lil {name}.',
  projectReadyChat: '{name} lest, u din iċ-chat tinsab fih. Ma nbidilx min jista’ jiftaħ iċ-chat.',
  projectReadyPrivate: '{name} lest. Int biss tista’ tiftaħha.',
  projectCreatedNotice: '{name} inħoloq. Kull ħaġa fih iżżomm l-aċċess tagħha stess.',
  latestAnswerYou: 'Qed tirċievi tweġiba',
  latestAnswerOther: '{name} qed jirċievi tweġiba',
  inProjectMove: 'F’{name}. Mexxi din iċ-chat',
  notInProjectMove: 'Mhux fi proġett. Mexxi din iċ-chat',
  movedTo: 'Imċaqlaq għal',
  accessUnchanged: 'Min jista’ jiftaħ din iċ-chat ma nbidilx.',
  theProject: 'il-proġett',
  in: 'Fi',
  stopMakingProject: 'Waqqaf milli toħloq proġett ġdid f’din iċ-chat',
  searchYourWork: 'Fittex fix-xogħol tiegħek',
  searchDocuments: 'Fittex dokumenti, fajls u laqgħat…',
  yourWork: 'Ix-xogħol tiegħek',
  looking: 'Qed infittex…',
  nothingMatchesChat:
    'Ma nstab xejn li jaqbel. Biex iġġib chat, iftaħha u uża l-post tagħha fil-header.',
  typeToFind: 'Ittajpja biex issib xogħol li tista’ tiftaħ.',
  newProjectDraft: 'Proġett ġdid · Abbozz {count} · Għadu ma nħoloqx',
  projectCreatedOpen: 'Inħoloq il-proġett · Iftaħu',
  aNewProject: 'Proġett ġdid',
  draftIntro:
    'Għid fil-chat x’inhu x-xogħol. Poneva jabbozza l-proġett hawn, b’dak li għandu jiddaħħal u ma’ min għandu jinqasam. Xejn ma jinħoloq sakemm ma tgħidx hekk.',
  draft: 'Abbozz',
  projectCreatedAccess: 'Inħoloq. Kull ħaġa fih iżżomm l-aċċess tagħha stess.',
  changeInChatDraft: 'Ibdel kull ħaġa billi tgħid hekk fil-chat.',
  chatOwnerCreate: 'Il-persuna li għandha dan il-chat biss tista’ toħolqu.',
  open: 'Iftaħ',
  creating: 'Qed jinħoloq…',
  cannotOpenDraft:
    '{people} ma jistgħux jiftħu {title}, għalhekk il-chats tagħhom hawn iwieġbu mingħajru. Għid fil-chat jekk għandniex nitolbu lil sidu jaqsamha, jew inħalluh barra.',
  bringsIn: 'Idaħħal {count}',
  thisChat: 'Dan il-chat',
  takenOutDraft: 'Tneħħa mill-abbozz {count}',
  nothingYet: 'Għadu xejn. Semmi fil-chat dak li għandu jkun hawn.',
  leftOut: 'Tħalla barra: {items}.',
  whoCanUse: 'Min jista’ jużah',
  youLead: 'Int, mexxej',
  beingInProject: 'Li tkun fil-proġett ma jiftaħ xejn. Kull oġġett iżomm l-aċċess tiegħu stess.',
  onlyYouUntilShare: 'Jibqa’ Aħdek biss sakemm taqsmu.',
  colour: 'Kulur',
  sand: 'Ramel',
  green: 'Aħdar',
  blue: 'Blu',
  grey: 'Griż',
  firstProject: 'Ibda l-ewwel proġett tiegħek',
  firstProjectDescription:
    'Agħtih isem, u kull chat li tibda fih jaqra l-istess brief. Daħħal xogħol li diġà għandek, u aqsamha meta oħrajn għandhom jaħdmu hemm.',
  loadingProjects: 'Qed jitgħabbew il-proġetti…',
  thisChatMoves: 'Dan il-chat jiċċaqlaq fil-proġett. Min jista’ jiftħu ma jinbidilx.',
  whatIsWork: 'X’inhu x-xogħol?',
  optional: 'Mhux obbligatorju',
  writeFromChat: 'Iktbu minn dan il-chat',
  briefPlaceholder: 'Għalxiex hu, ir-regoli li għandhom jiġu segwiti, u d-dati importanti.',
  briefDraftHelp:
    'Kull chat fil-proġett jaqra dan l-ewwel. “Iktbu minn dan il-chat” titlob lil Poneva jabbozzah ħdejn il-chat; xorta int tagħżel “Oħloq”.',
  briefLaterHelp:
    'Kull chat fil-proġett jaqra dan l-ewwel. Ibdelha aktar tard billi titlobha fi kwalunkwe chat hemmhekk.',
  sendClearFirst:
    'Ibgħat jew neħħi l-messaġġ u l-annessi mhux mibgħuta l-ewwel, biex tikteb il-brief minn dan il-chat.',
  createProjectError: 'Ma stajniex noħolqu l-proġett. Erġa’ pprova.',
  onlyYouUntil: 'Aħdek biss, sakemm taqsmu',
  whereChat: 'Fejn jgħix dan il-chat',
  whereChatHelp:
    'Chat jgħix fi proġett wieħed kull darba. Li tmexxih qatt ma jibdel min jista’ jiftħu.',
  searchCreateProject: 'Fittex jew oħloq proġett',
  noProject: 'L-ebda proġett',
  inCompanyChats: 'Fil-chats tiegħek f’{company}',
  newProjectWithChat: 'Proġett ġdid b’dan il-chat',
  newProjectNamedWithChat: 'Proġett ġdid “{name}” b’dan il-chat',
  makingProject: 'Qed jinħoloq proġett ġdid',
  moveToProject: 'Mexxi dan il-chat għal {name}',
  chatInProject: 'Dan il-chat jinsab f’{name}.',
  looksLikeWork: 'Dan jidher li hu xogħol ta’ {name}. Trid tmexxih hemm?',
  accessBriefNext:
    'Min jista’ jiftħu ma nbidilx. Mill-messaġġ li jmiss tiegħek jaqra l-brief tal-proġett.',
  moveFailed: 'Ma stajniex nimxuh. Erġa’ pprova, jew uża l-post tiegħu fil-header.',
  accessBriefNextTypographic:
    'Min jista’ jiftħu ma jinbidilx. Mill-messaġġ li jmiss tiegħek jaqra l-brief tal-proġett.',
  openProject: 'Iftaħ il-proġett',
  move: 'Mexxi',
  movedOut: 'Tneħħa mill-proġett tiegħu. Min jista’ jiftħu ma nbidilx.',
  chatLivesHere: 'Dan il-chat issa jgħix hawn. Min jista’ jiftħu ma nbidilx.',
  addedTo: '{item} ġie miżjud ma’ {project}',
  addedAccess: 'Iżomm l-aċċess tiegħu stess. Jekk iżżidu hawn ma taqsmuh ma’ ħadd.',
  removedOut: '{item} tneħħa minn {project}. Jibqa’ fejn jgħix, u min jista’ jiftħu ma nbidilx.',
  itIs: 'Huwa',
  couldntMoveChat: 'Ma stajniex nimxu dan il-chat.',
  sharingCheckFailed:
    'Ma stajniex niċċekkjaw min jista’ jiftaħ l-oġġetti li jinqraw l-ewwel. Irrevedi l-aċċess tagħhom qabel taqsam dan il-proġett.',
  cannotOpenShare: '{people} ma jistgħux jiftħu {title}.',
  readsFirstShare:
    'Kull chat f’dan il-proġett jaqrah l-ewwel, għalhekk il-chats tagħhom hawn iwieġbu mingħajru. Li taqsam il-proġett ma jbiddilx dan.',
  sharingSavedUnread: 'Il-qsim tħarreġ. {name} ma setax jinqara mill-ġdid issa stess.',
  formerColleague: 'Kollega preċedenti',
  madeInChatHere: "magħmul f'chat hawn",
  latestStarted: '{name} beda {title}',
  latestStartedYou: 'Bdejt {title}',
  latestContinued: '{name} kompla {title}',
  latestContinuedYou: 'Kompliet {title}',
  latestMade: '{name} għamel {title}',
  latestMadeYou: 'Għamilt {title}',
  latestAdded: '{name} żied {title}',
  latestAddedYou: 'Żidt {title}',
  projectChipLives:
    "Dan iċ-chat jinsab f'{name} u jaqra l-brief tiegħu. Mexxiħ mill-ewwel parti tal-intestatura.",
  addExistingWork: 'Żid ix-xogħol li diġà għandek',
  nameLabel: 'Isem',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} element',
  itemsMany: '{count} elementi',
  itemsAllStillHere: '{items}, kollha għadhom hawn',
  projectsOverviewDescription:
    "Post wieħed għal kull biċċa xogħol. Li tqiegħed xi ħaġa fi proġett qatt ma jbiddel min jista' jiftaħha.",
  noProjectMatchesHint: 'L-ebda proġett ma jaqbel. Ipprova kelma mill-isem jew mill-brief tiegħu.',
  aboutProject: 'Dwar dan il-proġett',
  aboutShort: 'Dwar',
  workingIn: "Qed taħdem f'{name}",
  noBriefHome:
    "Għad m'hemm l-ebda brief. Għid f'chat hawn x'inhu x-xogħol; iċ-chats kollha tal-proġett jaqrawh l-ewwel.",
  tabAll: 'Kollox',
  tabChats: 'Chats',
  tabResults: 'Riżultati',
  tabFiles: 'Fajls',
  emptyChats: "Għad m'hemm l-ebda chat hawn. Ibda waħda hawn fuq.",
  emptyResults: "Għad ma sar xejn hawn. Dak li tagħmel f'chat hawn jispiċċa hawn.",
  emptyFiles: "Għad m'hemm l-ebda fajl hawn. Il-fajls li żżid f'chat hawn jispiċċaw hawn.",
  showTabs: 'Uri',
  newestShown: 'Hawn jidhru l-aktar {shown} reċenti minn {count}.',
  nothingHereYet: "Għad m'hemm xejn hawn.",
  homeEmptyHelp:
    'Iċ-chats li tibda hawn fuq jispiċċaw hawn, bħall-fajls li żżid u r-riżultati li tagħmel fihom.',
  shareWithPeopleDoingIt: "Aqsam ma' dawk li qed jagħmlu x-xogħol",
  briefWrittenBy: '{version} · miktub minn {name}, {when}',
  briefChangedBy: '{version} · mibdul minn {name}, {when}',
  personWorksInIt: '{people} jaħdem fih.',
  peopleWorkInIt: '{people} jaħdmu fih.',
  aboutUnavailable:
    "Dan il-proġett mhux disponibbli. Jista' jkun li tneħħa, jew mhux maqsum miegħek.",
  landedIn: "F'{name} · {access}",
  landedOnlyYou: "Int biss tista' tiftaħha",
  youWorkInIt: 'Int taħdem fih.',
  youAndPeopleWorkInIt: 'Int u {people} taħdmu fih.',
  landedCompanyCanOpen: "Kulħadd f'{company} jista' jiftaħha",
  landedMembersCanOpen: 'Kollegi magħżula jistgħu jiftħuha',
  briefWrittenByYou: '{version} · miktub minnek, {when}',
  briefChangedByYou: '{version} · mibdul minnek, {when}',
  briefWrittenByFormer: '{version} · miktub minn kollega preċedenti, {when}',
  briefChangedByFormer: '{version} · mibdul minn kollega preċedenti, {when}',
  addedByFormer: 'miżjud minn kollega preċedenti',
  formerColleagueLeadsIt: 'Kollega preċedenti jmexxih.',
  projectLoadFailed: 'Dan il-proġett ma setax jiġi mgħobbi.',
  personCannotOpenWithout:
    'Dan ma jistax jinfetaħ minn {people}, għalhekk il-chats ta’ din il-persuna hawn iwieġbu mingħajru.',
  peopleCannotOpenWithout:
    '{people} ma jistgħux jiftħu dan, għalhekk il-chats tagħhom hawn iwieġbu mingħajru.',
};
const nl: Copy = {
  projects: 'Projecten',
  newProject: 'Nieuw project',
  searchProjects: 'Projecten zoeken',
  finished: 'Voltooid',
  people: 'Personen',
  skill: 'Vaardigheid',
  noBrief: 'Nog geen briefing.',
  createProject: 'Project maken',
  knowledgePages: 'Kennispagina’s',
  searchPages: 'Pagina’s zoeken',
  formatting: 'Opmaak',
  pageTitle: 'Paginatitel',
  suggestions: 'Suggesties',
  current: 'Huidig',
  agent: 'Agent',
  runs: 'Uitvoeringen',
  goal: 'Doel',
  instructions: 'Instructies',
  noRuns: 'Nog geen uitvoeringen.',
  runNow: 'Nu uitvoeren',
  schedule: 'Planning',
  editors: 'Bewerkers',
  now: 'Nu',
  moreFor: 'Meer voor {name}',
  brief: 'Briefing',
  version: 'Versie {count}',
  noBriefLong:
    'Nog geen briefing. Zeg in een gesprek wat dit werk inhoudt en welke regels ervoor gelden.',
  changeInChat: 'Wijzigen in gesprek',
  everyChatFollows: 'Elke chat hier volgt',
  andReadsFirst: 'En leest als eerste',
  file: 'Bestand',
  knowledge: 'Kennis',
  youLeadIt: 'Jij leidt het.',
  personLeadsIt: '{name} leidt het.',
  everyoneAtCanFind: 'Iedereen bij {company} kan het vinden.',
  shareWhenOthers: 'Deel het wanneer anderen hier moeten werken.',
  projectAccessNote:
    'Deelname aan het project geeft nergens toegang toe. Elk item heeft zijn eigen toegangsrechten en gesprekken hier worden gevoerd namens degene die ze start.',
  project: 'Project',
  needsYou: 'Heeft jouw aandacht nodig',
  review: 'Beoordelen',
  inThisProject: 'In dit project',
  deleteQuestion: '{name} verwijderen?',
  deleteDescription:
    'Alleen het project verdwijnt. De chats, bestanden en resultaten blijven bij de mensen die ze beheren, op de plek waar ze stonden.',
  deleteConfirm: '{name} verwijderen',
  projectDeleted: '{name} is verwijderd. De chats en het werk blijven waar ze waren.',
  couldntDelete: 'Kan {name} niet verwijderen.',
  itemOutSuccess: '{item} is uit {project} verwijderd. Er is verder niets gewijzigd.',
  itemOutError: 'Kan {item} niet uit {project} verwijderen.',
  moveOutProject: 'Uit het project verplaatsen',
  takeOutProject: 'Uit het project verwijderen',
  unavailableTitle: 'Dit project is niet beschikbaar',
  unavailableDescription:
    'Het is mogelijk verwijderd of niet met jou gedeeld. Er is niets aan veranderd voor jou.',
  allProjects: 'Alle projecten',
  openingProject: 'Project wordt geopend…',
  ended: 'Beëindigd',
  ends: 'Eindigt',
  yesterday: 'Gisteren',
  roleLead: 'Leider',
  roleCanEdit: 'Kan bewerken',
  roleCanUse: 'Kan gebruiken',
  visibilityCompany: 'Iedereen bij {company}',
  visibilityMembers: "Geselecteerde collega's",
  visibilityPrivate: 'Alleen jij',
  kindApp: 'App',
  kindDeck: 'Presentatie',
  kindSheet: 'Werkblad',
  kindChart: 'Grafiek',
  kindDashboard: 'Dashboard',
  kindReport: 'Rapport',
  kindChat: 'Chat',
  kindFile: 'Bestand',
  kindMeeting: 'Vergadering',
  kindAgent: 'Agent',
  kindDocument: 'Document',
  you: 'Jij',
  gettingAnswer: 'Werkt aan een antwoord',
  gettingAnswerOther: '{name} werkt aan een antwoord',
  addedByYou: 'toegevoegd door jou',
  addedByOther: 'toegevoegd door {name}',
  renameProjectDescription: 'Hernoem het, wijzig de briefing of de einddatum',
  deleteProject: 'Project verwijderen',
  openToShare: 'Openen om te delen',
  sharingSaved: 'Delen opgeslagen. {name} wordt niet meer met je gedeeld.',
  onlyOwnerPrivate: 'Alleen {name} kan het privé maken',
  add: 'Toevoegen',
  addTo: 'Toevoegen aan {name}',
  addAnything:
    'Alles wat je kunt openen. Het behoudt zijn eigen toegang: als je het hier toevoegt, wordt het met niemand gedeeld.',
  couldntAdd: 'Kan {name} niet toevoegen.',
  projectReadyChat:
    '{name} is klaar en deze chat staat erin. Wie de chat kan openen, is niet gewijzigd.',
  projectReadyPrivate: '{name} is klaar. Alleen jij kunt het openen.',
  projectCreatedNotice: '{name} is aangemaakt. Alles erin behoudt de eigen toegangsrechten.',
  latestAnswerYou: 'Je krijgt een antwoord',
  latestAnswerOther: '{name} krijgt een antwoord',
  inProjectMove: 'In {name}. Deze chat verplaatsen',
  notInProjectMove: 'Niet in een project. Deze chat verplaatsen',
  movedTo: 'Verplaatst naar',
  accessUnchanged: 'Wie deze chat kan openen, is niet gewijzigd.',
  theProject: 'het project',
  in: 'In',
  stopMakingProject: 'Stoppen met een nieuw project in deze chat',
  searchYourWork: 'Je werk doorzoeken',
  searchDocuments: 'Documenten, bestanden en vergaderingen zoeken…',
  yourWork: 'Je werk',
  looking: 'Zoeken…',
  nothingMatchesChat:
    'Geen resultaten. Als je een chat wilt toevoegen, open je die en gebruik je de optie in de koptekst.',
  typeToFind: 'Typ om werk te vinden dat je kunt openen.',
  newProjectDraft: 'Nieuw project · Concept {count} · Nog niet aangemaakt',
  projectCreatedOpen: 'Project aangemaakt · Openen',
  aNewProject: 'Een nieuw project',
  draftIntro:
    'Zeg in de chat wat het werk inhoudt. Poneva maakt hier een concept van het project, met wat moet worden toegevoegd en met wie je het wilt delen. Er wordt niets aangemaakt totdat je dat bevestigt.',
  draft: 'Concept',
  projectCreatedAccess: 'Aangemaakt. Alles erin behoudt zijn eigen toegang.',
  changeInChatDraft: 'Wijzig iets door het in de chat te zeggen.',
  chatOwnerCreate: 'Alleen de eigenaar van deze chat kan dit aanmaken.',
  open: 'Openen',
  creating: 'Aanmaken…',
  cannotOpenDraft:
    '{people} kan {title} niet openen, dus hun chats hier zouden zonder dit antwoord geven. Zeg in de chat of je de eigenaar wilt vragen om toegang te delen, of laat het weg.',
  bringsIn: 'Voegt {count} toe',
  thisChat: 'Deze chat',
  takenOutDraft: 'In concept {count} verwijderd',
  nothingYet: 'Nog niets. Benoem in de chat wat hier thuishoort.',
  leftOut: 'Weggelaten: {items}.',
  whoCanUse: 'Wie het kan gebruiken',
  youLead: 'Jij, lead',
  beingInProject:
    'Als iets in het project staat, wordt er niets geopend. Elk item behoudt zijn eigen toegang.',
  onlyYouUntilShare: 'Het blijft Alleen jij totdat je het deelt.',
  colour: 'Kleur',
  sand: 'Zand',
  green: 'Groen',
  blue: 'Blauw',
  grey: 'Grijs',
  firstProject: 'Start je eerste project',
  firstProjectDescription:
    'Geef het een naam; elke chat die je erin start, leest dezelfde briefing. Voeg werk toe dat je al hebt en deel het wanneer anderen eraan moeten werken.',
  loadingProjects: 'Projecten laden…',
  thisChatMoves:
    'Deze chat wordt naar het project verplaatst. Wie de chat kan openen, verandert niet.',
  whatIsWork: 'Wat houdt het werk in?',
  optional: 'Optioneel',
  writeFromChat: 'Schrijven vanuit deze chat',
  briefPlaceholder: 'Waar het voor dient, welke regels gelden en welke data belangrijk zijn.',
  briefDraftHelp:
    'Elke chat in het project leest dit als eerste. Met Schrijven vanuit deze chat vraag je Poneva om het naast de chat op te stellen; je kiest nog steeds voor Aanmaken.',
  briefLaterHelp:
    'Elke chat in het project leest dit als eerste. Wijzig het later door het in een chat daar te vragen.',
  sendClearFirst:
    'Verstuur of wis eerst je niet-verstuurde bericht en bijlagen om de briefing vanuit deze chat te schrijven.',
  createProjectError: 'Het project kan niet worden aangemaakt. Probeer het opnieuw.',
  onlyYouUntil: 'Alleen jij, totdat je het deelt',
  whereChat: 'Waar deze chat staat',
  whereChatHelp:
    'Een chat staat altijd in één project tegelijk. Verplaatsen verandert nooit wie de chat kan openen.',
  searchCreateProject: 'Een project zoeken of aanmaken',
  noProject: 'Geen project',
  inCompanyChats: 'In je chats bij {company}',
  newProjectWithChat: 'Nieuw project met deze chat',
  newProjectNamedWithChat: 'Nieuw project “{name}” met deze chat',
  makingProject: 'Nieuw project maken',
  moveToProject: 'Deze chat naar {name} verplaatsen',
  chatInProject: 'Deze chat staat in {name}.',
  looksLikeWork: 'Dit lijkt op werk voor {name}. Daarheen verplaatsen?',
  accessBriefNext:
    'Wie de chat kan openen, is niet veranderd. Vanaf je volgende bericht leest de chat de briefing van het project.',
  moveFailed:
    'De chat kan niet worden verplaatst. Probeer het opnieuw of gebruik de optie in de koptekst.',
  accessBriefNextTypographic:
    'Wie de chat kan openen, verandert niet. Vanaf je volgende bericht leest de chat de briefing van het project.',
  openProject: 'Project openen',
  move: 'Verplaatsen',
  movedOut: 'Uit het project verplaatst. Wie de chat kan openen, is niet veranderd.',
  chatLivesHere: 'Deze chat staat nu hier. Wie de chat kan openen, is niet veranderd.',
  addedTo: '{item} toegevoegd aan {project}',
  addedAccess:
    'Het behoudt zijn eigen toegang. Als je het hier toevoegt, wordt het met niemand gedeeld.',
  removedOut:
    '{item} is uit {project} verwijderd. Het blijft staan waar het staat en wie het kan openen, is niet veranderd.',
  itIs: 'Het is',
  couldntMoveChat: 'Deze chat kan niet worden verplaatst.',
  sharingCheckFailed:
    'Kan niet controleren wie de items die als eerste worden gelezen, kan openen. Controleer hun toegang voordat je dit project deelt.',
  cannotOpenShare: '{people} kan {title} niet openen.',
  readsFirstShare:
    'Elke chat in dit project leest dit als eerste, dus hun chats hier geven antwoord zonder dit. Het delen van het project verandert dat niet.',
  sharingSavedUnread: 'Delen opgeslagen. {name} kon zojuist niet opnieuw worden gelezen.',
  formerColleague: 'Een oud-collega',
  madeInChatHere: 'gemaakt in een chat hier',
  latestStarted: '{name} startte {title}',
  latestStartedYou: 'Je startte {title}',
  latestContinued: '{name} zette {title} voort',
  latestContinuedYou: 'Je zette {title} voort',
  latestMade: '{name} maakte {title}',
  latestMadeYou: 'Je maakte {title}',
  latestAdded: '{name} voegde {title} toe',
  latestAddedYou: 'Je voegde {title} toe',
  projectChipLives:
    'Deze chat hoort bij {name} en leest de briefing. Verplaats hem via het eerste deel van de kop.',
  addExistingWork: 'Voeg werk toe dat je al hebt',
  nameLabel: 'Naam',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} item',
  itemsMany: '{count} items',
  itemsAllStillHere: '{items}, allemaal nog hier',
  projectsOverviewDescription:
    'Eén plek voor elk stuk werk. Iets in een project zetten verandert nooit wie het kan openen.',
  noProjectMatchesHint: 'Geen project komt overeen. Probeer een woord uit de naam of briefing.',
  aboutProject: 'Over dit project',
  aboutShort: 'Over',
  workingIn: 'Werken in {name}',
  noBriefHome:
    'Nog geen briefing. Zeg in een chat hier waar het werk over gaat; elke chat in het project leest het eerst.',
  tabAll: 'Alles',
  tabChats: 'Chats',
  tabResults: 'Resultaten',
  tabFiles: 'Bestanden',
  emptyChats: 'Nog geen chats hier. Start er hierboven een.',
  emptyResults: 'Hier is nog niets gemaakt. Wat je in een chat hier maakt, komt hier terecht.',
  emptyFiles:
    'Nog geen bestanden hier. Bestanden die je in een chat hier toevoegt, komen hier terecht.',
  showTabs: 'Toon',
  newestShown: 'De nieuwste {shown} van {count} worden hier getoond.',
  nothingHereYet: 'Hier is nog niets.',
  homeEmptyHelp:
    'Chats die je hierboven start komen hier terecht, net als de bestanden die je toevoegt en de resultaten die je erin maakt.',
  shareWithPeopleDoingIt: 'Delen met de mensen die eraan werken',
  briefWrittenBy: '{version} · geschreven door {name}, {when}',
  briefChangedBy: '{version} · gewijzigd door {name}, {when}',
  personWorksInIt: '{people} werkt eraan.',
  peopleWorkInIt: '{people} werken eraan.',
  aboutUnavailable:
    'Dit project is niet beschikbaar. Het is mogelijk verwijderd of niet met jou gedeeld.',
  landedIn: 'In {name} · {access}',
  landedOnlyYou: 'Alleen jij kunt het openen',
  youWorkInIt: 'Jij werkt eraan.',
  youAndPeopleWorkInIt: 'Jij en {people} werken eraan.',
  landedCompanyCanOpen: 'Iedereen bij {company} kan het openen',
  landedMembersCanOpen: "Geselecteerde collega's kunnen het openen",
  briefWrittenByYou: '{version} · geschreven door jou, {when}',
  briefChangedByYou: '{version} · gewijzigd door jou, {when}',
  briefWrittenByFormer: '{version} · geschreven door een oud-collega, {when}',
  briefChangedByFormer: '{version} · gewijzigd door een oud-collega, {when}',
  addedByFormer: 'toegevoegd door een oud-collega',
  formerColleagueLeadsIt: 'Een oud-collega leidt het.',
  projectLoadFailed: 'Dit project kon niet worden geladen.',
  personCannotOpenWithout:
    '{people} kan dit niet openen, dus de gesprekken van deze persoon hier beantwoorden zonder dit.',
  peopleCannotOpenWithout:
    '{people} kunnen dit niet openen, dus hun gesprekken hier beantwoorden zonder dit.',
};
const pl: Copy = {
  projects: 'Projekty',
  newProject: 'Nowy projekt',
  searchProjects: 'Szukaj projektów',
  finished: 'Ukończone',
  people: 'Osoby',
  skill: 'Umiejętność',
  noBrief: 'Brak opisu.',
  createProject: 'Utwórz projekt',
  knowledgePages: 'Strony wiedzy',
  searchPages: 'Szukaj stron',
  formatting: 'Formatowanie',
  pageTitle: 'Tytuł strony',
  suggestions: 'Sugestie',
  current: 'Bieżąca',
  agent: 'Agent',
  runs: 'Uruchomienia',
  goal: 'Cel',
  instructions: 'Instrukcje',
  noRuns: 'Brak uruchomień.',
  runNow: 'Uruchom teraz',
  schedule: 'Harmonogram',
  editors: 'Edytorzy',
  now: 'Teraz',
  moreFor: 'Więcej o {name}',
  brief: 'Brief',
  version: 'Wersja {count}',
  noBriefLong:
    'Nie ma jeszcze briefu. Napisz na czacie, na czym polega ta praca i jakie są jej zasady.',
  changeInChat: 'Zmień na czacie',
  everyChatFollows: 'Każdy czat tutaj korzysta z',
  andReadsFirst: 'I najpierw odczytuje',
  file: 'Plik',
  knowledge: 'Wiedza',
  youLeadIt: 'Ty nim kierujesz.',
  personLeadsIt: '{name} nim kieruje.',
  everyoneAtCanFind: 'Wszyscy w {company} mogą to znaleźć.',
  shareWhenOthers: 'Udostępnij, gdy inni mają tu pracować.',
  projectAccessNote:
    'Samo dodanie do projektu nie otwiera żadnych elementów. Każdy element ma własne uprawnienia, a rozmowy tutaj działają jako osoba, która je rozpoczyna.',
  project: 'Projekt',
  needsYou: 'Wymaga Twojej uwagi',
  review: 'Sprawdź',
  inThisProject: 'W tym projekcie',
  deleteQuestion: 'Usunąć {name}?',
  deleteDescription:
    'Zniknie tylko projekt. Jego czaty, pliki i wyniki pozostaną u osób, do których należą, w dotychczasowych miejscach.',
  deleteConfirm: 'Usuń {name}',
  projectDeleted: 'Usunięto {name}. Jego czaty i praca pozostają tam, gdzie były.',
  couldntDelete: 'Nie udało się usunąć {name}.',
  itemOutSuccess: 'Usunięto {item} z {project}. Nic więcej się nie zmieniło.',
  itemOutError: 'Nie udało się usunąć {item} z {project}.',
  moveOutProject: 'Przenieś poza projekt',
  takeOutProject: 'Usuń z projektu',
  unavailableTitle: 'Ten projekt jest niedostępny',
  unavailableDescription:
    'Mógł zostać usunięty albo nie został Ci udostępniony. Nic w nim się dla Ciebie nie zmieniło.',
  allProjects: 'Wszystkie projekty',
  openingProject: 'Otwieranie projektu…',
  ended: 'Zakończono',
  ends: 'Kończy się',
  yesterday: 'Wczoraj',
  roleLead: 'Lider',
  roleCanEdit: 'Może edytować',
  roleCanUse: 'Może używać',
  visibilityCompany: 'Wszyscy w {company}',
  visibilityMembers: 'Wybrani współpracownicy',
  visibilityPrivate: 'Tylko Ty',
  kindApp: 'Aplikacja',
  kindDeck: 'Prezentacja',
  kindSheet: 'Arkusz',
  kindChart: 'Wykres',
  kindDashboard: 'Panel',
  kindReport: 'Raport',
  kindChat: 'Czat',
  kindFile: 'Plik',
  kindMeeting: 'Spotkanie',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Ty',
  gettingAnswer: 'Pobieranie odpowiedzi',
  gettingAnswerOther: '{name} pobiera odpowiedź',
  addedByYou: 'dodano przez Ciebie',
  addedByOther: 'dodano przez {name}',
  renameProjectDescription: 'Zmień nazwę, brief lub datę zakończenia',
  deleteProject: 'Usuń projekt',
  openToShare: 'Otwórz, aby udostępnić',
  sharingSaved: 'Ustawienia udostępniania zapisane. Element {name} nie jest już Ci udostępniany.',
  onlyOwnerPrivate: 'Tylko {name} może ustawić go jako prywatny',
  add: 'Dodaj',
  addTo: 'Dodaj do {name}',
  addAnything:
    'Wszystko, co możesz otworzyć. Zachowuje własne uprawnienia dostępu — dodanie tego tutaj nie udostępni tego nikomu.',
  couldntAdd: 'Nie udało się dodać {name}.',
  projectReadyChat:
    '{name} jest gotowy, a ten czat się w nim znajduje. Nie zmieniło się, kto może otworzyć ten czat.',
  projectReadyPrivate: '{name} jest gotowy. Tylko Ty możesz go otworzyć.',
  projectCreatedNotice:
    '{name} został utworzony. Wszystko, co się w nim znajduje, zachowuje własne ustawienia dostępu.',
  latestAnswerYou: 'Otrzymujesz odpowiedź',
  latestAnswerOther: '{name} otrzymuje odpowiedź',
  inProjectMove: 'W projekcie {name}. Przenieś ten czat',
  notInProjectMove: 'Poza projektem. Przenieś ten czat',
  movedTo: 'Przeniesiono do',
  accessUnchanged: 'Nie zmieniło się, kto może otworzyć ten czat.',
  theProject: 'projektu',
  in: 'W',
  stopMakingProject: 'Przestań tworzyć nowy projekt w tym czacie',
  searchYourWork: 'Przeszukaj swoją pracę',
  searchDocuments: 'Szukaj dokumentów, plików i spotkań…',
  yourWork: 'Twoja praca',
  looking: 'Wyszukiwanie…',
  nothingMatchesChat: 'Brak wyników. Aby dodać czat, otwórz go i użyj jego lokalizacji w nagłówku.',
  typeToFind: 'Wpisz, aby znaleźć pracę, którą możesz otworzyć.',
  newProjectDraft: 'Nowy projekt · Wersja robocza {count} · Jeszcze nieutworzony',
  projectCreatedOpen: 'Projekt utworzony · Otwórz go',
  aNewProject: 'Nowy projekt',
  draftIntro:
    'Napisz na czacie, na czym polega praca. Poneva przygotuje tutaj wersję roboczą projektu, określając, co dodać i komu go udostępnić. Nic nie zostanie utworzone, dopóki tego nie potwierdzisz.',
  draft: 'Wersja robocza',
  projectCreatedAccess: 'Utworzono. Wszystkie elementy zachowują własne uprawnienia dostępu.',
  changeInChatDraft: 'Wprowadź dowolne zmiany, pisząc o nich na czacie.',
  chatOwnerCreate: 'Tylko osoba, do której należy ten czat, może go utworzyć.',
  open: 'Otwórz',
  creating: 'Tworzenie…',
  cannotOpenDraft:
    '{people} nie mogą otworzyć elementu {title}, więc ich czaty tutaj będą odpowiadać bez niego. Napisz na czacie, czy poprosić jego właściciela o udostępnienie, czy go pominąć.',
  bringsIn: 'Dodaje {count}',
  thisChat: 'Ten czat',
  takenOutDraft: 'Usunięto w wersji roboczej {count}',
  nothingYet: 'Jeszcze nic. Napisz na czacie, co ma się tutaj znaleźć.',
  leftOut: 'Pominięto: {items}.',
  whoCanUse: 'Kto może z tego korzystać',
  youLead: 'Ty, osoba prowadząca',
  beingInProject:
    'Samo dodanie do projektu nie otwiera dostępu do żadnych elementów. Każdy element zachowuje własne uprawnienia dostępu.',
  onlyYouUntilShare: 'Do czasu udostępnienia widzisz to tylko Ty.',
  colour: 'Kolor',
  sand: 'Piaskowy',
  green: 'Zielony',
  blue: 'Niebieski',
  grey: 'Szary',
  firstProject: 'Utwórz swój pierwszy projekt',
  firstProjectDescription:
    'Nadaj mu nazwę, a każdy rozpoczęty w nim czat będzie korzystać z tego samego opisu. Dodaj pracę, którą już masz, i udostępnij ją, gdy inni mają w niej pracować.',
  loadingProjects: 'Ładowanie projektów…',
  thisChatMoves:
    'Ten czat zostanie przeniesiony do projektu. To, kto może go otworzyć, nie zmieni się.',
  whatIsWork: 'Na czym polega praca?',
  optional: 'Opcjonalne',
  writeFromChat: 'Napisz na podstawie tego czatu',
  briefPlaceholder: 'Do czego to służy, jakich zasad przestrzegać i jakie daty są ważne.',
  briefDraftHelp:
    'Każdy czat w projekcie odczytuje to najpierw. Opcja „Napisz na podstawie tego czatu” poprosi Ponevę o przygotowanie wersji roboczej obok czatu; nadal to Ty wybierasz opcję Utwórz.',
  briefLaterHelp:
    'Każdy czat w projekcie odczytuje to najpierw. Możesz zmienić to później, prosząc o to na dowolnym czacie w tym projekcie.',
  sendClearFirst:
    'Najpierw wyślij lub usuń niewysłaną wiadomość i załączniki, aby napisać opis na podstawie tego czatu.',
  createProjectError: 'Nie udało się utworzyć projektu. Spróbuj ponownie.',
  onlyYouUntil: 'Tylko Ty, dopóki go nie udostępnisz',
  whereChat: 'Gdzie znajduje się ten czat',
  whereChatHelp:
    'Czat może należeć jednocześnie tylko do jednego projektu. Przeniesienie go nie zmienia tego, kto może go otworzyć.',
  searchCreateProject: 'Wyszukaj lub utwórz projekt',
  noProject: 'Brak projektu',
  inCompanyChats: 'W Twoich czatach w {company}',
  newProjectWithChat: 'Nowy projekt z tym czatem',
  newProjectNamedWithChat: 'Nowy projekt „{name}” z tym czatem',
  makingProject: 'Tworzenie nowego projektu',
  moveToProject: 'Przenieś ten czat do {name}',
  chatInProject: 'Ten czat należy do projektu {name}.',
  looksLikeWork: 'Wygląda na to, że to praca związana z {name}. Przenieść ją tam?',
  accessBriefNext:
    'To, kto może go otworzyć, nie zmieniło się. Od następnej wiadomości czat będzie korzystać z opisu projektu.',
  moveFailed: 'Nie udało się go przenieść. Spróbuj ponownie lub użyj jego lokalizacji w nagłówku.',
  accessBriefNextTypographic:
    'To, kto może go otworzyć, nie zmienia się. Od następnej wiadomości czat będzie korzystać z opisu projektu.',
  openProject: 'Otwórz projekt',
  move: 'Przenieś',
  movedOut: 'Przeniesiono poza projekt. To, kto może go otworzyć, nie zmieniło się.',
  chatLivesHere: 'Ten czat znajduje się teraz tutaj. To, kto może go otworzyć, nie zmieniło się.',
  addedTo: 'Dodano {item} do {project}',
  addedAccess:
    'Zachowuje własne uprawnienia dostępu. Dodanie tego tutaj nie udostępni tego nikomu.',
  removedOut:
    'Element {item} został usunięty z projektu {project}. Pozostaje w swoim dotychczasowym miejscu, a to, kto może go otworzyć, nie zmieniło się.',
  itIs: 'To',
  couldntMoveChat: 'Nie udało się przenieść tego czatu.',
  sharingCheckFailed:
    'Nie udało się sprawdzić, kto może otworzyć elementy odczytywane jako pierwsze. Przed udostępnieniem tego projektu sprawdź ich uprawnienia dostępu.',
  cannotOpenShare: '{people} nie mogą otworzyć elementu {title}.',
  readsFirstShare:
    'Każdy czat w tym projekcie odczytuje go najpierw, więc czaty tych osób tutaj będą odpowiadać bez niego. Udostępnienie projektu tego nie zmienia.',
  sharingSavedUnread:
    'Ustawienia udostępniania zapisane. Nie udało się teraz ponownie odczytać elementu {name}.',
  formerColleague: 'Dawny współpracownik',
  madeInChatHere: 'utworzone na czacie tutaj',
  latestStarted: '{name} rozpoczął(-ęła) {title}',
  latestStartedYou: 'Rozpocząłeś(-ęłaś) {title}',
  latestContinued: '{name} kontynuował(a) {title}',
  latestContinuedYou: 'Kontynuowałeś(-ęłaś) {title}',
  latestMade: '{name} utworzył(a) {title}',
  latestMadeYou: 'Utworzyłeś(-ęłaś) {title}',
  latestAdded: '{name} dodał(a) {title}',
  latestAddedYou: 'Dodałeś(-ęłaś) {title}',
  projectChipLives:
    'Ten czat należy do projektu {name} i czyta jego brief. Przenieś go z pierwszej części nagłówka.',
  addExistingWork: 'Dodaj pracę, którą już masz',
  nameLabel: 'Nazwa',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} element',
  itemsMany: 'Elementy: {count}',
  itemsAllStillHere: '{items}, wszystko nadal na miejscu',
  projectsOverviewDescription:
    'Jedno miejsce na każdą pracę. Dodanie czegoś do projektu nigdy nie zmienia tego, kto może to otworzyć.',
  noProjectMatchesHint: 'Brak pasujących projektów. Spróbuj słowa z nazwy lub briefu.',
  aboutProject: 'O tym projekcie',
  aboutShort: 'O projekcie',
  workingIn: 'Pracujesz w projekcie {name}',
  noBriefHome:
    'Brak briefu. Napisz na czacie tutaj, na czym polega praca; każdy czat w projekcie czyta go jako pierwszy.',
  tabAll: 'Wszystko',
  tabChats: 'Czaty',
  tabResults: 'Wyniki',
  tabFiles: 'Pliki',
  emptyChats: 'Nie ma tu jeszcze czatów. Rozpocznij jeden powyżej.',
  emptyResults: 'Nic tu jeszcze nie powstało. To, co utworzysz na czacie tutaj, pojawi się tutaj.',
  emptyFiles: 'Nie ma tu jeszcze plików. Pliki dodane na czacie tutaj pojawią się tutaj.',
  showTabs: 'Pokaż',
  newestShown: 'Pokazano tutaj najnowsze: {shown} z {count}.',
  nothingHereYet: 'Nic tu jeszcze nie ma.',
  homeEmptyHelp:
    'Czaty rozpoczęte powyżej trafiają tutaj, tak samo jak dodane przez Ciebie pliki i wyniki, które w nich tworzysz.',
  shareWithPeopleDoingIt: 'Udostępnij osobom, które nad tym pracują',
  briefWrittenBy: '{version} · napisane przez {name}, {when}',
  briefChangedBy: '{version} · zmienione przez {name}, {when}',
  personWorksInIt: '{people} pracuje nad tym.',
  peopleWorkInIt: '{people} pracują nad tym.',
  aboutUnavailable:
    'Ten projekt jest niedostępny. Mógł zostać usunięty albo nie jest Ci udostępniony.',
  landedIn: 'W projekcie {name} · {access}',
  landedOnlyYou: 'Tylko Ty możesz to otworzyć',
  youWorkInIt: 'Ty pracujesz nad tym.',
  youAndPeopleWorkInIt: 'Ty i {people} pracujecie nad tym.',
  landedCompanyCanOpen: 'Wszyscy w {company} mogą to otworzyć',
  landedMembersCanOpen: 'Wybrani współpracownicy mogą to otworzyć',
  briefWrittenByYou: '{version} · napisane przez Ciebie, {when}',
  briefChangedByYou: '{version} · zmienione przez Ciebie, {when}',
  briefWrittenByFormer: '{version} · napisane przez dawnego współpracownika, {when}',
  briefChangedByFormer: '{version} · zmienione przez dawnego współpracownika, {when}',
  addedByFormer: 'dodano przez dawnego współpracownika',
  formerColleagueLeadsIt: 'Dawny współpracownik nim kieruje.',
  projectLoadFailed: 'Nie udało się wczytać tego projektu.',
  personCannotOpenWithout:
    '{people} nie może tego otworzyć, więc rozmowy tej osoby tutaj będą bez tego.',
  peopleCannotOpenWithout: '{people} nie mogą tego otworzyć, więc ich rozmowy tutaj będą bez tego.',
};
const pt: Copy = {
  projects: 'Projetos',
  newProject: 'Novo projeto',
  searchProjects: 'Pesquisar projetos',
  finished: 'Concluídos',
  people: 'Pessoas',
  skill: 'Habilidade',
  noBrief: 'Ainda não há resumo.',
  createProject: 'Criar projeto',
  knowledgePages: 'Páginas de conhecimento',
  searchPages: 'Pesquisar páginas',
  formatting: 'Formatação',
  pageTitle: 'Título da página',
  suggestions: 'Sugestões',
  current: 'Atual',
  agent: 'Agente',
  runs: 'Execuções',
  goal: 'Objetivo',
  instructions: 'Instruções',
  noRuns: 'Ainda não há execuções.',
  runNow: 'Executar agora',
  schedule: 'Agendamento',
  editors: 'Editores',
  now: 'Agora',
  moreFor: 'Mais para {name}',
  brief: 'Briefing',
  version: 'Versão {count}',
  noBriefLong:
    'Ainda não há briefing. Diga em uma conversa no que consiste este trabalho e quais são as regras.',
  changeInChat: 'Alterar na conversa',
  everyChatFollows: 'Todos os chats aqui seguem',
  andReadsFirst: 'E leem primeiro',
  file: 'Arquivo',
  knowledge: 'Conhecimento',
  youLeadIt: 'Você lidera isso.',
  personLeadsIt: '{name} lidera isso.',
  everyoneAtCanFind: 'Todos na {company} podem encontrar isso.',
  shareWhenOthers: 'Compartilhe quando outras pessoas precisarem trabalhar aqui.',
  projectAccessNote:
    'Estar no projeto não abre nada. Cada item mantém seu próprio acesso, e as conversas aqui são executadas como a pessoa que as inicia.',
  project: 'Projeto',
  needsYou: 'Precisa de você',
  review: 'Revisar',
  inThisProject: 'Neste projeto',
  deleteQuestion: 'Excluir {name}?',
  deleteDescription:
    'Somente o projeto será removido. As conversas, os arquivos e os resultados dele permanecem com as pessoas que os possuem, no local onde estavam.',
  deleteConfirm: 'Excluir {name}',
  projectDeleted: '{name} foi excluído. As conversas e o trabalho dele permanecem onde estavam.',
  couldntDelete: 'Não foi possível excluir {name}.',
  itemOutSuccess: '{item} foi removido de {project}. Nada mais foi alterado.',
  itemOutError: 'Não foi possível remover {item} de {project}.',
  moveOutProject: 'Mover para fora do projeto',
  takeOutProject: 'Remover do projeto',
  unavailableTitle: 'Este projeto não está disponível',
  unavailableDescription:
    'Ele pode ter sido excluído ou não foi compartilhado com você. Nada nele mudou para você.',
  allProjects: 'Todos os projetos',
  openingProject: 'Abrindo o projeto…',
  ended: 'Encerrado',
  ends: 'Termina',
  yesterday: 'Ontem',
  roleLead: 'Liderança',
  roleCanEdit: 'Pode editar',
  roleCanUse: 'Pode usar',
  visibilityCompany: 'Todos na {company}',
  visibilityMembers: 'Colegas selecionados',
  visibilityPrivate: 'Somente você',
  kindApp: 'Aplicativo',
  kindDeck: 'Apresentação',
  kindSheet: 'Planilha',
  kindChart: 'Gráfico',
  kindDashboard: 'Painel',
  kindReport: 'Relatório',
  kindChat: 'Conversa',
  kindFile: 'Arquivo',
  kindMeeting: 'Reunião',
  kindAgent: 'Agente',
  kindDocument: 'Documento',
  you: 'Você',
  gettingAnswer: 'Obtendo uma resposta',
  gettingAnswerOther: '{name} está obtendo uma resposta',
  addedByYou: 'adicionado por você',
  addedByOther: 'adicionado por {name}',
  renameProjectDescription: 'Renomeie, altere o briefing ou a data de término',
  deleteProject: 'Excluir projeto',
  openToShare: 'Abra para compartilhar',
  sharingSaved: 'Compartilhamento salvo. {name} não é mais compartilhado com você.',
  onlyOwnerPrivate: 'Somente {name} pode torná-lo privado',
  add: 'Adicionar',
  addTo: 'Adicionar a {name}',
  addAnything:
    'Qualquer coisa que você possa abrir. Ela mantém seu próprio acesso: adicioná-la aqui não a compartilha com ninguém.',
  couldntAdd: 'Não foi possível adicionar {name}.',
  projectReadyChat: '{name} está pronto, e este chat está nele. Quem pode abrir o chat não mudou.',
  projectReadyPrivate: '{name} está pronto. Somente você pode abri-lo.',
  projectCreatedNotice: '{name} foi criado. Tudo nele mantém seu próprio acesso.',
  latestAnswerYou: 'Você está recebendo uma resposta',
  latestAnswerOther: '{name} está recebendo uma resposta',
  inProjectMove: 'Em {name}. Mover este chat',
  notInProjectMove: 'Não está em um projeto. Mover este chat',
  movedTo: 'Movido para',
  accessUnchanged: 'Quem pode abrir este chat não mudou.',
  theProject: 'o projeto',
  in: 'Em',
  stopMakingProject: 'Pare de criar um novo projeto neste chat',
  searchYourWork: 'Pesquisar seu trabalho',
  searchDocuments: 'Pesquisar documentos, arquivos e reuniões…',
  yourWork: 'Seu trabalho',
  looking: 'Procurando…',
  nothingMatchesChat:
    'Nada corresponde. Para adicionar um chat, abra-o e use o local dele no cabeçalho.',
  typeToFind: 'Digite para encontrar um trabalho que você possa abrir.',
  newProjectDraft: 'Novo projeto · Rascunho {count} · Ainda não criado',
  projectCreatedOpen: 'Projeto criado · Abrir',
  aNewProject: 'Um novo projeto',
  draftIntro:
    'Diga no chat qual é o trabalho. O Poneva prepara o projeto aqui, com o que adicionar e com quem compartilhá-lo. Nada é criado até você autorizar.',
  draft: 'Rascunho',
  projectCreatedAccess: 'Criado. Tudo nele mantém seu próprio acesso.',
  changeInChatDraft: 'Mude qualquer coisa dizendo isso no chat.',
  chatOwnerCreate: 'Somente a pessoa proprietária deste chat pode criá-lo.',
  open: 'Abrir',
  creating: 'Criando…',
  cannotOpenDraft:
    '{people} não pode abrir {title}, então os chats dessas pessoas aqui responderiam sem ele. Diga no chat se deve pedir ao proprietário que o compartilhe ou deixá-lo de fora.',
  bringsIn: 'Adiciona {count}',
  thisChat: 'Este chat',
  takenOutDraft: 'Retirado do rascunho {count}',
  nothingYet: 'Ainda nada. Diga no chat o que deve ficar aqui.',
  leftOut: 'Deixado de fora: {items}.',
  whoCanUse: 'Quem pode usar',
  youLead: 'Você, líder',
  beingInProject: 'Estar no projeto não dá acesso a nada. Cada item mantém seu próprio acesso.',
  onlyYouUntilShare: 'Ele fica visível apenas para você até que seja compartilhado.',
  colour: 'Cor',
  sand: 'Areia',
  green: 'Verde',
  blue: 'Azul',
  grey: 'Cinza',
  firstProject: 'Comece seu primeiro projeto',
  firstProjectDescription:
    'Dê um nome a ele, e todos os chats iniciados nele lerão o mesmo briefing. Adicione trabalhos que você já tem e compartilhe-os quando outras pessoas precisarem trabalhar nele.',
  loadingProjects: 'Carregando projetos…',
  thisChatMoves: 'Este chat será movido para o projeto. Quem pode abri-lo não muda.',
  whatIsWork: 'Qual é o trabalho?',
  optional: 'Opcional',
  writeFromChat: 'Escrever a partir deste chat',
  briefPlaceholder: 'Para que serve, quais regras seguir e quais datas são importantes.',
  briefDraftHelp:
    'Todos os chats do projeto leem isto primeiro. Escrever a partir deste chat pede ao Poneva para preparar o briefing ao lado do chat; você ainda escolhe Criar.',
  briefLaterHelp:
    'Todos os chats do projeto leem isto primeiro. Mude-o depois pedindo em qualquer chat do projeto.',
  sendClearFirst:
    'Envie ou limpe primeiro sua mensagem não enviada e os anexos para escrever o briefing a partir deste chat.',
  createProjectError: 'Não foi possível criar o projeto. Tente novamente.',
  onlyYouUntil: 'Apenas você, até compartilhá-lo',
  whereChat: 'Onde este chat fica',
  whereChatHelp: 'Um chat fica em um projeto por vez. Movê-lo nunca muda quem pode abri-lo.',
  searchCreateProject: 'Pesquisar ou criar um projeto',
  noProject: 'Nenhum projeto',
  inCompanyChats: 'Nos seus chats em {company}',
  newProjectWithChat: 'Novo projeto com este chat',
  newProjectNamedWithChat: 'Novo projeto “{name}” com este chat',
  makingProject: 'Criando um novo projeto',
  moveToProject: 'Mover este chat para {name}',
  chatInProject: 'Este chat está em {name}.',
  looksLikeWork: 'Isto parece trabalho de {name}. Mover para lá?',
  accessBriefNext:
    'Quem pode abri-lo não mudou. Este chat lerá o briefing do projeto a partir da sua próxima mensagem.',
  moveFailed: 'Não foi possível movê-lo. Tente novamente ou use o local dele no cabeçalho.',
  accessBriefNextTypographic:
    'Quem pode abri-lo não muda. Este chat lerá o briefing do projeto a partir da sua próxima mensagem.',
  openProject: 'Abrir projeto',
  move: 'Mover',
  movedOut: 'Movido para fora do projeto. Quem pode abri-lo não mudou.',
  chatLivesHere: 'Este chat fica aqui agora. Quem pode abri-lo não mudou.',
  addedTo: '{item} adicionado a {project}',
  addedAccess: 'Ele mantém seu próprio acesso. Adicioná-lo aqui não o compartilha com ninguém.',
  removedOut:
    '{item} foi removido de {project}. Ele permanece onde está, e quem pode abri-lo não mudou.',
  itIs: 'É',
  couldntMoveChat: 'Não foi possível mover este chat.',
  sharingCheckFailed:
    'Não foi possível verificar quem pode abrir os itens lidos primeiro. Revise o acesso deles antes de compartilhar este projeto.',
  cannotOpenShare: '{people} não pode abrir {title}.',
  readsFirstShare:
    'Todos os chats deste projeto leem isto primeiro, então os chats dessas pessoas aqui responderiam sem ele. Compartilhar o projeto não muda isso.',
  sharingSavedUnread: 'Compartilhamento salvo. Não foi possível ler {name} novamente agora.',
  formerColleague: 'Um ex-colega',
  madeInChatHere: 'feito em uma conversa aqui',
  latestStarted: '{name} iniciou {title}',
  latestStartedYou: 'Você iniciou {title}',
  latestContinued: '{name} continuou {title}',
  latestContinuedYou: 'Você continuou {title}',
  latestMade: '{name} fez {title}',
  latestMadeYou: 'Você fez {title}',
  latestAdded: '{name} adicionou {title}',
  latestAddedYou: 'Você adicionou {title}',
  projectChipLives:
    'Esta conversa está em {name} e lê o briefing dele. Mova-a a partir da primeira parte do cabeçalho.',
  addExistingWork: 'Adicionar o trabalho que você já tem',
  nameLabel: 'Nome',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} item',
  itemsMany: '{count} itens',
  itemsAllStillHere: '{items}, todos ainda aqui',
  projectsOverviewDescription:
    'Um lugar para cada trabalho. Colocar algo em um projeto nunca muda quem pode abri-lo.',
  noProjectMatchesHint: 'Nenhum projeto corresponde. Tente uma palavra do nome ou do briefing.',
  aboutProject: 'Sobre este projeto',
  aboutShort: 'Sobre',
  workingIn: 'Trabalhando em {name}',
  noBriefHome:
    'Ainda não há briefing. Diga em uma conversa aqui qual é o trabalho; todas as conversas do projeto o leem primeiro.',
  tabAll: 'Tudo',
  tabChats: 'Conversas',
  tabResults: 'Resultados',
  tabFiles: 'Arquivos',
  emptyChats: 'Ainda não há conversas aqui. Inicie uma acima.',
  emptyResults:
    'Ainda não foi feito nada aqui. O que você fizer em uma conversa aqui aparece aqui.',
  emptyFiles:
    'Ainda não há arquivos aqui. Os arquivos que você adicionar em uma conversa aqui aparecem aqui.',
  showTabs: 'Mostrar',
  newestShown: 'Os {shown} mais recentes de {count} são mostrados aqui.',
  nothingHereYet: 'Ainda não há nada aqui.',
  homeEmptyHelp:
    'As conversas que você iniciar acima aparecem aqui, assim como os arquivos que você adicionar e os resultados que fizer nelas.',
  shareWithPeopleDoingIt: 'Compartilhar com quem está fazendo',
  briefWrittenBy: '{version} · escrito por {name}, {when}',
  briefChangedBy: '{version} · alterado por {name}, {when}',
  personWorksInIt: '{people} trabalha nele.',
  peopleWorkInIt: '{people} trabalham nele.',
  aboutUnavailable:
    'Este projeto não está disponível. Ele pode ter sido excluído ou não estar compartilhado com você.',
  landedIn: 'Em {name} · {access}',
  landedOnlyYou: 'Somente você pode abri-lo',
  youWorkInIt: 'Você trabalha nele.',
  youAndPeopleWorkInIt: 'Você e {people} trabalham nele.',
  landedCompanyCanOpen: 'Todos na {company} podem abri-lo',
  landedMembersCanOpen: 'Colegas selecionados podem abri-lo',
  briefWrittenByYou: '{version} · escrito por você, {when}',
  briefChangedByYou: '{version} · alterado por você, {when}',
  briefWrittenByFormer: '{version} · escrito por um ex-colega, {when}',
  briefChangedByFormer: '{version} · alterado por um ex-colega, {when}',
  addedByFormer: 'adicionado por um ex-colega',
  formerColleagueLeadsIt: 'Um ex-colega lidera isso.',
  projectLoadFailed: 'Não foi possível carregar este projeto.',
  personCannotOpenWithout:
    '{people} não pode abrir isto, então as conversas dessa pessoa aqui respondem sem isso.',
  peopleCannotOpenWithout:
    '{people} não podem abrir isto, então as conversas dessas pessoas aqui respondem sem isso.',
};
const ro: Copy = {
  projects: 'Proiecte',
  newProject: 'Proiect nou',
  searchProjects: 'Caută proiecte',
  finished: 'Finalizate',
  people: 'Persoane',
  skill: 'Competență',
  noBrief: 'Nu există încă un rezumat.',
  createProject: 'Creează proiectul',
  knowledgePages: 'Pagini de cunoștințe',
  searchPages: 'Caută pagini',
  formatting: 'Formatare',
  pageTitle: 'Titlul paginii',
  suggestions: 'Sugestii',
  current: 'Curent',
  agent: 'Agent',
  runs: 'Execuții',
  goal: 'Obiectiv',
  instructions: 'Instrucțiuni',
  noRuns: 'Nu există încă execuții.',
  runNow: 'Rulează acum',
  schedule: 'Program',
  editors: 'Editori',
  now: 'Acum',
  moreFor: 'Mai multe pentru {name}',
  brief: 'Rezumat',
  version: 'Versiunea {count}',
  noBriefLong:
    'Nu există încă niciun rezumat. Spune într-un chat despre ce este această activitate și care sunt regulile ei.',
  changeInChat: 'Schimbă în chat',
  everyChatFollows: 'Fiecare conversație de aici urmează',
  andReadsFirst: 'Și citește mai întâi',
  file: 'Fișier',
  knowledge: 'Cunoștințe',
  youLeadIt: 'Tu îl coordonezi.',
  personLeadsIt: '{name} îl coordonează.',
  everyoneAtCanFind: 'Toată lumea de la {company} îl poate găsi.',
  shareWhenOthers: 'Distribuie-l când și alții ar trebui să lucreze aici.',
  projectAccessNote:
    'Faptul că faci parte din proiect nu deschide nimic. Fiecare element își păstrează propriul acces, iar chat-urile de aici rulează cu drepturile persoanei care le inițiază.',
  project: 'Proiect',
  needsYou: 'Necesită atenția ta',
  review: 'Verifică',
  inThisProject: 'În acest proiect',
  deleteQuestion: 'Ștergi {name}?',
  deleteDescription:
    'Doar proiectul va fi eliminat. Chat-urile, fișierele și rezultatele sale rămân la persoanele cărora le aparțin, în locurile în care se aflau.',
  deleteConfirm: 'Șterge {name}',
  projectDeleted: '{name} a fost șters. Chat-urile și activitățile sale rămân acolo unde erau.',
  couldntDelete: '{name} nu a putut fi șters.',
  itemOutSuccess: '{item} a fost eliminat din {project}. Nu s-a schimbat nimic altceva.',
  itemOutError: '{item} nu a putut fi eliminat din {project}.',
  moveOutProject: 'Mută în afara proiectului',
  takeOutProject: 'Elimină din proiect',
  unavailableTitle: 'Acest proiect nu este disponibil',
  unavailableDescription:
    'Este posibil să fi fost șters sau să nu fi fost distribuit către tine. Nimic din el nu s-a schimbat pentru tine.',
  allProjects: 'Toate proiectele',
  openingProject: 'Se deschide proiectul…',
  ended: 'Încheiat',
  ends: 'Se încheie',
  yesterday: 'Ieri',
  roleLead: 'Coordonator',
  roleCanEdit: 'Poate edita',
  roleCanUse: 'Poate folosi',
  visibilityCompany: 'Toată lumea de la {company}',
  visibilityMembers: 'Colegi selectați',
  visibilityPrivate: 'Doar tu',
  kindApp: 'Aplicație',
  kindDeck: 'Prezentare',
  kindSheet: 'Foaie de calcul',
  kindChart: 'Diagramă',
  kindDashboard: 'Tablou de bord',
  kindReport: 'Raport',
  kindChat: 'Chat',
  kindFile: 'Fișier',
  kindMeeting: 'Întâlnire',
  kindAgent: 'Agent',
  kindDocument: 'Document',
  you: 'Tu',
  gettingAnswer: 'Se pregătește un răspuns',
  gettingAnswerOther: '{name} pregătește un răspuns',
  addedByYou: 'adăugat de tine',
  addedByOther: 'adăugat de {name}',
  renameProjectDescription: 'Redenumește-l, modifică rezumatul sau data de încheiere',
  deleteProject: 'Șterge proiectul',
  openToShare: 'Deschide-l pentru a-l partaja',
  sharingSaved: 'Partajarea a fost salvată. {name} nu mai este partajat cu tine.',
  onlyOwnerPrivate: 'Doar {name} îl poate face privat',
  add: 'Adaugă',
  addTo: 'Adaugă la {name}',
  addAnything:
    'Orice poți deschide. Își păstrează propriul acces: adăugarea aici nu îl partajează cu nimeni.',
  couldntAdd: 'Nu s-a putut adăuga {name}.',
  projectReadyChat:
    '{name} este gata, iar acest chat se află în el. Accesul la deschiderea chatului nu s-a schimbat.',
  projectReadyPrivate: '{name} este gata. Doar tu îl poți deschide.',
  projectCreatedNotice: '{name} a fost creat. Tot ce conține își păstrează propriul acces.',
  latestAnswerYou: 'Primești un răspuns',
  latestAnswerOther: '{name} primește un răspuns',
  inProjectMove: 'În {name}. Mută acest chat',
  notInProjectMove: 'Nu se află într-un proiect. Mută acest chat',
  movedTo: 'Mutat în',
  accessUnchanged: 'Cine poate deschide acest chat nu s-a schimbat.',
  theProject: 'proiectul',
  in: 'În',
  stopMakingProject: 'Oprește crearea unui proiect nou în acest chat',
  searchYourWork: 'Caută în activitatea ta',
  searchDocuments: 'Caută documente, fișiere și întâlniri…',
  yourWork: 'Activitatea ta',
  looking: 'Se caută…',
  nothingMatchesChat:
    'Nimic nu corespunde. Pentru a aduce o conversație, deschide-o și folosește locația ei din antet.',
  typeToFind: 'Tastează pentru a găsi activitatea pe care o poți deschide.',
  newProjectDraft: 'Proiect nou · Schiță {count} · Încă nu a fost creat',
  projectCreatedOpen: 'Proiect creat · Deschide-l',
  aNewProject: 'Un proiect nou',
  draftIntro:
    'Spune în conversație care este activitatea. Poneva schițează aici proiectul, cu ce trebuie adus și cu cine trebuie partajat. Nimic nu este creat până nu confirmi.',
  draft: 'Schiță',
  projectCreatedAccess: 'Creat. Tot ce conține își păstrează propriul acces.',
  changeInChatDraft: 'Schimbă orice spunând acest lucru în conversație.',
  chatOwnerCreate: 'Doar persoana care deține această conversație o poate crea.',
  open: 'Deschide',
  creating: 'Se creează…',
  cannotOpenDraft:
    '{people} nu pot deschide {title}, așa că răspunsurile conversațiilor lor de aici nu îl vor include. Spune în conversație dacă să îi ceri proprietarului să îl partajeze sau să îl lași deoparte.',
  bringsIn: 'Aduce {count}',
  thisChat: 'Această conversație',
  takenOutDraft: 'Eliminat din schița {count}',
  nothingYet: 'Încă nimic. Spune în conversație ce trebuie să fie aici.',
  leftOut: 'Lăsat deoparte: {items}.',
  whoCanUse: 'Cine îl poate folosi',
  youLead: 'Tu, coordonator',
  beingInProject:
    'Faptul că se află în proiect nu deschide nimic. Fiecare element își păstrează propriul acces.',
  onlyYouUntilShare: 'Rămâne vizibil doar pentru tine până când îl partajezi.',
  colour: 'Culoare',
  sand: 'Nisip',
  green: 'Verde',
  blue: 'Albastru',
  grey: 'Gri',
  firstProject: 'Începe primul tău proiect',
  firstProjectDescription:
    'Dă-i un nume, iar fiecare conversație pe care o începi în el va citi același rezumat. Adu activitatea pe care o ai deja și partajează proiectul când și alții trebuie să lucreze acolo.',
  loadingProjects: 'Se încarcă proiectele…',
  thisChatMoves:
    'Această conversație va fi mutată în proiect. Cine o poate deschide nu se schimbă.',
  whatIsWork: 'Care este activitatea?',
  optional: 'Opțional',
  writeFromChat: 'Scrie din această conversație',
  briefPlaceholder: 'Scopul, regulile de urmat și datele importante.',
  briefDraftHelp:
    'Fiecare conversație din proiect citește mai întâi acest rezumat. Scrie din această conversație îi cere lui Poneva să îl schițeze lângă conversație; tu alegi în continuare Creează.',
  briefLaterHelp:
    'Fiecare conversație din proiect citește mai întâi acest rezumat. Îl poți modifica mai târziu cerând acest lucru în orice conversație de acolo.',
  sendClearFirst:
    'Trimite sau șterge mai întâi mesajul și atașamentele netrimise pentru a scrie rezumatul din această conversație.',
  createProjectError: 'Proiectul nu a putut fi creat. Încearcă din nou.',
  onlyYouUntil: 'Doar pentru tine, până când îl partajezi',
  whereChat: 'Unde se află această conversație',
  whereChatHelp:
    'O conversație se află într-un singur proiect la un moment dat. Mutarea ei nu schimbă niciodată cine o poate deschide.',
  searchCreateProject: 'Caută sau creează un proiect',
  noProject: 'Niciun proiect',
  inCompanyChats: 'În conversațiile tale de la {company}',
  newProjectWithChat: 'Proiect nou cu această conversație',
  newProjectNamedWithChat: 'Proiect nou „{name}” cu această conversație',
  makingProject: 'Se creează un proiect nou',
  moveToProject: 'Mută această conversație în {name}',
  chatInProject: 'Această conversație se află în {name}.',
  looksLikeWork: 'Aceasta pare a fi activitatea {name}. O muți acolo?',
  accessBriefNext:
    'Cine o poate deschide nu s-a schimbat. Va citi rezumatul proiectului începând cu următorul tău mesaj.',
  moveFailed: 'Nu s-a putut efectua mutarea. Încearcă din nou sau folosește locația ei din antet.',
  accessBriefNextTypographic:
    'Cine o poate deschide nu se schimbă. Va citi rezumatul proiectului începând cu următorul tău mesaj.',
  openProject: 'Deschide proiectul',
  move: 'Mută',
  movedOut: 'Mutată în afara proiectului. Cine o poate deschide nu s-a schimbat.',
  chatLivesHere: 'Această conversație se află acum aici. Cine o poate deschide nu s-a schimbat.',
  addedTo: '{item} a fost adăugat la {project}',
  addedAccess: 'Își păstrează propriul acces. Adăugarea aici nu îl partajează cu nimeni.',
  removedOut:
    '{item} a fost scos din {project}. Rămâne în locația sa, iar cine îl poate deschide nu s-a schimbat.',
  itIs: 'Este',
  couldntMoveChat: 'Această conversație nu a putut fi mutată.',
  sharingCheckFailed:
    'Nu s-a putut verifica cine poate deschide elementele citite mai întâi. Verifică accesul la acestea înainte de a partaja proiectul.',
  cannotOpenShare: '{people} nu pot deschide {title}.',
  readsFirstShare:
    'Fiecare conversație din acest proiect îl citește mai întâi, așa că răspunsurile conversațiilor lor de aici nu îl vor include. Partajarea proiectului nu schimbă acest lucru.',
  sharingSavedUnread: 'Partajarea a fost salvată. {name} nu a putut fi citit din nou chiar acum.',
  formerColleague: 'Un fost coleg',
  madeInChatHere: 'creat într-un chat de aici',
  latestStarted: '{name} a început {title}',
  latestStartedYou: 'Ai început {title}',
  latestContinued: '{name} a continuat {title}',
  latestContinuedYou: 'Ai continuat {title}',
  latestMade: '{name} a creat {title}',
  latestMadeYou: 'Ai creat {title}',
  latestAdded: '{name} a adăugat {title}',
  latestAddedYou: 'Ai adăugat {title}',
  projectChipLives:
    'Acest chat se află în {name} și citește rezumatul lui. Mută-l din prima parte a antetului.',
  addExistingWork: 'Adaugă munca pe care o ai deja',
  nameLabel: 'Nume',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} element',
  itemsMany: '{count} elemente',
  itemsAllStillHere: '{items}, toate încă aici',
  projectsOverviewDescription:
    'Un loc pentru fiecare lucrare. Punerea unui lucru într-un proiect nu schimbă niciodată cine îl poate deschide.',
  noProjectMatchesHint:
    'Niciun proiect nu se potrivește. Încearcă un cuvânt din nume sau din rezumat.',
  aboutProject: 'Despre acest proiect',
  aboutShort: 'Despre',
  workingIn: 'Lucrezi în {name}',
  noBriefHome:
    'Încă nu există rezumat. Spune într-un chat de aici ce presupune lucrarea; toate chaturile din proiect îl citesc primul.',
  tabAll: 'Toate',
  tabChats: 'Chaturi',
  tabResults: 'Rezultate',
  tabFiles: 'Fișiere',
  emptyChats: 'Încă nu există chaturi aici. Începe unul mai sus.',
  emptyResults: 'Încă nu s-a creat nimic aici. Ce creezi într-un chat de aici ajunge aici.',
  emptyFiles:
    'Încă nu există fișiere aici. Fișierele pe care le adaugi într-un chat de aici ajung aici.',
  showTabs: 'Afișează',
  newestShown: 'Aici sunt afișate cele mai noi {shown} din {count}.',
  nothingHereYet: 'Încă nimic aici.',
  homeEmptyHelp:
    'Chaturile pe care le începi mai sus ajung aici, la fel și fișierele pe care le adaugi și rezultatele pe care le creezi în ele.',
  shareWithPeopleDoingIt: 'Partajează cu cei care lucrează la asta',
  briefWrittenBy: '{version} · scris de {name}, {when}',
  briefChangedBy: '{version} · modificat de {name}, {when}',
  personWorksInIt: '{people} lucrează în el.',
  peopleWorkInIt: '{people} lucrează în el.',
  aboutUnavailable:
    'Acest proiect nu este disponibil. Poate a fost șters sau nu este partajat cu tine.',
  landedIn: 'În {name} · {access}',
  landedOnlyYou: 'Doar tu îl poți deschide',
  youWorkInIt: 'Tu lucrezi în el.',
  youAndPeopleWorkInIt: 'Tu și {people} lucrați în el.',
  landedCompanyCanOpen: 'Toată lumea de la {company} îl poate deschide',
  landedMembersCanOpen: 'Colegii selectați îl pot deschide',
  briefWrittenByYou: '{version} · scris de tine, {when}',
  briefChangedByYou: '{version} · modificat de tine, {when}',
  briefWrittenByFormer: '{version} · scris de un fost coleg, {when}',
  briefChangedByFormer: '{version} · modificat de un fost coleg, {when}',
  addedByFormer: 'adăugat de un fost coleg',
  formerColleagueLeadsIt: 'Un fost coleg îl coordonează.',
  projectLoadFailed: 'Proiectul nu a putut fi încărcat.',
  personCannotOpenWithout:
    '{people} nu poate deschide acest element, așa că în chat-urile sale de aici nu îl poate folosi.',
  peopleCannotOpenWithout:
    '{people} nu pot deschide acest element, așa că în chat-urile lor de aici nu îl pot folosi.',
};
const sk: Copy = {
  projects: 'Projekty',
  newProject: 'Nový projekt',
  searchProjects: 'Hľadať projekty',
  finished: 'Dokončené',
  people: 'Ľudia',
  skill: 'Zručnosť',
  noBrief: 'Zhrnutie zatiaľ nie je.',
  createProject: 'Vytvoriť projekt',
  knowledgePages: 'Stránky znalostí',
  searchPages: 'Hľadať stránky',
  formatting: 'Formátovanie',
  pageTitle: 'Názov stránky',
  suggestions: 'Návrhy',
  current: 'Aktuálne',
  agent: 'Agent',
  runs: 'Spustenia',
  goal: 'Cieľ',
  instructions: 'Pokyny',
  noRuns: 'Zatiaľ žiadne spustenia.',
  runNow: 'Spustiť teraz',
  schedule: 'Plán',
  editors: 'Editori',
  now: 'Teraz',
  moreFor: 'Viac pre {name}',
  brief: 'Zadanie',
  version: 'Verzia {count}',
  noBriefLong:
    'Zatiaľ bez zadania. V chate napíšte, čo je táto práca a aké pravidlá pre ňu platia.',
  changeInChat: 'Zmeniť v chate',
  everyChatFollows: 'Každý chat tu dodržiava',
  andReadsFirst: 'A najprv si prečíta',
  file: 'Súbor',
  knowledge: 'Znalosti',
  youLeadIt: 'Vediete ho.',
  personLeadsIt: '{name} ho vedie.',
  everyoneAtCanFind: 'Nájde ho každý v spoločnosti {company}.',
  shareWhenOthers: 'Zdieľajte ho, keď na ňom majú pracovať aj ostatní.',
  projectAccessNote:
    'Členstvo v projekte neotvára nič. Každá položka má vlastné prístupové práva a chaty tu fungujú ako osoba, ktorá ich začala.',
  project: 'Projekt',
  needsYou: 'Vyžaduje vašu pozornosť',
  review: 'Skontrolovať',
  inThisProject: 'V tomto projekte',
  deleteQuestion: 'Odstrániť {name}?',
  deleteDescription:
    'Odstráni sa iba projekt. Jeho chaty, súbory a výsledky zostanú ľuďom, ktorí ich vlastnia, na pôvodnom mieste.',
  deleteConfirm: 'Odstrániť {name}',
  projectDeleted: '{name} bol odstránený. Jeho chaty a práca zostávajú tam, kde boli.',
  couldntDelete: '{name} sa nepodarilo odstrániť.',
  itemOutSuccess: '{item} je mimo projektu {project}. Nič iné sa nezmenilo.',
  itemOutError: '{item} sa nepodarilo odstrániť z projektu {project}.',
  moveOutProject: 'Presunúť mimo projektu',
  takeOutProject: 'Odobrať z projektu',
  unavailableTitle: 'Tento projekt nie je k dispozícii',
  unavailableDescription:
    'Možno bol odstránený alebo s vami nie je zdieľaný. Nič v ňom sa pre vás nezmenilo.',
  allProjects: 'Všetky projekty',
  openingProject: 'Otvára sa projekt…',
  ended: 'Skončené',
  ends: 'Končí',
  yesterday: 'Včera',
  roleLead: 'Vedúci',
  roleCanEdit: 'Môže upravovať',
  roleCanUse: 'Môže používať',
  visibilityCompany: 'Všetci v spoločnosti {company}',
  visibilityMembers: 'Vybraní kolegovia',
  visibilityPrivate: 'Iba vy',
  kindApp: 'Aplikácia',
  kindDeck: 'Prezentácia',
  kindSheet: 'Tabuľka',
  kindChart: 'Graf',
  kindDashboard: 'Ovládací panel',
  kindReport: 'Správa',
  kindChat: 'Chat',
  kindFile: 'Súbor',
  kindMeeting: 'Stretnutie',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Vy',
  gettingAnswer: 'Získava sa odpoveď',
  gettingAnswerOther: '{name} získava odpoveď',
  addedByYou: 'pridané vami',
  addedByOther: 'pridané používateľom {name}',
  renameProjectDescription: 'Premenujte ho, zmeňte zadanie alebo dátum ukončenia',
  deleteProject: 'Odstrániť projekt',
  openToShare: 'Otvorte ho, aby ste ho mohli zdieľať',
  sharingSaved: 'Zdieľanie uložené. {name} sa s vami už nezdieľa.',
  onlyOwnerPrivate: 'Iba {name} ho môže nastaviť ako súkromný',
  add: 'Pridať',
  addTo: 'Pridať do {name}',
  addAnything: 'Všetko, čo môžete otvoriť. Má vlastný prístup: pridaním sem ho s nikým nezdieľate.',
  couldntAdd: 'Nepodarilo sa pridať {name}.',
  projectReadyChat:
    '{name} je pripravený a tento chat je v ňom. Kto môže otvoriť chat, sa nezmenilo.',
  projectReadyPrivate: '{name} je pripravený. Môžete ho otvoriť iba vy.',
  projectCreatedNotice:
    'Projekt {name} bol vytvorený. Všetko v ňom má vlastné prístupové oprávnenia.',
  latestAnswerYou: 'Dostávate odpoveď',
  latestAnswerOther: '{name} dostáva odpoveď',
  inProjectMove: 'V projekte {name}. Presuňte tento chat',
  notInProjectMove: 'Nie je v projekte. Presuňte tento chat',
  movedTo: 'Presunuté do',
  accessUnchanged: 'To, kto môže otvoriť tento chat, sa nezmenilo.',
  theProject: 'projektu',
  in: 'V',
  stopMakingProject: 'Prestať vytvárať nový projekt v tomto chate',
  searchYourWork: 'Prehľadať svoju prácu',
  searchDocuments: 'Hľadať dokumenty, súbory a schôdze…',
  yourWork: 'Vaša práca',
  looking: 'Hľadá sa…',
  nothingMatchesChat:
    'Nič nezodpovedá. Ak chcete pridať chat, otvorte ho a použite jeho tlačidlo v hlavičke.',
  typeToFind: 'Začnite písať a nájdite prácu, ktorú môžete otvoriť.',
  newProjectDraft: 'Nový projekt · Koncept {count} · Zatiaľ nevytvorené',
  projectCreatedOpen: 'Projekt vytvorený · Otvoriť',
  aNewProject: 'Nový projekt',
  draftIntro:
    'V chate povedzte, o čom je táto práca. Poneva tu pripraví projekt vrátane toho, čo doň pridať a s kým ho zdieľať. Nič sa nevytvorí, kým to nepotvrdíte.',
  draft: 'Koncept',
  projectCreatedAccess: 'Vytvorené. Každá položka si zachováva vlastný prístup.',
  changeInChatDraft: 'Čokoľvek zmeňte tak, že to poviete v chate.',
  chatOwnerCreate: 'Projekt môže vytvoriť iba osoba, ktorá vlastní tento chat.',
  open: 'Otvoriť',
  creating: 'Vytvára sa…',
  cannotOpenDraft:
    '{people} nemôžu otvoriť {title}, takže ich chaty tu by odpovedali bez toho. V chate povedzte, či máte požiadať vlastníka o zdieľanie, alebo to vynechať.',
  bringsIn: 'Pridáva {count}',
  thisChat: 'Tento chat',
  takenOutDraft: 'Vynechané v koncepte {count}',
  nothingYet: 'Zatiaľ nič. V chate uveďte, čo sem patrí.',
  leftOut: 'Vynechané: {items}.',
  whoCanUse: 'Kto ho môže používať',
  youLead: 'Vy, vedúci',
  beingInProject:
    'To, že je položka v projekte, neotvára prístup k ničomu. Každá položka si zachováva vlastný prístup.',
  onlyYouUntilShare: 'Zostáva iba pre vás, kým ho nezdieľate.',
  colour: 'Farba',
  sand: 'Piesková',
  green: 'Zelená',
  blue: 'Modrá',
  grey: 'Sivá',
  firstProject: 'Začnite svoj prvý projekt',
  firstProjectDescription:
    'Pomenujte ho a každý chat, ktorý v ňom začnete, si prečíta rovnaké zadanie. Pridajte prácu, ktorú už máte, a zdieľajte ju, keď na nej majú pracovať aj ostatní.',
  loadingProjects: 'Načítavajú sa projekty…',
  thisChatMoves: 'Tento chat sa presunie do projektu. To, kto ho môže otvoriť, sa nezmení.',
  whatIsWork: 'O čom je táto práca?',
  optional: 'Voliteľné',
  writeFromChat: 'Napísať z tohto chatu',
  briefPlaceholder: 'Na čo slúži, aké pravidlá treba dodržiavať a ktoré dátumy sú dôležité.',
  briefDraftHelp:
    'Každý chat v projekte si toto prečíta ako prvé. Možnosť „Napísať z tohto chatu“ požiada Ponevu, aby zadanie pripravila vedľa chatu; vy stále vyberiete možnosť Vytvoriť.',
  briefLaterHelp:
    'Každý chat v projekte si toto prečíta ako prvé. Neskôr to zmeňte tak, že o to požiadate v ľubovoľnom chate v projekte.',
  sendClearFirst:
    'Najprv odošlite alebo vymažte neodoslanú správu a prílohy, aby ste mohli napísať zadanie z tohto chatu.',
  createProjectError: 'Projekt sa nepodarilo vytvoriť. Skúste to znova.',
  onlyYouUntil: 'Iba vy, kým ho nezdieľate',
  whereChat: 'Kde sa tento chat nachádza',
  whereChatHelp:
    'Chat môže byť naraz iba v jednom projekte. Presunutím sa nezmení, kto ho môže otvoriť.',
  searchCreateProject: 'Vyhľadať alebo vytvoriť projekt',
  noProject: 'Žiadny projekt',
  inCompanyChats: 'Vo vašich chatoch v {company}',
  newProjectWithChat: 'Nový projekt s týmto chatom',
  newProjectNamedWithChat: 'Nový projekt „{name}“ s týmto chatom',
  makingProject: 'Vytvára sa nový projekt',
  moveToProject: 'Presunúť tento chat do {name}',
  chatInProject: 'Tento chat je v projekte {name}.',
  looksLikeWork: 'Vyzerá to ako práca pre {name}. Presunúť ho tam?',
  accessBriefNext:
    'To, kto ho môže otvoriť, sa nezmenilo. Od vašej ďalšej správy si prečíta zadanie projektu.',
  moveFailed: 'Nepodarilo sa ho presunúť. Skúste to znova alebo použite jeho tlačidlo v hlavičke.',
  accessBriefNextTypographic:
    'To, kto ho môže otvoriť, sa nezmení. Od vašej ďalšej správy si prečíta zadanie projektu.',
  openProject: 'Otvoriť projekt',
  move: 'Presunúť',
  movedOut: 'Presunuté mimo projektu. To, kto to môže otvoriť, sa nezmenilo.',
  chatLivesHere: 'Tento chat je teraz tu. To, kto ho môže otvoriť, sa nezmenilo.',
  addedTo: 'Pridané: {item} do {project}',
  addedAccess: 'Zachováva si vlastný prístup. Pridaním sem ho s nikým nezdieľate.',
  removedOut:
    '{item} je mimo projektu {project}. Zostáva tam, kde sa nachádza, a to, kto ho môže otvoriť, sa nezmenilo.',
  itIs: 'Je to',
  couldntMoveChat: 'Tento chat sa nepodarilo presunúť.',
  sharingCheckFailed:
    'Nepodarilo sa overiť, kto môže otvoriť položky, ktoré sa čítajú ako prvé. Pred zdieľaním tohto projektu skontrolujte ich prístup.',
  cannotOpenShare: '{people} nemôžu otvoriť {title}.',
  readsFirstShare:
    'Každý chat v tomto projekte si to prečíta ako prvé, takže ich chaty tu odpovedajú bez toho. Zdieľaním projektu sa to nezmení.',
  sharingSavedUnread: 'Zdieľanie bolo uložené. {name} sa práve nepodarilo znova načítať.',
  formerColleague: 'Bývalý kolega',
  madeInChatHere: 'vytvorené v chate tu',
  latestStarted: '{name} začal(a) {title}',
  latestStartedYou: 'Začali ste {title}',
  latestContinued: '{name} pokračoval(a) v {title}',
  latestContinuedYou: 'Pokračovali ste v {title}',
  latestMade: '{name} vytvoril(a) {title}',
  latestMadeYou: 'Vytvorili ste {title}',
  latestAdded: '{name} pridal(a) {title}',
  latestAddedYou: 'Pridali ste {title}',
  projectChipLives:
    'Tento chat patrí do projektu {name} a číta jeho zadanie. Presuniete ho z prvej časti hlavičky.',
  addExistingWork: 'Pridajte prácu, ktorú už máte',
  nameLabel: 'Názov',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} položka',
  itemsMany: 'Položky: {count}',
  itemsAllStillHere: '{items}, všetko je stále tu',
  projectsOverviewDescription:
    'Jedno miesto pre každú prácu. Pridaním niečoho do projektu sa nikdy nezmení, kto to môže otvoriť.',
  noProjectMatchesHint: 'Žiadny projekt nezodpovedá. Skúste slovo z názvu alebo zadania.',
  aboutProject: 'O tomto projekte',
  aboutShort: 'O projekte',
  workingIn: 'Pracujete v projekte {name}',
  noBriefHome:
    'Zatiaľ žiadne zadanie. Napíšte tu v chate, o akú prácu ide; každý chat v projekte ho číta ako prvé.',
  tabAll: 'Všetko',
  tabChats: 'Chaty',
  tabResults: 'Výsledky',
  tabFiles: 'Súbory',
  emptyChats: 'Zatiaľ tu nie sú žiadne chaty. Jeden začnite vyššie.',
  emptyResults: 'Zatiaľ tu nič nevzniklo. Čo vytvoríte v chate tu, sa zobrazí tu.',
  emptyFiles: 'Zatiaľ tu nie sú žiadne súbory. Súbory pridané v chate tu sa zobrazia tu.',
  showTabs: 'Zobraziť',
  newestShown: 'Zobrazuje sa {shown} najnovších z {count}.',
  nothingHereYet: 'Zatiaľ tu nič nie je.',
  homeEmptyHelp:
    'Chaty, ktoré začnete vyššie, sa zobrazia tu, rovnako ako súbory, ktoré pridáte, a výsledky, ktoré v nich vytvoríte.',
  shareWithPeopleDoingIt: 'Zdieľať s ľuďmi, ktorí na tom pracujú',
  briefWrittenBy: '{version} · autor: {name}, {when}',
  briefChangedBy: '{version} · zmena: {name}, {when}',
  personWorksInIt: '{people} v ňom pracuje.',
  peopleWorkInIt: '{people} v ňom pracujú.',
  aboutUnavailable:
    'Tento projekt nie je k dispozícii. Možno bol odstránený alebo nie je s vami zdieľaný.',
  landedIn: 'V projekte {name} · {access}',
  landedOnlyYou: 'Otvoriť ho môžete len vy',
  youWorkInIt: 'Pracujete v ňom.',
  youAndPeopleWorkInIt: 'Vy a {people} v ňom pracujete.',
  landedCompanyCanOpen: 'Všetci v spoločnosti {company} to môžu otvoriť',
  landedMembersCanOpen: 'Vybraní kolegovia to môžu otvoriť',
  briefWrittenByYou: '{version} · autor: vy, {when}',
  briefChangedByYou: '{version} · zmena: vy, {when}',
  briefWrittenByFormer: '{version} · autor: bývalý kolega, {when}',
  briefChangedByFormer: '{version} · zmena: bývalý kolega, {when}',
  addedByFormer: 'pridané bývalým kolegom',
  formerColleagueLeadsIt: 'Vedie ho bývalý kolega.',
  projectLoadFailed: 'Tento projekt sa nepodarilo načítať.',
  personCannotOpenWithout:
    '{people} to nemôže otvoriť, takže chaty tejto osoby tu budú odpovedať bez toho.',
  peopleCannotOpenWithout:
    '{people} to nemôžu otvoriť, takže ich chaty tu budú odpovedať bez toho.',
};
const sl: Copy = {
  projects: 'Projekti',
  newProject: 'Nov projekt',
  searchProjects: 'Išči projekte',
  finished: 'Dokončani',
  people: 'Ljudje',
  skill: 'Veščina',
  noBrief: 'Opisa še ni.',
  createProject: 'Ustvari projekt',
  knowledgePages: 'Strani znanja',
  searchPages: 'Išči strani',
  formatting: 'Oblikovanje',
  pageTitle: 'Naslov strani',
  suggestions: 'Predlogi',
  current: 'Trenutno',
  agent: 'Agent',
  runs: 'Zagoni',
  goal: 'Cilj',
  instructions: 'Navodila',
  noRuns: 'Zagonov še ni.',
  runNow: 'Zaženi zdaj',
  schedule: 'Razpored',
  editors: 'Uredniki',
  now: 'Zdaj',
  moreFor: 'Več za {name}',
  brief: 'Povzetek',
  version: 'Različica {count}',
  noBriefLong:
    'Povzetka še ni. V klepetu povej, za kaj gre pri tem delu in katera pravila veljajo zanj.',
  changeInChat: 'Spremeni v klepetu',
  everyChatFollows: 'Vsak klepet tukaj sledi',
  andReadsFirst: 'In najprej prebere',
  file: 'Datoteka',
  knowledge: 'Znanje',
  youLeadIt: 'Vodiš ga ti.',
  personLeadsIt: 'Vodi ga {name}.',
  everyoneAtCanFind: 'Vsi v {company} ga lahko najdejo.',
  shareWhenOthers: 'Deli ga, ko naj bi tukaj delali tudi drugi.',
  projectAccessNote:
    'Članstvo v projektu ne odpre ničesar. Vsak element ima svoj dostop, klepeti tukaj pa se izvajajo kot oseba, ki jih začne.',
  project: 'Projekt',
  needsYou: 'Potrebuje te',
  review: 'Pregled',
  inThisProject: 'V tem projektu',
  deleteQuestion: 'Izbrišem {name}?',
  deleteDescription:
    'Odstranjen bo samo projekt. Njegovi klepeti, datoteke in rezultati ostanejo pri osebah, ki jih imajo v lasti, na svojih prejšnjih mestih.',
  deleteConfirm: 'Izbriši {name}',
  projectDeleted: '{name} je izbrisan. Njegovi klepeti in delo ostanejo tam, kjer so bili.',
  couldntDelete: '{name} ni bilo mogoče izbrisati.',
  itemOutSuccess: '{item} je odstranjen iz projekta {project}. Nič drugega se ni spremenilo.',
  itemOutError: '{item} ni bilo mogoče odstraniti iz projekta {project}.',
  moveOutProject: 'Premakni iz projekta',
  takeOutProject: 'Odstrani iz projekta',
  unavailableTitle: 'Ta projekt ni na voljo',
  unavailableDescription:
    'Morda je bil izbrisan ali pa ni v skupni rabi s tabo. Zate se v njem ni nič spremenilo.',
  allProjects: 'Vsi projekti',
  openingProject: 'Odpiranje projekta…',
  ended: 'Končano',
  ends: 'Se konča',
  yesterday: 'Včeraj',
  roleLead: 'Vodja',
  roleCanEdit: 'Lahko ureja',
  roleCanUse: 'Lahko uporablja',
  visibilityCompany: 'Vsi v {company}',
  visibilityMembers: 'Izbrani sodelavci',
  visibilityPrivate: 'Samo ti',
  kindApp: 'Aplikacija',
  kindDeck: 'Predstavitev',
  kindSheet: 'Preglednica',
  kindChart: 'Grafikon',
  kindDashboard: 'Nadzorna plošča',
  kindReport: 'Poročilo',
  kindChat: 'Klepet',
  kindFile: 'Datoteka',
  kindMeeting: 'Sestanek',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Ti',
  gettingAnswer: 'Pridobivanje odgovora',
  gettingAnswerOther: '{name} pridobiva odgovor',
  addedByYou: 'dodano od tebe',
  addedByOther: 'dodano od {name}',
  renameProjectDescription: 'Preimenuj ga, spremeni povzetek ali datum konca',
  deleteProject: 'Izbriši projekt',
  openToShare: 'Odpri ga za skupno rabo',
  sharingSaved: 'Skupna raba je shranjena. {name} ni več v skupni rabi z vami.',
  onlyOwnerPrivate: 'Samo {name} ga lahko nastavi kot zasebnega',
  add: 'Dodaj',
  addTo: 'Dodaj v {name}',
  addAnything:
    'Vse, kar lahko odprete. Ohrani lastni dostop: če ga dodate sem, ga ne delite z nikomer.',
  couldntAdd: '{name} ni bilo mogoče dodati.',
  projectReadyChat:
    '{name} je pripravljen, ta klepet pa je v njem. Kdo lahko odpre ta klepet, se ni spremenilo.',
  projectReadyPrivate: '{name} je pripravljen. Odprete ga lahko samo vi.',
  projectCreatedNotice: '{name} je ustvarjen. Vse v njem ohrani lastne nastavitve dostopa.',
  latestAnswerYou: 'Prejemate odgovor',
  latestAnswerOther: '{name} prejema odgovor',
  inProjectMove: 'V {name}. Premakni ta klepet',
  notInProjectMove: 'Ni v projektu. Premakni ta klepet',
  movedTo: 'Premaknjeno v',
  accessUnchanged: 'Kdo lahko odpre ta klepet, se ni spremenilo.',
  theProject: 'projekt',
  in: 'V',
  stopMakingProject: 'Prenehaj ustvarjati nov projekt v tem klepetu',
  searchYourWork: 'Išči po svojem delu',
  searchDocuments: 'Išči po dokumentih, datotekah in sestankih …',
  yourWork: 'Vaše delo',
  looking: 'Iskanje …',
  nothingMatchesChat:
    'Nič se ne ujema. Če želite dodati klepet, ga odprite in uporabite njegovo možnost v glavi.',
  typeToFind: 'Vnesite besedilo za iskanje dela, ki ga lahko odprete.',
  newProjectDraft: 'Nov projekt · Osnutek {count} · Še ni ustvarjen',
  projectCreatedOpen: 'Projekt je ustvarjen · Odpri ga',
  aNewProject: 'Nov projekt',
  draftIntro:
    'V klepetu povejte, kaj je treba narediti. Poneva bo tukaj pripravila projekt ter navedla, kaj vključiti in s kom ga deliti. Nič se ne ustvari, dokler tega ne potrdite.',
  draft: 'Osnutek',
  projectCreatedAccess: 'Ustvarjeno. Vse v njem ohrani lastni dostop.',
  changeInChatDraft: 'Karkoli spremenite tako, da to poveste v klepetu.',
  chatOwnerCreate: 'Projekt lahko ustvari samo lastnik tega klepeta.',
  open: 'Odpri',
  creating: 'Ustvarjanje …',
  cannotOpenDraft:
    '{people} ne morejo odpreti {title}, zato bi njihovi klepeti tukaj odgovarjali brez tega. V klepetu povejte, ali naj prosimo njegovega lastnika za skupno rabo ali naj to izpustimo.',
  bringsIn: 'Vključi {count}',
  thisChat: 'Ta klepet',
  takenOutDraft: 'Odstranjeno v osnutku {count}',
  nothingYet: 'Zaenkrat nič. V klepetu navedite, kaj spada sem.',
  whoCanUse: 'Kdo ga lahko uporablja',
  youLead: 'Vi, vodja',
  beingInProject:
    'To, da je nekaj v projektu, ne odpre ničesar. Vsak element ohrani lastni dostop.',
  onlyYouUntilShare: 'Ostane samo za vas, dokler ga ne delite.',
  colour: 'Barva',
  sand: 'Peščena',
  green: 'Zelena',
  blue: 'Modra',
  grey: 'Siva',
  firstProject: 'Ustvarite svoj prvi projekt',
  firstProjectDescription:
    'Poimenujte ga in vsak klepet, ki ga začnete v njem, bo prebral ista navodila. Dodajte delo, ki ga že imate, in ga delite, ko naj v njem delajo tudi drugi.',
  loadingProjects: 'Nalaganje projektov …',
  thisChatMoves: 'Ta klepet bo premaknjen v projekt. Kdo ga lahko odpre, se ne bo spremenilo.',
  whatIsWork: 'Kaj je treba narediti?',
  optional: 'Izbirno',
  writeFromChat: 'Napiši iz tega klepeta',
  briefPlaceholder:
    'Čemu je namenjeno, katera pravila je treba upoštevati in kateri datumi so pomembni.',
  briefDraftHelp:
    'Vsak klepet v projektu to najprej prebere. Možnost »Napiši iz tega klepeta« pozove Ponevo, naj pripravi osnutek ob klepetu; vi še vedno izberete Ustvari.',
  briefLaterHelp:
    'Vsak klepet v projektu to najprej prebere. Pozneje to spremenite tako, da vprašate v katerem koli klepetu v projektu.',
  sendClearFirst:
    'Najprej pošljite ali izbrišite neposlano sporočilo in priloge, da lahko iz tega klepeta napišete opis.',
  createProjectError: 'Projekta ni bilo mogoče ustvariti. Poskusite znova.',
  onlyYouUntil: 'Samo za vas, dokler ga ne delite',
  whereChat: 'Kje je ta klepet',
  whereChatHelp:
    'Klepet je lahko hkrati v samo enem projektu. Če ga premaknete, se ne spremeni, kdo ga lahko odpre.',
  searchCreateProject: 'Poiščite ali ustvarite projekt',
  noProject: 'Brez projekta',
  inCompanyChats: 'V vaših klepetih pri {company}',
  newProjectWithChat: 'Nov projekt s tem klepetom',
  newProjectNamedWithChat: 'Nov projekt »{name}« s tem klepetom',
  makingProject: 'Ustvarjanje novega projekta',
  moveToProject: 'Premakni ta klepet v {name}',
  chatInProject: 'Ta klepet je v projektu {name}.',
  looksLikeWork: 'To je videti kot delo za {name}. Ga premaknete tja?',
  accessBriefNext:
    'Ni se spremenilo, kdo ga lahko odpre. Od vašega naslednjega sporočila naprej bo prebral opis projekta.',
  moveFailed: 'Premik ni uspel. Poskusite znova ali uporabite njegovo možnost v glavi.',
  accessBriefNextTypographic:
    'To, kdo ga lahko odpre, se ne spremeni. Od vašega naslednjega sporočila naprej bo prebral opis projekta.',
  openProject: 'Odpri projekt',
  move: 'Premakni',
  movedOut: 'Premaknjeno iz projekta. Ni se spremenilo, kdo lahko to odpre.',
  chatLivesHere: 'Ta klepet je zdaj tukaj. Ni se spremenilo, kdo ga lahko odpre.',
  addedTo: '{item} je dodan v {project}',
  addedAccess: 'Ohrani lastni dostop. Če ga dodate sem, ga ne delite z nikomer.',
  removedOut:
    '{item} je odstranjen iz {project}. Ostane tam, kjer je, in ni se spremenilo, kdo ga lahko odpre.',
  itIs: 'To je',
  couldntMoveChat: 'Tega klepeta ni bilo mogoče premakniti.',
  sharingCheckFailed:
    'Ni bilo mogoče preveriti, kdo lahko odpre elemente, ki se preberejo najprej. Preden projekt delite, preverite njihov dostop.',
  cannotOpenShare: '{people} ne morejo odpreti {title}.',
  readsFirstShare:
    'Vsak klepet v tem projektu to najprej prebere, zato njihovi klepeti tukaj odgovarjajo brez tega. Skupna raba projekta tega ne spremeni.',
  leftOut: 'Izpuščeno: {items}.',
  sharingSavedUnread:
    'Skupna raba je shranjena. Elementa {name} zdaj ni bilo mogoče znova prebrati.',
  formerColleague: 'Nekdanji sodelavec',
  madeInChatHere: 'ustvarjeno v klepetu tukaj',
  latestStarted: '{name} je začel(a) {title}',
  latestStartedYou: 'Začeli ste {title}',
  latestContinued: '{name} je nadaljeval(a) {title}',
  latestContinuedYou: 'Nadaljevali ste {title}',
  latestMade: '{name} je ustvaril(a) {title}',
  latestMadeYou: 'Ustvarili ste {title}',
  latestAdded: '{name} je dodal(a) {title}',
  latestAddedYou: 'Dodali ste {title}',
  projectChipLives:
    'Ta klepet živi v projektu {name} in bere njegov povzetek. Premaknete ga iz prvega dela glave.',
  addExistingWork: 'Dodajte delo, ki ga že imate',
  nameLabel: 'Ime',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} element',
  itemsMany: 'Elementi: {count}',
  itemsAllStillHere: '{items}, vse je še vedno tukaj',
  projectsOverviewDescription:
    'Eno mesto za vsako delo. Če nekaj dodate v projekt, se s tem nikoli ne spremeni, kdo lahko to odpre.',
  noProjectMatchesHint: 'Noben projekt se ne ujema. Poskusite z besedo iz imena ali povzetka.',
  aboutProject: 'O tem projektu',
  aboutShort: 'O projektu',
  workingIn: 'Delate v projektu {name}',
  noBriefHome:
    'Povzetka še ni. V klepetu tukaj povejte, za kakšno delo gre; vsak klepet v projektu ga prebere prvega.',
  tabAll: 'Vse',
  tabChats: 'Klepeti',
  tabResults: 'Rezultati',
  tabFiles: 'Datoteke',
  emptyChats: 'Tukaj še ni klepetov. Začnite enega zgoraj.',
  emptyResults: 'Tukaj še ni nastalo nič. Kar ustvarite v klepetu tukaj, se prikaže tukaj.',
  emptyFiles: 'Tukaj še ni datotek. Datoteke, ki jih dodate v klepetu tukaj, se prikažejo tukaj.',
  showTabs: 'Pokaži',
  newestShown: 'Tukaj je prikazanih najnovejših {shown} od {count}.',
  nothingHereYet: 'Tukaj še ni nič.',
  homeEmptyHelp:
    'Klepeti, ki jih začnete zgoraj, se prikažejo tukaj, prav tako datoteke, ki jih dodate, in rezultati, ki jih v njih ustvarite.',
  shareWithPeopleDoingIt: 'Deli z ljudmi, ki delajo na tem',
  briefWrittenBy: '{version} · avtor: {name}, {when}',
  briefChangedBy: '{version} · sprememba: {name}, {when}',
  personWorksInIt: '{people} dela v njem.',
  peopleWorkInIt: '{people} delajo v njem.',
  aboutUnavailable: 'Ta projekt ni na voljo. Morda je bil izbrisan ali ni deljen z vami.',
  landedIn: 'V projektu {name} · {access}',
  landedOnlyYou: 'Odprete ga lahko samo vi',
  youWorkInIt: 'Vi delate v njem.',
  youAndPeopleWorkInIt: 'Vi in {people} delate v njem.',
  landedCompanyCanOpen: 'Vsi v {company} ga lahko odprejo',
  landedMembersCanOpen: 'Izbrani sodelavci ga lahko odprejo',
  briefWrittenByYou: '{version} · avtor: vi, {when}',
  briefChangedByYou: '{version} · sprememba: vi, {when}',
  briefWrittenByFormer: '{version} · avtor: nekdanji sodelavec, {when}',
  briefChangedByFormer: '{version} · sprememba: nekdanji sodelavec, {when}',
  addedByFormer: 'dodano od nekdanjega sodelavca',
  formerColleagueLeadsIt: 'Vodi ga nekdanji sodelavec.',
  projectLoadFailed: 'Tega projekta ni bilo mogoče naložiti.',
  personCannotOpenWithout:
    '{people} tega ne more odpreti, zato klepeti te osebe tukaj odgovarjajo brez tega.',
  peopleCannotOpenWithout:
    '{people} tega ne morejo odpreti, zato njihovi klepeti tukaj odgovarjajo brez tega.',
};
const sv: Copy = {
  projects: 'Projekt',
  newProject: 'Nytt projekt',
  searchProjects: 'Sök projekt',
  finished: 'Avslutade',
  people: 'Personer',
  skill: 'Färdighet',
  noBrief: 'Ingen brief ännu.',
  createProject: 'Skapa projekt',
  knowledgePages: 'Kunskapssidor',
  searchPages: 'Sök sidor',
  formatting: 'Formatering',
  pageTitle: 'Sidans titel',
  suggestions: 'Förslag',
  current: 'Aktuell',
  agent: 'Agent',
  runs: 'Körningar',
  goal: 'Mål',
  instructions: 'Instruktioner',
  noRuns: 'Inga körningar ännu.',
  runNow: 'Kör nu',
  schedule: 'Schema',
  editors: 'Redaktörer',
  now: 'Nu',
  moreFor: 'Mer för {name}',
  brief: 'Beskrivning',
  version: 'Version {count}',
  noBriefLong:
    'Ingen beskrivning än. Säg i en chatt vad det här arbetet gäller och vilka regler som gäller för det.',
  changeInChat: 'Ändra i chatten',
  everyChatFollows: 'Varje chatt här följer',
  andReadsFirst: 'Och läser först',
  file: 'Fil',
  knowledge: 'Kunskap',
  youLeadIt: 'Du leder det.',
  personLeadsIt: '{name} leder det.',
  everyoneAtCanFind: 'Alla på {company} kan hitta det.',
  shareWhenOthers: 'Dela det när andra ska arbeta här.',
  projectAccessNote:
    'Att vara med i projektet ger inte åtkomst till något. Varje objekt har sin egen åtkomst, och chattar här körs som den person som startar dem.',
  project: 'Projekt',
  needsYou: 'Behöver dig',
  review: 'Granska',
  inThisProject: 'I det här projektet',
  deleteQuestion: 'Ta bort {name}?',
  deleteDescription:
    'Bara projektet försvinner. Dess chattar, filer och resultat finns kvar hos personerna som äger dem, där de fanns tidigare.',
  deleteConfirm: 'Ta bort {name}',
  projectDeleted: '{name} har tagits bort. Dess chattar och arbete finns kvar där de var.',
  couldntDelete: 'Det gick inte att ta bort {name}.',
  itemOutSuccess: '{item} har tagits bort från {project}. Inget annat ändrades.',
  itemOutError: 'Det gick inte att ta bort {item} från {project}.',
  moveOutProject: 'Flytta ut ur projektet',
  takeOutProject: 'Ta bort från projektet',
  unavailableTitle: 'Det här projektet är inte tillgängligt',
  unavailableDescription:
    'Det kan ha tagits bort eller så har det inte delats med dig. Inget i det ändrades för dig.',
  allProjects: 'Alla projekt',
  openingProject: 'Öppnar projektet…',
  ended: 'Avslutat',
  ends: 'Slutar',
  yesterday: 'I går',
  roleLead: 'Ansvarig',
  roleCanEdit: 'Kan redigera',
  roleCanUse: 'Kan använda',
  visibilityCompany: 'Alla på {company}',
  visibilityMembers: 'Valda kollegor',
  visibilityPrivate: 'Bara du',
  kindApp: 'App',
  kindDeck: 'Presentation',
  kindSheet: 'Kalkylark',
  kindChart: 'Diagram',
  kindDashboard: 'Instrumentpanel',
  kindReport: 'Rapport',
  kindChat: 'Chatt',
  kindFile: 'Fil',
  kindMeeting: 'Möte',
  kindAgent: 'Agent',
  kindDocument: 'Dokument',
  you: 'Du',
  gettingAnswer: 'Hämtar ett svar',
  gettingAnswerOther: '{name} hämtar ett svar',
  addedByYou: 'tillagd av dig',
  addedByOther: 'tillagd av {name}',
  renameProjectDescription: 'Byt namn, ändra beskrivningen eller slutdatumet',
  deleteProject: 'Ta bort projekt',
  openToShare: 'Öppna det för att dela',
  sharingSaved: 'Delningen har sparats. {name} delas inte längre med dig.',
  onlyOwnerPrivate: 'Endast {name} kan göra det privat',
  add: 'Lägg till',
  addTo: 'Lägg till i {name}',
  addAnything:
    'Allt du kan öppna. Det behåller sin egen åtkomst: att lägga till det här delar det inte med någon.',
  couldntAdd: 'Det gick inte att lägga till {name}.',
  projectReadyChat:
    '{name} är redo, och den här chatten finns i det. Det har inte ändrats vem som kan öppna chatten.',
  projectReadyPrivate: '{name} är redo. Det är bara du som kan öppna det.',
  projectCreatedNotice: '{name} har skapats. Allt i det har sina egna åtkomstinställningar.',
  latestAnswerYou: 'Du håller på att få ett svar',
  latestAnswerOther: '{name} håller på att få ett svar',
  inProjectMove: 'I {name}. Flytta den här chatten',
  notInProjectMove: 'Inte i ett projekt. Flytta den här chatten',
  movedTo: 'Flyttad till',
  accessUnchanged: 'Vem som kan öppna den här chatten har inte ändrats.',
  theProject: 'projektet',
  in: 'I',
  stopMakingProject: 'Sluta skapa ett nytt projekt i den här chatten',
  searchYourWork: 'Sök i ditt arbete',
  searchDocuments: 'Sök i dokument, filer och möten…',
  yourWork: 'Ditt arbete',
  looking: 'Söker…',
  nothingMatchesChat:
    'Inget matchar. Om du vill ta med en chatt öppnar du den och använder dess plats i sidhuvudet.',
  typeToFind: 'Skriv för att hitta arbete som du kan öppna.',
  newProjectDraft: 'Nytt projekt · Utkast {count} · Inte skapat ännu',
  projectCreatedOpen: 'Projektet har skapats · Öppna det',
  aNewProject: 'Ett nytt projekt',
  draftIntro:
    'Säg i chatten vad arbetet gäller. Poneva skapar ett utkast till projektet här, med vad som ska tas med och vem det ska delas med. Inget skapas förrän du säger till.',
  draft: 'Utkast',
  projectCreatedAccess: 'Skapat. Allt i det behåller sin egen åtkomst.',
  changeInChatDraft: 'Ändra vad som helst genom att säga till i chatten.',
  chatOwnerCreate: 'Det är bara personen som äger den här chatten som kan skapa det.',
  open: 'Öppna',
  creating: 'Skapar…',
  cannotOpenDraft:
    '{people} kan inte öppna {title}, så deras chattar här skulle svara utan det. Säg i chatten om ägaren ska ombes att dela det eller om det ska lämnas utanför.',
  bringsIn: 'Tar med {count}',
  thisChat: 'Den här chatten',
  takenOutDraft: 'Borttagen i utkast {count}',
  nothingYet: 'Ingenting ännu. Ange i chatten vad som hör hemma här.',
  leftOut: 'Lämnas utanför: {items}.',
  whoCanUse: 'Vem kan använda det',
  youLead: 'Du, ansvarig',
  beingInProject: 'Att vara med i projektet öppnar inget. Varje objekt behåller sin egen åtkomst.',
  onlyYouUntilShare: 'Det är endast synligt för dig tills du delar det.',
  colour: 'Färg',
  sand: 'Sand',
  green: 'Grön',
  blue: 'Blå',
  grey: 'Grå',
  firstProject: 'Starta ditt första projekt',
  firstProjectDescription:
    'Ge det ett namn, så läser varje chatt du startar där samma beskrivning. Ta med arbete du redan har och dela det när andra ska arbeta där.',
  loadingProjects: 'Läser in projekt…',
  thisChatMoves: 'Den här chatten flyttas till projektet. Det ändrar inte vem som kan öppna den.',
  whatIsWork: 'Vad gäller arbetet?',
  optional: 'Valfritt',
  writeFromChat: 'Skriv från den här chatten',
  briefPlaceholder: 'Vad det gäller, vilka regler som ska följas och vilka datum som är viktiga.',
  briefDraftHelp:
    'Varje chatt i projektet läser detta först. Med Skriv från den här chatten ber du Poneva skapa ett utkast bredvid chatten; du väljer fortfarande Skapa.',
  briefLaterHelp:
    'Varje chatt i projektet läser detta först. Ändra det senare genom att fråga i valfri chatt där.',
  sendClearFirst:
    'Skicka eller rensa ditt oskickade meddelande och dina bilagor först för att skriva beskrivningen från den här chatten.',
  createProjectError: 'Det gick inte att skapa projektet. Försök igen.',
  onlyYouUntil: 'Endast synligt för dig tills du delar det',
  whereChat: 'Var den här chatten finns',
  whereChatHelp:
    'En chatt kan bara finnas i ett projekt åt gången. Att flytta den ändrar aldrig vem som kan öppna den.',
  searchCreateProject: 'Sök efter eller skapa ett projekt',
  noProject: 'Inget projekt',
  inCompanyChats: 'I dina chattar hos {company}',
  newProjectWithChat: 'Nytt projekt med den här chatten',
  newProjectNamedWithChat: 'Nytt projekt ”{name}” med den här chatten',
  makingProject: 'Skapar ett nytt projekt',
  moveToProject: 'Flytta den här chatten till {name}',
  chatInProject: 'Den här chatten finns i {name}.',
  looksLikeWork: 'Det här ser ut som arbete för {name}. Flytta det dit?',
  accessBriefNext:
    'Det har inte ändrats vem som kan öppna det. Från och med ditt nästa meddelande läser chatten projektets beskrivning.',
  moveFailed: 'Det gick inte att flytta den. Försök igen eller använd dess plats i sidhuvudet.',
  accessBriefNextTypographic:
    'Det ändras inte vem som kan öppna det. Från och med ditt nästa meddelande läser chatten projektets beskrivning.',
  openProject: 'Öppna projekt',
  move: 'Flytta',
  movedOut: 'Flyttad ut ur projektet. Det har inte ändrats vem som kan öppna den.',
  chatLivesHere: 'Den här chatten finns här nu. Det har inte ändrats vem som kan öppna den.',
  addedTo: 'Lade till {item} i {project}',
  addedAccess: 'Det behåller sin egen åtkomst. Att lägga till det här delar det inte med någon.',
  removedOut:
    '{item} har tagits bort från {project}. Det finns kvar där det hör hemma, och det har inte ändrats vem som kan öppna det.',
  itIs: 'Det är',
  couldntMoveChat: 'Det gick inte att flytta den här chatten.',
  sharingCheckFailed:
    'Det gick inte att kontrollera vem som kan öppna objekten som läses först. Kontrollera deras åtkomst innan du delar projektet.',
  cannotOpenShare: '{people} kan inte öppna {title}.',
  readsFirstShare:
    'Varje chatt i det här projektet läser det först, så deras chattar här svarar utan det. Att dela projektet ändrar inte det.',
  sharingSavedUnread: 'Delningen sparades. {name} gick inte att läsa in igen just nu.',
  formerColleague: 'En tidigare kollega',
  madeInChatHere: 'gjord i en chatt här',
  latestStarted: '{name} startade {title}',
  latestStartedYou: 'Du startade {title}',
  latestContinued: '{name} fortsatte {title}',
  latestContinuedYou: 'Du fortsatte {title}',
  latestMade: '{name} gjorde {title}',
  latestMadeYou: 'Du gjorde {title}',
  latestAdded: '{name} lade till {title}',
  latestAddedYou: 'Du lade till {title}',
  projectChipLives:
    'Den här chatten hör till {name} och läser projektets beskrivning. Flytta den från första delen av rubriken.',
  addExistingWork: 'Lägg till arbete du redan har',
  nameLabel: 'Namn',
  projectNameExample: 'Black Friday 2026',
  itemsOne: '{count} objekt',
  itemsMany: '{count} objekt',
  itemsAllStillHere: '{items}, alla kvar',
  projectsOverviewDescription:
    'En plats för varje arbetsuppgift. Att lägga något i ett projekt ändrar aldrig vem som kan öppna det.',
  noProjectMatchesHint: 'Inget projekt matchar. Prova ett ord från namnet eller beskrivningen.',
  aboutProject: 'Om det här projektet',
  aboutShort: 'Om',
  workingIn: 'Arbetar i {name}',
  noBriefHome:
    'Ingen beskrivning än. Skriv i en chatt här vad arbetet gäller; varje chatt i projektet läser den först.',
  tabAll: 'Alla',
  tabChats: 'Chattar',
  tabResults: 'Resultat',
  tabFiles: 'Filer',
  emptyChats: 'Inga chattar här än. Starta en ovan.',
  emptyResults: 'Inget gjort här än. Det du gör i en chatt här hamnar här.',
  emptyFiles: 'Inga filer här än. Filer du lägger till i en chatt här hamnar här.',
  showTabs: 'Visa',
  newestShown: 'De {shown} senaste av {count} visas här.',
  nothingHereYet: 'Inget här än.',
  homeEmptyHelp:
    'Chattar du startar ovan hamnar här, och det gör även filerna du lägger till och resultaten du gör i dem.',
  shareWithPeopleDoingIt: 'Dela med dem som gör arbetet',
  briefWrittenBy: '{version} · skriven av {name}, {when}',
  briefChangedBy: '{version} · ändrad av {name}, {when}',
  personWorksInIt: '{people} arbetar i det.',
  peopleWorkInIt: '{people} arbetar i det.',
  aboutUnavailable:
    'Det här projektet är inte tillgängligt. Det kan ha tagits bort, eller så är det inte delat med dig.',
  landedIn: 'I {name} · {access}',
  landedOnlyYou: 'Bara du kan öppna det',
  youWorkInIt: 'Du arbetar i det.',
  youAndPeopleWorkInIt: 'Du och {people} arbetar i det.',
  landedCompanyCanOpen: 'Alla på {company} kan öppna det',
  landedMembersCanOpen: 'Valda kollegor kan öppna det',
  briefWrittenByYou: '{version} · skriven av dig, {when}',
  briefChangedByYou: '{version} · ändrad av dig, {when}',
  briefWrittenByFormer: '{version} · skriven av en tidigare kollega, {when}',
  briefChangedByFormer: '{version} · ändrad av en tidigare kollega, {when}',
  addedByFormer: 'tillagd av en tidigare kollega',
  formerColleagueLeadsIt: 'En tidigare kollega leder det.',
  projectLoadFailed: 'Projektet kunde inte läsas in.',
  personCannotOpenWithout:
    '{people} kan inte öppna detta, så personens chattar här svarar utan det.',
  peopleCannotOpenWithout: '{people} kan inte öppna detta, så deras chattar här svarar utan det.',
};

const copy: NamespaceCatalog<keyof typeof en> = {
  en,
  bg,
  cs,
  da,
  de,
  el,
  es,
  et,
  fi,
  fr,
  ga,
  hr,
  hu,
  it,
  lt,
  lv,
  mt,
  nl,
  pl,
  pt,
  ro,
  sk,
  sl,
  sv,
};
export default copy;
